/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/compat get default export */
/******/ (() => {
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = (module) => {
/******/ 		var getter = module && module.__esModule ?
/******/ 			() => (module['default']) :
/******/ 			() => (module);
/******/ 		__webpack_require__.d(getter, { a: getter });
/******/ 		return getter;
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/******/ /* webpack/runtime/make namespace object */
/******/ (() => {
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  zn9: () => (/* reexport */ Lightbox_ANIMATION_DURATION),
  xG4: () => (/* reexport */ AppBar_AppBar),
  CVn: () => (/* reexport */ AriaLiveAttributes),
  Ehc: () => (/* reexport */ Arrow),
  MUU: () => (/* reexport */ ArticleColors),
  JFs: () => (/* reexport */ ArticleFontWeights),
  WnP: () => (/* reexport */ ArticleSizeVariants),
  LYm: () => (/* reexport */ ArticleSizes),
  L6R: () => (/* reexport */ ArticleStyles),
  aPt: () => (/* reexport */ ArticleTextVariants),
  dnp: () => (/* reexport */ ArticleWeights),
  zRX: () => (/* reexport */ AsyncModal_AsyncModal),
  eJh: () => (/* reexport */ Back),
  cgf: () => (/* reexport */ Behavior),
  t6b: () => (/* reexport */ Blob),
  Bld: () => (/* reexport */ BodyColors),
  kc3: () => (/* reexport */ BodyFontWeights),
  by9: () => (/* reexport */ BodySizeVariants),
  coK: () => (/* reexport */ BodySizes),
  ChY: () => (/* reexport */ BodyStyles),
  wrz: () => (/* reexport */ BodyTextVariants),
  w1F: () => (/* reexport */ BodyWeights),
  rZ0: () => (/* reexport */ Bolt),
  Rkq: () => (/* reexport */ BorderLabel_BorderLabel),
  KN4: () => (/* reexport */ BowlSteaming),
  OoM: () => (/* reexport */ Breadcrumbs_Breadcrumbs),
  zxk: () => (/* reexport */ Button_Button),
  cTN: () => (/* reexport */ ButtonVariants),
  faS: () => (/* reexport */ Calendar),
  Zbd: () => (/* reexport */ Card_Card),
  ATA: () => (/* reexport */ CardCvc),
  imh: () => (/* reexport */ CardExpiration),
  izk: () => (/* reexport */ CardHTMLElements),
  ZQe: () => (/* reexport */ CardNumber_CardNumber),
  Fjk: () => (/* reexport */ Caret),
  lr9: () => (/* reexport */ Carousel_Carousel),
  d$M: () => (/* reexport */ CarouselItem_CarouselItem),
  R0Z: () => (/* reexport */ Carrot),
  JrY: () => (/* reexport */ Check),
  fU8: () => (/* reexport */ CheckCircle),
  XZJ: () => (/* reexport */ Checkbox_Checkbox),
  Zn_: () => (/* reexport */ CheckboxView),
  Tt3: () => (/* reexport */ Chevron),
  Cdc: () => (/* reexport */ Circle),
  Bjq: () => (/* reexport */ CircleAlert),
  liM: () => (/* reexport */ CircleCross),
  LSb: () => (/* reexport */ CircleFill),
  XWL: () => (/* reexport */ CircleMinus),
  Gq5: () => (/* reexport */ CirclePlus),
  TUt: () => (/* reexport */ Clipboard),
  SUY: () => (/* reexport */ Clock),
  x8P: () => (/* reexport */ Close),
  PZ7: () => (/* reexport */ CloseButton_CloseButton),
  Zqw: () => (/* reexport */ ContentReveal),
  OE3: () => (/* reexport */ ContentRevealAnimations),
  ufE: () => (/* reexport */ ContentWidth_ContentWidth),
  HDb: () => (/* reexport */ ContentWidthAlignment),
  anL: () => (/* reexport */ ContentWidth),
  izJ: () => (/* reexport */ Divider_Divider),
  B_z: () => (/* reexport */ DividerColors),
  FCg: () => (/* reexport */ DividerOrientations),
  mF8: () => (/* reexport */ Doctor),
  $6d: () => (/* reexport */ DogFood),
  hYT: () => (/* reexport */ ESCAPE),
  Dkg: () => (/* reexport */ ElementStates),
  _5T: () => (/* reexport */ ElementsProvider),
  s1S: () => (/* reexport */ Facebook),
  NDf: () => (/* reexport */ ForkSpoon),
  NIc: () => (/* reexport */ FormControl_FormControl),
  riA: () => (/* reexport */ Gallery_Gallery),
  Wx4: () => (/* reexport */ GalleryModes),
  T5p: () => (/* reexport */ GridContainer_GridContainer),
  aH1: () => (/* reexport */ GridContainerBreakpoints),
  kqm: () => (/* reexport */ GridContainerHTMLElements),
  tYz: () => (/* reexport */ HeadingColors),
  o0: () => (/* reexport */ HeadingFontWeights),
  ton: () => (/* reexport */ HeadingSizeVariants),
  vwx: () => (/* reexport */ HeadingSizes),
  Ewq: () => (/* reexport */ HeadingStyles),
  MyD: () => (/* reexport */ HeadingTextVariants),
  QDz: () => (/* reexport */ HeadingWeights),
  Xdw: () => (/* reexport */ Heart),
  mqL: () => (/* reexport */ HeartOutline),
  VMD: () => (/* reexport */ Hero_Hero),
  hM8: () => (/* reexport */ HoImport),
  X9i: () => (/* reexport */ HorizontalNavigation_HorizontalNavigation),
  EWW: () => (/* reexport */ HorizontalNavigationItem_HorizontalNavigationItem),
  Nt3: () => (/* reexport */ IconPropTypes),
  JFW: () => (/* reexport */ IndexButton_IndexButton),
  daM: () => (/* reexport */ Information),
  IIB: () => (/* reexport */ Input_Input),
  amK: () => (/* reexport */ InputComponent),
  YlX: () => (/* reexport */ LabeledSelector_LabeledSelector),
  B3Q: () => (/* reexport */ Leaf),
  eyg: () => (/* reexport */ Lightbox_Lightbox),
  rUS: () => (/* reexport */ Link_Link),
  z4R: () => (/* reexport */ LinkModes),
  CTN: () => (/* reexport */ LinkVariants),
  H27: () => (/* reexport */ ListSelect_ListSelect),
  fmD: () => (/* reexport */ ListSelectOption_ListSelectOption),
  IBy: () => (/* reexport */ ListSelectOptionComponent),
  xbP: () => (/* reexport */ LiveMessage_LiveMessage),
  HEZ: () => (/* reexport */ Lock),
  TRl: () => (/* reexport */ Logo_Logo),
  MvK: () => (/* reexport */ LogoModes),
  Mh9: () => (/* reexport */ Mail),
  WF_: () => (/* reexport */ Minus),
  u_l: () => (/* reexport */ Modal_Modal),
  nlv: () => (/* reexport */ Modes),
  W_F: () => (/* reexport */ Navigation),
  Wti: () => (/* reexport */ PREFERS_REDUCED_MOTION_QUERY),
  SSe: () => (/* reexport */ Parcel),
  shV: () => (/* reexport */ Play),
  v37: () => (/* reexport */ Plus),
  Y8K: () => (/* reexport */ Radio_Radio),
  gFx: () => (/* reexport */ RadioView),
  NOA: () => (/* reexport */ Refund),
  lzW: () => (/* reexport */ ResponsiveText),
  MiT: () => (/* reexport */ ResponsiveTextVariants),
  ahL: () => (/* reexport */ RichSelector_RichSelector),
  aBh: () => (/* reexport */ RichSelectorGroup_RichSelectorGroup),
  Ciz: () => (/* reexport */ Scale),
  a_G: () => (/* reexport */ ScrollSnap_ScrollSnap),
  Xwg: () => (/* reexport */ ScrollSnapComponent),
  PhF: () => (/* reexport */ Select_Select),
  Qfc: () => (/* reexport */ Selector_Selector),
  pdy: () => (/* reexport */ SelectorGroup_SelectorGroup),
  n19: () => (/* reexport */ SlideShow_SlideShow),
  bK0: () => (/* reexport */ Square),
  uX1: () => (/* reexport */ SquareFill),
  Ex: () => (/* reexport */ StandOnScale),
  Uxw: () => (/* reexport */ Star),
  GPN: () => (/* reexport */ StripeElement),
  vwl: () => (/* reexport */ StripeProvider),
  xvT: () => (/* reexport */ Text_Text),
  Kx8: () => (/* reexport */ TextArea_TextArea),
  U5e: () => (/* reexport */ TextAreaComponent),
  _T: () => (/* reexport */ Text_Text),
  i$g: () => (/* reexport */ TextVariants),
  qOL: () => (/* reexport */ TextVariants),
  VWW: () => (/* reexport */ ToastProvider),
  Tyr: () => (/* reexport */ ToastRenderer_ToastRenderer),
  ua7: () => (/* reexport */ Tooltip_Tooltip),
  uvY: () => (/* reexport */ TooltipModes),
  asY: () => (/* reexport */ TooltipPositions),
  _DY: () => (/* reexport */ Truck),
  tLe: () => (/* reexport */ Twitter),
  Yky: () => (/* reexport */ Types),
  orV: () => (/* reexport */ Vegetable),
  ORm: () => (/* reexport */ VerticalNavigation_VerticalNavigation),
  Y24: () => (/* reexport */ article),
  gKo: () => (/* reexport */ articleStyles),
  d1Q: () => (/* reexport */ body),
  EtW: () => (/* reexport */ bodyStyles),
  KmX: () => (/* reexport */ browserOnly),
  qJJ: () => (/* reexport */ getButtonDesign_getButtonDesign),
  X2c: () => (/* reexport */ getCheckboxDesign_getCheckboxDesign),
  ri4: () => (/* reexport */ getLineThroughDesign_getLineThroughDesign),
  UEi: () => (/* reexport */ getLinkDesign_getLinkDesign),
  ilL: () => (/* reexport */ getModalDesign_getModalDesign),
  tJS: () => (/* reexport */ getNonWaveDesign),
  QqB: () => (/* reexport */ getPreferredScrollBehavior),
  VUO: () => (/* reexport */ getRadioDesign_getRadioDesign),
  GlN: () => (/* reexport */ getWaveDesign),
  nPj: () => (/* reexport */ heading),
  $BV: () => (/* reexport */ headingStyles),
  E2g: () => (/* reexport */ isAnchorLink),
  b_w: () => (/* reexport */ polyfillSmoothScroll),
  RS$: () => (/* reexport */ useCreateToken),
  XDk: () => (/* reexport */ useElementState),
  lqB: () => (/* reexport */ useElements),
  pJl: () => (/* reexport */ useHtmlElement),
  sxs: () => (/* reexport */ useIntersection),
  LIc: () => (/* reexport */ useIsomorphicLayoutEffect),
  DlW: () => (/* reexport */ useLightboxControl),
  OyM: () => (/* reexport */ useSafeOptions),
  LAe: () => (/* reexport */ useSlideShow),
  MDn: () => (/* reexport */ useStripe),
  pmc: () => (/* reexport */ useToast),
  cJl: () => (/* reexport */ useToastDialog),
  Oer: () => (/* reexport */ withRef),
  pum: () => (/* reexport */ withTFDProps)
});

// NAMESPACE OBJECT: ./src/typography/index.ts
var typography_namespaceObject = {};
__webpack_require__.r(typography_namespaceObject);
__webpack_require__.d(typography_namespaceObject, {
  ArticleColors: () => (ArticleColors),
  ArticleFontWeights: () => (ArticleFontWeights),
  ArticleSizeVariants: () => (ArticleSizeVariants),
  ArticleSizes: () => (ArticleSizes),
  ArticleStyles: () => (ArticleStyles),
  ArticleWeights: () => (ArticleWeights),
  BodyColors: () => (BodyColors),
  BodyFontWeights: () => (BodyFontWeights),
  BodySizeVariants: () => (BodySizeVariants),
  BodySizes: () => (BodySizes),
  BodyStyles: () => (BodyStyles),
  BodyWeights: () => (BodyWeights),
  HeadingColors: () => (HeadingColors),
  HeadingFontWeights: () => (HeadingFontWeights),
  HeadingSizeVariants: () => (HeadingSizeVariants),
  HeadingSizes: () => (HeadingSizes),
  HeadingStyles: () => (HeadingStyles),
  HeadingWeights: () => (HeadingWeights),
  article: () => (article),
  articleStyles: () => (articleStyles),
  body: () => (body),
  bodyStyles: () => (bodyStyles),
  heading: () => (heading),
  headingStyles: () => (headingStyles)
});

;// CONCATENATED MODULE: ./src/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const base = ({});
;// CONCATENATED MODULE: external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// CONCATENATED MODULE: ./src/typography/Typography.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

var Typography = /*#__PURE__*/ function() {
    "use strict";
    function Typography(cssModules, props) {
        _class_call_check(this, Typography);
        _define_property(this, "props", void 0);
        _define_property(this, "cssModules", void 0);
        this.props = props;
        this.cssModules = cssModules;
    }
    _create_class(Typography, [
        {
            key: "className",
            get: function get() {
                return this.toString();
            }
        },
        {
            /**
   * Return a new typography object that merges the current and next typographic
   * properties.
   */ key: "create",
            value: function create(props) {
                return new Typography(this.cssModules, Object.assign({}, this.props, props));
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font color.
   */ key: "color",
            value: function color(nextColor) {
                var change = {
                    color: nextColor
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font size.
   */ key: "size",
            value: function size(nextSize) {
                var change = {
                    size: nextSize
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font weight.
   */ key: "weight",
            value: function weight(nextWeight) {
                var change = {
                    weight: nextWeight
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with a
   * font style.
   */ key: "fontStyle",
            value: function fontStyle(nextStyle) {
                var change = {
                    fontStyle: nextStyle
                };
                return this.create(change);
            }
        },
        {
            /**
   * Return a new typography object that merges the current properties with the
   * font weight of `bold`.
   */ key: "bold",
            value: function bold() {
                return this.weight("bold");
            }
        },
        {
            /**
   * Return a single class name that matches a given typographic property with
   * the class names provided by this object's css modules.
   */ key: "getClassName",
            value: function getClassName(prop, className) {
                if (typeof className === "undefined") {
                    return;
                }
                return this.cssModules[prop][className];
            }
        },
        {
            /**
   * Return a string value of css class names for the appropriate typographic
   * properties that have been applied to this object.
   */ key: "toString",
            value: function toString() {
                var _this_props = this.props, color = _this_props.color, size = _this_props.size, weight = _this_props.weight, fontStyle = _this_props.fontStyle;
                return external_classnames_default().apply(void 0, _to_consumable_array(Object.values(this.cssModules.base)).concat([
                    this.getClassName("colors", color),
                    this.getClassName("sizes", "size-".concat(size !== null && size !== void 0 ? size : "undefined")),
                    this.getClassName("weights", weight),
                    this.getClassName("fontStyles", fontStyle)
                ]));
            }
        }
    ]);
    return Typography;
}();

;// CONCATENATED MODULE: ./src/typography/body/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const colors = ({"blueberry-2":"HuWVIw","blueberry2":"HuWVIw","carrot-2":"qhaiFZ","carrot2":"qhaiFZ","carrot-3":"phBiB0","carrot3":"phBiB0","charcoal-1":"ABZeDk","charcoal1":"ABZeDk","charcoal-2":"DXtob_","charcoal2":"DXtob_","charcoal-3":"dwonWt","charcoal3":"dwonWt","kale-2":"z6o6vK","kale2":"z6o6vK","white":"MuueZ1"});
;// CONCATENATED MODULE: ./src/typography/body/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const fontStyles = ({"normal":"UTEK_m","italic":"GETg_B"});
;// CONCATENATED MODULE: ./src/typography/body/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const sizes = ({"size-21":"w5Gigb","size21":"w5Gigb","size-16":"Onrt7M","size16":"Onrt7M","size-12":"tNalHK","size12":"tNalHK","size-1":"JxOyrS","size1":"JxOyrS","size-2":"lPXkrj","size2":"lPXkrj","size-3":"aLJRdI","size3":"aLJRdI"});
;// CONCATENATED MODULE: ./src/typography/body/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_base = ({"family":"MxSV6V"});
;// CONCATENATED MODULE: ./src/typography/body/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const weights = ({"normal":"kP01rb","roman":"wXaB35","bold":"I7NmKh"});
;// CONCATENATED MODULE: ./src/typography/body/styles/index.ts





var bodyStyles = {
    colors: colors,
    fontStyles: fontStyles,
    sizes: sizes,
    base: styles_base,
    weights: weights
};

;// CONCATENATED MODULE: ./src/typography/body/body.ts


/** the available body font sizes */ var BodySizes = [
    21,
    16,
    12
];
/** The available body font weights */ var BodyWeights = [
    "normal",
    "bold"
];
/** The available body font styles */ var BodyStyles = [
    "normal",
    "italic"
];
/** The available body font colors */ var BodyColors = [
    "blueberry-2",
    "carrot-2",
    "carrot-3",
    "charcoal-1",
    "charcoal-2",
    "charcoal-3",
    "kale-2",
    "white"
];
/** The available body font size variant for responsive text */ var BodySizeVariants = [
    "1",
    "2",
    "3"
];
/** The available body font weights for responsive text */ var BodyFontWeights = [
    "roman",
    "bold"
];
var body = new Typography(bodyStyles, {
    weight: "normal",
    fontStyle: "normal",
    size: 21
});

;// CONCATENATED MODULE: ./src/typography/body/index.ts



;// CONCATENATED MODULE: ./src/typography/article/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_colors = ({"blueberry-2":"d6M9nV","blueberry2":"d6M9nV","carrot-2":"XpkIT2","carrot2":"XpkIT2","carrot-3":"vP13y2","carrot3":"vP13y2","charcoal-1":"OPgCRp","charcoal1":"OPgCRp","charcoal-2":"d05LjI","charcoal2":"d05LjI","charcoal-3":"RNBOzr","charcoal3":"RNBOzr","kale-2":"yyB0nY","kale2":"yyB0nY","white":"R6uBMJ"});
;// CONCATENATED MODULE: ./src/typography/article/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_fontStyles = ({"normal":"A3cMl9","italic":"ANzMq1"});
;// CONCATENATED MODULE: ./src/typography/article/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_sizes = ({"size-21":"AVg6vN","size21":"AVg6vN","size-20":"Sd5rey","size20":"Sd5rey","size-16":"tq7_h7","size16":"tq7_h7","size-12":"amNnHC","size12":"amNnHC","size-1":"CxPOhC","size1":"CxPOhC","size-2":"AGszgf","size2":"AGszgf","size-3":"k9E_z2","size3":"k9E_z2"});
;// CONCATENATED MODULE: ./src/typography/article/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const article_styles_base = ({"family":"bOoAdc"});
;// CONCATENATED MODULE: ./src/typography/article/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_weights = ({"normal":"N5P5ZN","roman":"T2_JNo","bold":"zQwdZ5"});
;// CONCATENATED MODULE: ./src/typography/article/styles/index.ts





var articleStyles = {
    colors: styles_colors,
    fontStyles: styles_fontStyles,
    sizes: styles_sizes,
    base: article_styles_base,
    weights: styles_weights
};

;// CONCATENATED MODULE: ./src/typography/article/article.ts


/** The available article font sizes */ var ArticleSizes = [
    21,
    20,
    16,
    12
];
/** The available article font weights */ var ArticleWeights = [
    "normal",
    "bold"
];
/** The available article font styles */ var ArticleStyles = [
    "normal",
    "italic"
];
/** The available article font colors */ var ArticleColors = [
    "blueberry-2",
    "carrot-2",
    "carrot-3",
    "charcoal-1",
    "charcoal-2",
    "charcoal-3",
    "kale-2",
    "white"
];
/** The available article font size variant for responsive text */ var ArticleSizeVariants = [
    "1",
    "2",
    "3"
];
/** The available article font weights for responsive text */ var ArticleFontWeights = [
    "roman",
    "bold"
];
var article = new Typography(articleStyles, {
    weight: "normal",
    fontStyle: "normal",
    size: 16
});

;// CONCATENATED MODULE: ./src/typography/article/index.ts



;// CONCATENATED MODULE: ./src/typography/heading/styles/colors.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_colors = ({"blueberry-3":"kM5rLm","blueberry3":"kM5rLm","carrot-2":"HrxLrb","carrot2":"HrxLrb","carrot-3":"C1t5Gc","carrot3":"C1t5Gc","charcoal-1":"QItEqX","charcoal1":"QItEqX","charcoal-2":"iA7Qcq","charcoal2":"iA7Qcq","charcoal-3":"U67HrC","charcoal3":"U67HrC","kale-2":"aiLAmA","kale2":"aiLAmA","kale-3":"Pz8Jc_","kale3":"Pz8Jc_","white":"osMXBi"});
;// CONCATENATED MODULE: ./src/typography/heading/styles/fontStyles.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_fontStyles = ({"normal":"PGDFMa"});
;// CONCATENATED MODULE: ./src/typography/heading/styles/sizes.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_sizes = ({"size-72":"W67vY7","size72":"W67vY7","size-52":"eLbOpQ","size52":"eLbOpQ","size-40":"FUn009","size40":"FUn009","size-28":"tlQtaU","size28":"tlQtaU","size-22":"LnfUW7","size22":"LnfUW7","size-21":"ZWoR2o","size21":"ZWoR2o","size-16":"zPijcF","size16":"zPijcF","size-12":"Dbzq1C","size12":"Dbzq1C","size-1":"kPVMWW","size1":"kPVMWW","size-2":"SsjmnA","size2":"SsjmnA","size-3":"vhBtdN","size3":"vhBtdN","size-4":"bOqAXY","size4":"bOqAXY","size-5":"DCqlf1","size5":"DCqlf1"});
;// CONCATENATED MODULE: ./src/typography/heading/styles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_base = ({"family":"TNu9xA"});
;// CONCATENATED MODULE: ./src/typography/heading/styles/weights.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const heading_styles_weights = ({"normal":"pKjc9p","bold":"U70TRS","black":"jjdzq5","dynamicBold":"m_li4Y"});
;// CONCATENATED MODULE: ./src/typography/heading/styles/index.ts





var headingStyles = {
    colors: heading_styles_colors,
    fontStyles: heading_styles_fontStyles,
    sizes: heading_styles_sizes,
    base: heading_styles_base,
    weights: heading_styles_weights
};

;// CONCATENATED MODULE: ./src/typography/heading/heading.ts


/** The available heading font sizes */ var HeadingSizes = [
    72,
    52,
    40,
    28,
    22,
    21,
    16,
    12
];
/** The available heading font weights */ var HeadingWeights = [
    "normal",
    "bold"
];
/** The available heading font styles */ var HeadingStyles = [
    "normal"
];
/** The available heading font colors */ var HeadingColors = [
    "blueberry-3",
    "carrot-2",
    "carrot-3",
    "charcoal-1",
    "charcoal-2",
    "charcoal-3",
    "kale-2",
    "kale-3",
    "white"
];
/** The available heading font size variant for responsive text */ var HeadingSizeVariants = [
    "1",
    "2",
    "3",
    "4",
    "5"
];
var HeadingFontWeights = [
    "black"
];
var heading = new Typography(headingStyles, {
    weight: "normal",
    fontStyle: "normal"
});

;// CONCATENATED MODULE: ./src/typography/heading/index.ts



;// CONCATENATED MODULE: ./src/typography/index.ts




;// CONCATENATED MODULE: ./src/styles/button.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_button = ({"button":"qdKc3_"});
;// CONCATENATED MODULE: ./src/designs/getButtonDesign/getButtonDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getButtonDesign = ({"button":"Mv3epP","primary":"JjeNJn","secondary":"dhXnmw","mini":"T7AUyd","pill":"PWWto6","hover":"CGootV","active":"s5x0pS","disabled":"GuwyyR"});
;// CONCATENATED MODULE: ./src/designs/getButtonDesign/getButtonDesign.ts
function getButtonDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




/** All of the possible design variants available for the button design */ var ButtonVariants = [
    "primary",
    "secondary"
];
var typography = heading.create({
    size: 16,
    weight: "bold"
});
/**
 * Return a class name the applies the button design based on the button design
 * props interface.
 */ function getButtonDesign_getButtonDesign(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_active = param.active, active = _param_active === void 0 ? false : _param_active, _param_hover = param.hover, hover = _param_hover === void 0 ? false : _param_hover, _param_asPill = param.asPill, asPill = _param_asPill === void 0 ? false : _param_asPill, _param_asMini = param.asMini, asMini = _param_asMini === void 0 ? false : _param_asMini;
    var _obj;
    return external_classnames_default()(getButtonDesign.button, styles_button.button, typography.className, (_obj = {}, getButtonDesign_define_property(_obj, getButtonDesign[variant], variant), getButtonDesign_define_property(_obj, getButtonDesign.disabled, disabled), getButtonDesign_define_property(_obj, getButtonDesign.active, active), getButtonDesign_define_property(_obj, getButtonDesign.hover, hover), getButtonDesign_define_property(_obj, getButtonDesign.pill, asPill), getButtonDesign_define_property(_obj, getButtonDesign.mini, asMini), _obj));
}

;// CONCATENATED MODULE: ./src/designs/getButtonDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/getCheckboxDesign/getCheckboxDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getCheckboxDesign = ({"checkbox":"de4Npi","checked":"vYzOUT","disabled":"PaIfeJ","focus":"TxMWDn"});
;// CONCATENATED MODULE: ./src/designs/getCheckboxDesign/getCheckboxDesign.ts
function getCheckboxDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the checkbox design based on the checkbox design
 * props interface.
 */ function getCheckboxDesign_getCheckboxDesign(param) {
    var _param_checked = param.checked, checked = _param_checked === void 0 ? false : _param_checked, state = param.state;
    return external_classnames_default()(getCheckboxDesign.checkbox, getCheckboxDesign[state], getCheckboxDesign_define_property({}, getCheckboxDesign.checked, checked));
}

;// CONCATENATED MODULE: ./src/designs/getCheckboxDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/getLineThroughDesign/getLineThroughDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getLineThroughDesign = ({"line":"U4nhWs","first":"YxNBei","last":"dLZ9V3"});
;// CONCATENATED MODULE: ./src/designs/getLineThroughDesign/getLineThroughDesign.ts
function getLineThroughDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the line through design based on the line through design
 * props interface.
 */ function getLineThroughDesign_getLineThroughDesign() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_first = _ref.first, first = _ref_first === void 0 ? false : _ref_first, _ref_last = _ref.last, last = _ref_last === void 0 ? false : _ref_last;
    var _obj;
    return external_classnames_default()(getLineThroughDesign.line, (_obj = {}, getLineThroughDesign_define_property(_obj, getLineThroughDesign.first, first), getLineThroughDesign_define_property(_obj, getLineThroughDesign.last, last), _obj));
}

;// CONCATENATED MODULE: ./src/designs/getLineThroughDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/getLinkDesign/getLinkDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getLinkDesign = ({"link":"PLkTbL","primary":"ALo_z_","dark":"zX05h4","light":"IrduX9","high-contrast":"Ynvno7","highContrast":"Ynvno7","secondary":"BRERcz","tertiary":"oUnK5K","disabled":"upgeWx","hover":"wmVaBj","active":"IUAK3H"});
;// CONCATENATED MODULE: ./src/designs/getLinkDesign/getLinkDesign.ts
function getLinkDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/** All of the possible contrast modes available for the link design */ var LinkModes = [
    "light",
    "dark"
];
/** All of the possible design variants available for the link design */ var LinkVariants = [
    "primary",
    "secondary",
    "tertiary"
];
/**
 * Return a class name the applies the link design based on the link design
 * props interface.
 */ function getLinkDesign_getLinkDesign(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, _param_mode = param.mode, mode = _param_mode === void 0 ? "light" : _param_mode, _param_highContrast = param.highContrast, highContrast = _param_highContrast === void 0 ? false : _param_highContrast, disabled = param.disabled, active = param.active, hover = param.hover;
    var _obj;
    return external_classnames_default()(getLinkDesign.link, getLinkDesign[variant], getLinkDesign[mode], (_obj = {}, getLinkDesign_define_property(_obj, getLinkDesign.active, active), getLinkDesign_define_property(_obj, getLinkDesign.hover, hover), getLinkDesign_define_property(_obj, getLinkDesign.disabled, disabled), getLinkDesign_define_property(_obj, getLinkDesign.highContrast, highContrast), _obj));
}

;// CONCATENATED MODULE: ./src/designs/getLinkDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/getModalDesign/getModalDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getModalDesign = ({"modal":"wJ7ne0","non-wave":"weSLiE","nonWave":"weSLiE","wave-section":"nOGnz2","waveSection":"nOGnz2","below-wave-section":"Gmrww8","belowWaveSection":"Gmrww8"});
;// CONCATENATED MODULE: ./src/designs/getModalDesign/getModalDesign.ts


/**
 * Return a class name the applies the modal design.
 */ function getModalDesign_getModalDesign() {
    return external_classnames_default()(getModalDesign.modal);
}
/**
 * Return a class name that applies the non-wave design to the modal content.
 */ function getNonWaveDesign() {
    return external_classnames_default()(getModalDesign.nonWave);
}
/**
 * Return object with class names for the sections of the wave design modal.
 */ function getWaveDesign() {
    return {
        waveSectionDesign: external_classnames_default()(getModalDesign.waveSection),
        belowWaveSectionDesign: external_classnames_default()(getModalDesign.belowWaveSection)
    };
}

;// CONCATENATED MODULE: ./src/designs/getModalDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/getRadioDesign/getRadioDesign.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const getRadioDesign = ({"radio":"eRkNTG","checked":"LeJH8R","disabled":"ilz48F","focus":"ZyZxNH"});
;// CONCATENATED MODULE: ./src/designs/getRadioDesign/getRadioDesign.ts
function getRadioDesign_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Return a class name the applies the radio design based on the radio design
 * props interface.
 */ function getRadioDesign_getRadioDesign(param) {
    var state = param.state, checked = param.checked;
    return external_classnames_default()(getRadioDesign.radio, getRadioDesign[state], getRadioDesign_define_property({}, getRadioDesign.checked, checked));
}

;// CONCATENATED MODULE: ./src/designs/getRadioDesign/index.ts


;// CONCATENATED MODULE: ./src/designs/index.ts







;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// CONCATENATED MODULE: external "react-transition-group"
const external_react_transition_group_namespaceObject = require("react-transition-group");
;// CONCATENATED MODULE: ./src/components/BorderLabel/BorderLabel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const BorderLabel = ({"container":"FIJWu3","label":"MgASHM","normal":"DRlP_9","focus":"a9IHEz","invalid":"lTDcYH","disabled":"mdVruo","highlighted":"cC0zAR"});
;// CONCATENATED MODULE: ./src/components/BorderLabel/Text.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Text = ({"text":"WNyRfS","normal":"UDipXU","exited":"WIEMS8","exiting":"vZ_G9L","entered":"vkkPbD","entering":"GLrouC","focus":"sXNNDh","invalid":"uGPg8W","disabled":"H0o0OA"});
;// CONCATENATED MODULE: ./src/styles/accessibility.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const accessibility = ({"hidden":"EQwwNX"});
;// CONCATENATED MODULE: ./src/components/AccessibleContent/AccessibleContent.tsx


/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/accessiblecontent | AccessibleContent} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function AccessibleContent(param) {
    var visualContent = param.visualContent, accessibleText = param.accessibleText;
    return /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement("div", {
        "aria-hidden": "true"
    }, visualContent), /*#__PURE__*/ external_react_default().createElement("span", {
        className: accessibility.hidden
    }, accessibleText));
}

;// CONCATENATED MODULE: ./src/components/BorderLabel/BorderLabel.tsx
function BorderLabel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BorderLabel_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var ANIMATION_DURATION = 200;
var BorderLabel_typography = heading.create({
    size: 16
});
/**
 * An animated label that serves as both a WCAG compliant element label as well
 * as a placholder. The animations occur based on the different states of the
 * element.
 *
 * In adherence of best WCAG practices we put the interface element inside of
 * the label.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/fieldlabel | FieldLabel} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var BorderLabel_BorderLabel = function(_param) {
    var state = _param.state, children = _param.children, text = _param.text, show = _param.in, className = _param.className, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = _object_without_properties(_param, [
        "state",
        "children",
        "text",
        "in",
        "className",
        "hideLabel"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_transition_group_namespaceObject.Transition, {
        in: show,
        timeout: ANIMATION_DURATION
    }, function(transitionState) {
        return /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            className: external_classnames_default()(BorderLabel.container, className)
        }, /*#__PURE__*/ external_react_namespaceObject.createElement("label", _object_spread_props(_object_spread({}, props), {
            className: external_classnames_default()(BorderLabel.label, BorderLabel[state])
        }), children, hideLabel && show ? /*#__PURE__*/ external_react_namespaceObject.createElement(AccessibleContent, {
            visualContent: "",
            accessibleText: text
        }) : /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            className: external_classnames_default()(Text.text, Text[transitionState], Text[state], BorderLabel_typography.className)
        }, text)));
    });
};

;// CONCATENATED MODULE: ./src/components/BorderLabel/useElementState.ts
function useElementState_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useElementState_array_without_holes(arr) {
    if (Array.isArray(arr)) return useElementState_array_like_to_array(arr);
}
function useElementState_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useElementState_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || useElementState_unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function useElementState_to_consumable_array(arr) {
    return useElementState_array_without_holes(arr) || useElementState_iterable_to_array(arr) || useElementState_unsupported_iterable_to_array(arr) || useElementState_non_iterable_spread();
}
function useElementState_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useElementState_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useElementState_array_like_to_array(o, minLen);
}

/** An array of all possible states that an element can have */ var ElementStates = [
    "invalid",
    "disabled",
    "focus",
    "highlighted",
    "normal"
];
/**
 * Return a single string of the highest priority state given an array of
 * currently active states.
 */ function getState(states) {
    if (states.includes("disabled")) {
        return "disabled";
    }
    if (states.includes("invalid")) {
        return "invalid";
    }
    if (states.includes("focus")) {
        return "focus";
    }
    if (states.includes("highlighted")) {
        return "highlighted";
    }
    return "normal";
}
/**
 * Use interface element states based on props. Return an enum value of the
 * current element state as well as handlers to intercept focus and blur events
 * so that they stay in sync with the element state.
 */ var useElementState = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var invalid = Boolean(props.invalid);
    var disabled = Boolean(props.disabled);
    var autoFocus = Boolean(props.autoFocus);
    var highlighted = Boolean(props.highlighted);
    var _useState = _sliced_to_array((0,external_react_namespaceObject.useState)([]), 2), states = _useState[0], setStates = _useState[1];
    var addState = (0,external_react_namespaceObject.useCallback)(function(nextState) {
        setStates(function(lastStates) {
            return useElementState_to_consumable_array(lastStates).concat([
                nextState
            ]);
        });
    }, []);
    var removeState = (0,external_react_namespaceObject.useCallback)(function(nextState) {
        setStates(function(lastStates) {
            return lastStates.filter(function(state) {
                return state !== nextState;
            });
        });
    }, []);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (invalid) {
            addState("invalid");
        } else {
            removeState("invalid");
        }
    }, [
        addState,
        removeState,
        invalid
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (disabled) {
            addState("disabled");
        } else {
            removeState("disabled");
        }
    }, [
        addState,
        removeState,
        disabled
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (highlighted) {
            addState("highlighted");
        } else {
            removeState("highlighted");
        }
    }, [
        addState,
        removeState,
        highlighted
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (autoFocus) {
            addState("focus");
        } else {
            removeState("focus");
        }
    }, [
        addState,
        removeState,
        autoFocus
    ]);
    var handleFocus = function() {
        addState("focus");
    };
    var handleBlur = function() {
        removeState("focus");
    };
    return [
        getState(states),
        {
            onBlur: handleBlur,
            onFocus: handleFocus
        }
    ];
};

;// CONCATENATED MODULE: ./src/components/BorderLabel/index.ts



;// CONCATENATED MODULE: ./src/components/ActivityIndicator/ActivityIndicator.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ActivityIndicator = ({"container":"BJcT5w","bounce":"saeipN","light":"ydkNDZ"});
;// CONCATENATED MODULE: ./src/components/ActivityIndicator/ActivityIndicator.tsx



var ActivityIndicatorModes = (/* unused pure expression or super */ null && ([
    "light",
    "dark"
]));
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/activityindicator | ActivityIndicator} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ActivityIndicator_ActivityIndicator = function(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? "light" : _param_mode;
    var cssClass = external_classnames_default()(ActivityIndicator.container, ActivityIndicator[mode]);
    return /*#__PURE__*/ external_react_default().createElement("span", {
        className: cssClass
    }, /*#__PURE__*/ external_react_default().createElement("span", null), /*#__PURE__*/ external_react_default().createElement("span", null), /*#__PURE__*/ external_react_default().createElement("span", null));
};

;// CONCATENATED MODULE: ./src/components/ButtonBase/ButtonBase.tsx
function ButtonBase_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonBase_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonBase_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ButtonBase_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ButtonBase_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ButtonBase_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ButtonBase_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ButtonBase_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ButtonBase_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/**
 * The core component to render a button.  Responsible for managing any
 * accessibility patterns and minimal base button styles.
 *
 * This component is "private" to CORGI and should not be exported.
 */ var ButtonBase = function(_param) {
    var _param_type = _param.type, type = _param_type === void 0 ? "button" : _param_type, disabled = _param.disabled, props = ButtonBase_object_without_properties(_param, [
        "type",
        "disabled"
    ]);
    if (disabled) {
        props["aria-disabled"] = true;
    }
    var handleClickSuppression = function(event) {
        event.preventDefault();
        return;
    };
    return /*#__PURE__*/ external_react_default().createElement("button", ButtonBase_object_spread_props(ButtonBase_object_spread({}, props), {
        type: type,
        className: external_classnames_default()(styles_button.button, props.className),
        /* for accessibility purposes, disable click events if disabled or loading; otherwise use props */ onClick: disabled ? handleClickSuppression : props.onClick
    }), props.children);
};

;// CONCATENATED MODULE: ./src/components/Button/Button.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Button = ({"button":"br1fCW","as-link":"a6QHfN","asLink":"a6QHfN","loading":"mlU8zd","indicator":"_FURd4"});
;// CONCATENATED MODULE: ./src/components/Button/Button.tsx
function Button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Button_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Button_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Button_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Button_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Button_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Button_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






/**
 * Extends native button element
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/button | Button} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Button_Button = function(_param) {
    var _param_loading = _param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_asLink = _param.asLink, asLink = _param_asLink === void 0 ? false : _param_asLink, highContrast = _param.highContrast, variant = _param.variant, disabled = _param.disabled, active = _param.active, hover = _param.hover, asPill = _param.asPill, asMini = _param.asMini, mode = _param.mode, className = _param.className, children = _param.children, props = Button_object_without_properties(_param, [
        "loading",
        "asLink",
        "highContrast",
        "variant",
        "disabled",
        "active",
        "hover",
        "asPill",
        "asMini",
        "mode",
        "className",
        "children"
    ]);
    var elementClass = !asLink ? Button.button : Button.asLink;
    var designClass = !asLink ? getButtonDesign_getButtonDesign({
        variant: variant !== "tertiary" ? variant : undefined,
        disabled: disabled && !loading,
        active: active,
        hover: hover,
        asPill: asPill,
        asMini: asMini
    }) : getLinkDesign_getLinkDesign({
        variant: variant,
        disabled: disabled,
        active: active,
        hover: hover,
        mode: mode,
        highContrast: highContrast
    });
    return /*#__PURE__*/ external_react_default().createElement(ButtonBase, Button_object_spread_props(Button_object_spread({
        "aria-busy": loading,
        disabled: disabled || loading
    }, props), {
        className: external_classnames_default()(elementClass, designClass, className, Button_define_property({}, Button.loading, loading && !asLink))
    }), children, loading && !asLink && /*#__PURE__*/ external_react_default().createElement("span", {
        className: Button.indicator
    }, /*#__PURE__*/ external_react_default().createElement(ActivityIndicator_ActivityIndicator, {
        mode: variant !== "secondary" ? "light" : "dark"
    })));
};

;// CONCATENATED MODULE: ./src/components/Button/index.ts


;// CONCATENATED MODULE: ./src/util/withRef.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ function withRef_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withRef_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withRef_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withRef_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function withRef_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        withRef_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/**
 * Add a prop named `forwardedRef` to the component props. This is useful for
 * exposing the inner HTML element to the consumer of a component and makes it
 * easier to deal with the complications from using `forwardRef` in typescript.
 *
 * @deprecated Don't use this. Use the `forwardRef` function from React and make explicit the ref forwarding explicit in the code.
 */ var withRef = function(Wrapped) {
    return /*#__PURE__*/ (0,external_react_namespaceObject.forwardRef)(function(props, forwardedRef) {
        return /*#__PURE__*/ (0,external_react_namespaceObject.createElement)(Wrapped, withRef_object_spread_props(withRef_object_spread({}, props), {
            forwardedRef: forwardedRef
        }));
    });
};

;// CONCATENATED MODULE: ./src/util/interceptEvent.ts
/** No arguments */ function interceptEvent_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function interceptEvent_array_without_holes(arr) {
    if (Array.isArray(arr)) return interceptEvent_array_like_to_array(arr);
}
function interceptEvent_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function interceptEvent_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function interceptEvent_to_consumable_array(arr) {
    return interceptEvent_array_without_holes(arr) || interceptEvent_iterable_to_array(arr) || interceptEvent_unsupported_iterable_to_array(arr) || interceptEvent_non_iterable_spread();
}
function interceptEvent_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return interceptEvent_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return interceptEvent_array_like_to_array(o, minLen);
}
/**
 * Return an event handler that will run multiple events in the order that they
 * are passed as arguments.
 */ function interceptEvent() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handlers.forEach(function(handler) {
            if (handler) {
                handler.apply(void 0, interceptEvent_to_consumable_array(args));
            }
        });
    };
}

;// CONCATENATED MODULE: ./src/components/Selector/Selector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Selector = ({"container":"jU74az"});
;// CONCATENATED MODULE: ./src/components/Selector/Selector.tsx
function Selector_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Selector_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Selector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Selector_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Selector_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Selector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Selector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Selector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Selector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Selector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Selector_sliced_to_array(arr, i) {
    return Selector_array_with_holes(arr) || Selector_iterable_to_array_limit(arr, i) || Selector_unsupported_iterable_to_array(arr, i) || Selector_non_iterable_rest();
}
function Selector_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Selector_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Selector_array_like_to_array(o, minLen);
}






/** Valid input types that can be a selector */ var Types = [
    "radio",
    "checkbox"
];
/**
 * Component used to create a custom radio or checkbox element following a11y rules.
 * Children can be any react element and will be passed the prop "state" which holds a value from
 * useElementState.
 *
 * All props not defined will be passed into the `input` element except for the className which is passed to
 * the containing `label` element.
 *
 * @deprecated Do not use this component. Use Checkbox or RadioButton from corgi-x, or implement your own state.
 */ var Selector_Selector = withRef(function(_param) {
    var className = _param.className, onFocus = _param.onFocus, onBlur = _param.onBlur, children = _param.children, labelProps = _param.labelProps, forwardedRef = _param.forwardedRef, props = Selector_object_without_properties(_param, [
        "className",
        "onFocus",
        "onBlur",
        "children",
        "labelProps",
        "forwardedRef"
    ]);
    var _useElementState = Selector_sliced_to_array(useElementState(props), 2), state = _useElementState[0], handlers = _useElementState[1];
    return /*#__PURE__*/ external_react_namespaceObject.createElement("label", Selector_object_spread({
        className: external_classnames_default()(Selector.container, className)
    }, labelProps), /*#__PURE__*/ external_react_namespaceObject.createElement("input", Selector_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()(accessibility.hidden),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        "data-checked": props.checked
    }, props)), typeof children === "function" ? children(state) : external_react_namespaceObject.Children.map(children, function(child) {
        if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) return child;
        return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
            // @ts-ignore
            state: state
        });
    }));
});

;// CONCATENATED MODULE: ./src/icons/svg/arrow.svg
var _excluded = ["styles"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const arrow = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M11.03 19.53a.75.75 0 00.073-.976l-.073-.084-8.467-8.468 8.467-8.469a.75.75 0 00.073-.976L11.03.472A.75.75 0 0010.054.4L9.97.473.972 9.471a.75.75 0 00-.072.977l.072.084L9.97 19.53a.749.749 0 001.06 0z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/back.svg
var back_excluded = ["styles"];
function back_extends() { back_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return back_extends.apply(this, arguments); }
function back_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = back_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function back_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const back = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = back_objectWithoutProperties(_ref, back_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", back_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M44 21.988a1 1 0 01-1 1H3.414L15.707 35.28a1 1 0 11-1.414 1.414l-14-14a1 1 0 010-1.414l14-14a1 1 0 011.414 1.414L3.414 20.988H43a1 1 0 011 1z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/blob.svg
var blob_excluded = ["styles"];
function blob_extends() { blob_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return blob_extends.apply(this, arguments); }
function blob_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = blob_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function blob_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const blob = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = blob_objectWithoutProperties(_ref, blob_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", blob_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 464 422"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M462.672 182.35c-.012-.163-.032-.325-.048-.488-.5-5-.836-10.029-1.551-14.991-.612-4.2-1.258-8.326-1.308-7.665-2.914-17.292-8.7-34.369-15.9-50.368-6.136-13.631-13.662-26.749-23.42-37.983-5.853-6.737-12.451-12.735-19.03-18.714-2.952-2.682-5.905-5.365-8.953-7.927a151.248 151.248 0 00-37.873-23.308 310.565 310.565 0 00-7.751-3.167c-.864-.512-1.72-1.026-2.548-1.547-2.325-1.463-8.026-3.29-8.026-3.29s-7.842-2.768-10.844-3.368c-1.494-.3-3.722-.692-6.4-1.134a214.268 214.268 0 00-12.28-2.958c-6.88-1.433-13.828-2.415-20.784-3.2a367.837 367.837 0 00-33.43-2.224C242.1-.2 232.76 1.6 222.553 3.281A406.836 406.836 0 00172.6 14.758a204.233 204.233 0 00-26.066 9.6c-9.7 4.4-17.621 10.631-27.682 14.484C94 48.355 75.719 65.663 55.934 82.924c-8.788 7.667-17.7 15.469-24.546 25.106-7.141 10.052-12.328 21.92-17.364 33.251C3.142 165.765 1.1 196.228.165 223.149c-.09 2.586.068 6.762-.076 8.419.468 6.235-.286 3.067-.037 7.126-.13 1.23.188 5.536.521 9.684.4 4.623.651 7.911.323 6.568.571 5.377.91 8.745 1.007 10.025a786.428 786.428 0 001.254 10.184c.2 2.008.507 4.005.919 5.981.073-.035.878 5.113 1.751 10.475 1.183 7.683 1.217 6.487 1.259 5.051.266.238.982 3.549 1.786 7.22.592 2.076 1.193 3.93 2.06 7.459 6.195 14.582 11.137 28.565 20.576 41.545a126.592 126.592 0 0034.15 32.314c3.878 2.469 7.879 4.712 11.879 6.954a72.044 72.044 0 009.863 4.887c5.6 2.09 11.549 2.705 17.335 4.047 14.7 3.411 28.461 11.589 43.45 13.428 16.723 2.051 33.636 3.625 50.417 5.4 26.695 2.818 52.239.986 78.642-1.881 9.925-1.077 19.7-3.553 29.32-6.169 9.589-2.608 19.483-4.03 28.962-7.216 10.562-3.549 20.472-8.694 30.492-13.5 8.677-4.165 16.426-8.511 23.418-15.25a146.925 146.925 0 0013.48-15.338c4.039-5.153 8.606-9.748 12.571-14.985 2.026-2.676 4.036-5.583 6.027-8.653.038.07.07.146.11.215 4.455-7.817 9.281-14.548 13.982-22.13 4.747-7.657 6.733-16.236 9.664-24.7 3-8.675 7-17.349 10-26.023 2.916-8.427 5.336-36.186 6.535-44.906.1-.739.093-1.124-.007-1.222a204.619 204.619 0 00.874-35.808z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/bolt.svg
var bolt_excluded = ["styles"];
function bolt_extends() { bolt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bolt_extends.apply(this, arguments); }
function bolt_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = bolt_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function bolt_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const bolt = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = bolt_objectWithoutProperties(_ref, bolt_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", bolt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M13.255 9.19H7.759c.136-.648.276-1.3.412-1.948.328-1.544.656-3.088.98-4.632.136-.652.276-1.3.412-1.952C9.61.426 9.535.194 9.327.07c-.248-.148-.548-.052-.7.188-.316.496-.632.988-.952 1.484l-2.24 3.5L2.819 9.33c-.692 1.084-1.388 2.168-2.08 3.252-.22.348-.444.692-.664 1.04-.216.336.068.784.44.784h5.488c-.136.652-.276 1.3-.412 1.952-.328 1.544-.656 3.092-.98 4.636-.136.636-.272 1.276-.404 1.912a.52.52 0 00.04.428c.004.008.008.016.016.024.012.016.02.032.032.048a.48.48 0 00.044.048.106.106 0 01.02.024.284.284 0 00.056.04.055.055 0 01.016.012c.004 0 .004.004.008.004.02.012.04.02.064.028.012.004.024.012.036.012.008 0 .012.004.016.008.016.004.032.004.044.008.012 0 .024.004.032.004a.194.194 0 00.068 0h.028a.509.509 0 00.424-.292c.308-.48.616-.964.928-1.448.748-1.168 1.496-2.336 2.244-3.5.872-1.364 1.748-2.728 2.62-4.088.696-1.084 1.388-2.168 2.084-3.252.22-.348.444-.692.664-1.04.22-.336-.064-.784-.436-.784zm-3.636 5.244c-.872 1.364-1.748 2.728-2.62 4.088-.408.636-.816 1.272-1.224 1.912.316-1.488.632-2.976.944-4.464.14-.652.276-1.3.412-1.952.068-.328-.148-.66-.492-.66H1.463l.448-.7 2.24-3.5L6.767 5.07c.408-.636.812-1.272 1.22-1.908-.316 1.488-.628 2.972-.944 4.46-.136.652-.276 1.3-.412 1.952-.068.328.148.66.492.66h5.184l-.448.7a4745.65 4745.65 0 01-2.24 3.5z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/bowl-steaming.svg
var bowl_steaming_excluded = ["styles"];
function bowl_steaming_extends() { bowl_steaming_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bowl_steaming_extends.apply(this, arguments); }
function bowl_steaming_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = bowl_steaming_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function bowl_steaming_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const bowl_steaming = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = bowl_steaming_objectWithoutProperties(_ref, bowl_steaming_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", bowl_steaming_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "nonzero",
    d: "M14 11.832a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0112 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0014 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466A2.816 2.816 0 0115 11.832a2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0013 15.5a.5.5 0 01-1 0 2.816 2.816 0 011.162-2.203c.498-.326.809-.87.838-1.465zm4.5 0a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0116.5 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0018.5 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466a2.816 2.816 0 011.162 2.203 2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0017.5 15.5a.5.5 0 01-1 0 2.814 2.814 0 011.162-2.203 1.86 1.86 0 00.838-1.465zm4.5 0a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0121 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0023 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466A2.816 2.816 0 0124 11.832a2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0022 15.5a.5.5 0 01-1 0 2.814 2.814 0 011.162-2.203A1.86 1.86 0 0023 11.832z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M14 11.832a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0112 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0014 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466A2.816 2.816 0 0115 11.832a2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0013 15.5a.5.5 0 01-1 0 2.816 2.816 0 011.162-2.203c.498-.326.809-.87.838-1.465zm4.5 0a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0116.5 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0018.5 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466a2.816 2.816 0 011.162 2.203 2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0017.5 15.5a.5.5 0 01-1 0 2.814 2.814 0 011.162-2.203 1.86 1.86 0 00.838-1.465zm4.5 0a1.86 1.86 0 00-.838-1.466A2.816 2.816 0 0121 8.163a2.81 2.81 0 011.162-2.2A1.86 1.86 0 0023 4.5a.5.5 0 011 0 2.81 2.81 0 01-1.163 2.2c-.497.326-.808.87-.837 1.463.029.595.34 1.14.838 1.466A2.816 2.816 0 0124 11.832a2.814 2.814 0 01-1.162 2.203A1.86 1.86 0 0022 15.5a.5.5 0 01-1 0 2.814 2.814 0 011.162-2.203A1.86 1.86 0 0023 11.832z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "nonzero",
    d: "M31.5 19a.5.5 0 010 1h-2.58l-.003.077-.846 11a1 1 0 01-.997.923H8.926a1 1 0 01-.997-.923l-.846-11L7.08 20H4.5a.5.5 0 010-1h27zm-3.58 1H8.079l.847 11h18.148l.307-4H13.5a.5.5 0 010-1h13.958l.462-6z"
  })));
});
;// CONCATENATED MODULE: ./src/icons/svg/calendar.svg
var calendar_excluded = ["styles"];
function calendar_extends() { calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }
function calendar_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = calendar_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function calendar_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const calendar = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = calendar_objectWithoutProperties(_ref, calendar_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", calendar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M32 30.958c0 .576-.448 1.042-1 1.042H5c-.552 0-1-.466-1-1.042V8a1 1 0 011-1h5V5.5a.5.5 0 011 0V7h14V5.5a.5.5 0 011 0V7h5a1 1 0 011 1v22.958zM31 13H5v18h26V13zm-12.5 3a5.5 5.5 0 110 11 5.5 5.5 0 110-11zm0 1a4.505 4.505 0 00-4.5 4.5 4.5 4.5 0 104.5-4.5zm0 2a.5.5 0 01.5.5v2.25l1.8 1.35a.498.498 0 11-.6.8l-2-1.5a.5.5 0 01-.2-.4v-2.5a.5.5 0 01.5-.5zM31 8H5v4h26V8z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/caret.svg
var caret_excluded = ["styles"];
function caret_extends() { caret_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return caret_extends.apply(this, arguments); }
function caret_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = caret_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function caret_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const caret = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = caret_objectWithoutProperties(_ref, caret_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", caret_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M24 15l-6 8-6-8z",
    fillRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/carrot.svg
var carrot_excluded = ["styles"];
function carrot_extends() { carrot_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return carrot_extends.apply(this, arguments); }
function carrot_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = carrot_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function carrot_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const carrot = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = carrot_objectWithoutProperties(_ref, carrot_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", carrot_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M23.971 6.26a2.592 2.592 0 00-.601-.947 2.9 2.9 0 00-1.644-.792c-.048-.008-.095-.003-.144-.01a5.78 5.78 0 00.87-2.38.517.517 0 00-.584-.582c-.847.11-1.66.407-2.38.869-.005-.049-.001-.096-.01-.144A2.9 2.9 0 0018.688.63 2.592 2.592 0 0017.74.03a.496.496 0 00-.487.09 2.902 2.902 0 00-.945 2.765c.08.45.23.884.447 1.286a4.083 4.083 0 00-4.699 1.174A624.48 624.48 0 00.328 20.86c-.525.794-.4 1.85.297 2.499l.037.037c.629.675 1.654.797 2.424.287a628.464 628.464 0 0015.57-11.738 4.082 4.082 0 001.174-4.699 4.33 4.33 0 001.286.447 2.902 2.902 0 002.766-.945.496.496 0 00.09-.487zm-6.28-5.1c.094.06.18.13.258.208.277.295.451.67.5 1.07.047.328.048.66.001.988-.184.27-.32.568-.404.883a3.783 3.783 0 01-.707-1.59 1.93 1.93 0 01.352-1.558zm.324 9.961C13.177 14.897 8.3 18.574 2.47 22.84a.884.884 0 01-1.107-.22.92.92 0 01-.193-1.145c1.403-1.917 2.999-3.965 4.26-5.666L7.03 17.41a.522.522 0 00.739-.738l-1.698-1.697c-.005-.005-.012-.006-.017-.011.425-.573.847-1.138 1.264-1.697l.008.011 1.697 1.697a.522.522 0 00.738-.738l-1.697-1.697a.512.512 0 00-.133-.088c.43-.573.86-1.142 1.288-1.707l1.28 1.279a.522.522 0 00.737-.738L9.91 9.96a.48.48 0 00-.06-.04c.427-.562.857-1.123 1.288-1.684l.838.839a.522.522 0 00.738-.738l-.933-.934c.364-.47.728-.941 1.099-1.416a2.823 2.823 0 012.086-1.066 3.751 3.751 0 012.856 1.128l.057.057.056.056.196-.192.007.007-.194.194a3.753 3.753 0 011.138 2.86 2.822 2.822 0 01-1.066 2.091zm.961-6.095c.02-.522.247-1.014.63-1.369a3.823 3.823 0 011.653-.916 3.82 3.82 0 01-.916 1.654c-.354.383-.846.61-1.367.63zm2.305 1.635a3.784 3.784 0 01-1.59-.707c.315-.083.613-.22.882-.404.328-.047.66-.046.988.002.401.048.776.223 1.07.499.079.078.148.165.208.258a1.93 1.93 0 01-1.558.352z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/check-circle.svg
var check_circle_excluded = ["styles"];
function check_circle_extends() { check_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_circle_extends.apply(this, arguments); }
function check_circle_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = check_circle_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function check_circle_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const check_circle = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = check_circle_objectWithoutProperties(_ref, check_circle_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", check_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M80.195 45.993a1.667 1.667 0 012.612 2.05l-.186.236L58.44 73.948a1.67 1.67 0 01-2.093.273l-.236-.179-14.346-12.94a1.667 1.667 0 011.992-2.656l.24.18 13.13 11.847 23.069-24.48zM113.333 60c0 29.455-23.878 53.333-53.333 53.333S6.667 89.455 6.667 60 30.545 6.667 60 6.667A53.335 53.335 0 01113.333 60zM110 60c0-27.614-22.386-50-50-50S10 32.386 10 60s22.386 50 50 50c27.601-.03 49.97-22.399 50-50z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/check.svg
var check_excluded = ["styles"];
function check_extends() { check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_extends.apply(this, arguments); }
function check_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = check_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function check_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const check = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = check_objectWithoutProperties(_ref, check_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M4.243 11.186c.257.257.514.385.9.385s.643-.128.9-.385l9-9a1.243 1.243 0 000-1.8 1.243 1.243 0 00-1.8 0l-8.1 8.1-2.957-2.957a1.243 1.243 0 00-1.8 0 1.243 1.243 0 000 1.8l3.857 3.857z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/chevron.svg
var chevron_excluded = ["styles"];
function chevron_extends() { chevron_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_extends.apply(this, arguments); }
function chevron_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = chevron_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function chevron_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const chevron = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = chevron_objectWithoutProperties(_ref, chevron_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", chevron_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M12.97 27.53a.75.75 0 01-.073-.976l.073-.084 8.467-8.468-8.467-8.469a.75.75 0 01-.073-.976l.073-.085a.75.75 0 01.976-.072l.084.073 8.998 8.998a.75.75 0 01.072.977l-.072.084-8.998 8.998a.749.749 0 01-1.06 0z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle-alert.svg
var circle_alert_excluded = ["styles"];
function circle_alert_extends() { circle_alert_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_alert_extends.apply(this, arguments); }
function circle_alert_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_alert_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_alert_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle_alert = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_alert_objectWithoutProperties(_ref, circle_alert_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_alert_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M18 2C9.163 2 2 9.163 2 18s7.163 16 16 16 16-7.163 16-16A16 16 0 0018 2zm0 31C9.716 33 3 26.284 3 18 3 9.716 9.716 3 18 3c8.284 0 15 6.716 15 15-.01 8.28-6.72 14.99-15 15zm-.5-22h1v10h-1V11zm0 12.5h1v1h-1v-1z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle-cross.svg
var circle_cross_excluded = ["styles"];
function circle_cross_extends() { circle_cross_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_cross_extends.apply(this, arguments); }
function circle_cross_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_cross_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_cross_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle_cross = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_cross_objectWithoutProperties(_ref, circle_cross_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_cross_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M13.044 12.336l4.949 4.95 4.95-4.95a.5.5 0 01.707.708l-4.95 4.949 4.95 4.95a.5.5 0 01-.707.707l-4.95-4.95-4.95 4.95a.5.5 0 01-.707-.707l4.95-4.95-4.95-4.95a.5.5 0 01.708-.707zM34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1 0c0-8.284-6.716-15-15-15C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.28-.01 14.99-6.72 15-15z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle-fill.svg
var circle_fill_excluded = ["styles"];
function circle_fill_extends() { circle_fill_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_fill_extends.apply(this, arguments); }
function circle_fill_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_fill_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_fill_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle_fill = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_fill_objectWithoutProperties(_ref, circle_fill_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_fill_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5zm-2 0c0-6.904-5.596-12.5-12.5-12.5S5.5 11.096 5.5 18 11.096 30.5 18 30.5c6.9-.008 12.492-5.6 12.5-12.5z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle-minus.svg
var circle_minus_excluded = ["styles"];
function circle_minus_extends() { circle_minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_minus_extends.apply(this, arguments); }
function circle_minus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_minus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_minus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle_minus = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_minus_objectWithoutProperties(_ref, circle_minus_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-6 0a.75.75 0 01-.75.75H8.75a.75.75 0 010-1.5h18.5A.75.75 0 0128 18z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle-plus.svg
var circle_plus_excluded = ["styles"];
function circle_plus_extends() { circle_plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_plus_extends.apply(this, arguments); }
function circle_plus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_plus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_plus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle_plus = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_plus_objectWithoutProperties(_ref, circle_plus_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zM18 8a.75.75 0 01.75.75v8.5h8.5a.75.75 0 010 1.5h-8.5v8.5a.75.75 0 01-1.5 0v-8.5h-8.5a.75.75 0 010-1.5h8.5v-8.5A.75.75 0 0118 8z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/circle.svg
var circle_excluded = ["styles"];
function circle_extends() { circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_extends.apply(this, arguments); }
function circle_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = circle_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function circle_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const circle = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = circle_objectWithoutProperties(_ref, circle_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/clipboard.svg
var clipboard_excluded = ["styles"];
function clipboard_extends() { clipboard_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clipboard_extends.apply(this, arguments); }
function clipboard_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = clipboard_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function clipboard_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const clipboard = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = clipboard_objectWithoutProperties(_ref, clipboard_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", clipboard_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M22 2a2 2 0 012 2h4a2 2 0 012 2v26a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h4a2 2 0 012-2h8zM12 5H8a1 1 0 00-.993.883L7 6v26a1 1 0 00.883.993L8 33h20a1 1 0 00.993-.883L29 32V6a1 1 0 00-.883-.993L28 5h-4a2 2 0 01-2 2h-8a2 2 0 01-2-2zm4.266 10.745l.04.087L19.18 23.9l2.114-3.133a.498.498 0 01.316-.21l.098-.01H26a.5.5 0 01.09.992l-.09.008-4.025-.001-2.52 3.735a.5.5 0 01-.846-.029l-.039-.083-2.743-7.703-1.387 3.754a.5.5 0 01-.38.319l-.089.008H10a.5.5 0 01-.09-.992l.09-.008 3.623-.001 1.743-4.718a.5.5 0 01.9-.082zM22 3h-8a1 1 0 00-.993.883L13 4v1a1 1 0 00.883.993L14 6h8a1 1 0 00.993-.883L23 5V4a1 1 0 00-.883-.993L22 3z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/clock.svg
var clock_excluded = ["styles"];
function clock_extends() { clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_extends.apply(this, arguments); }
function clock_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = clock_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function clock_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const clock = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = clock_objectWithoutProperties(_ref, clock_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", clock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.333 60c0 29.455-23.878 53.333-53.333 53.333S6.667 89.455 6.667 60 30.545 6.667 60 6.667 113.333 30.545 113.333 60zM60 10c27.614 0 50 22.386 50 50s-22.386 50-50 50-50-22.386-50-50c.03-27.602 22.398-49.97 50-50zm0 18.33c.818 0 1.499.59 1.64 1.368l.027.3V59.31l19.537 19.518c.58.579.644 1.477.194 2.126l-.192.232a1.667 1.667 0 01-2.127.193l-.23-.192-20.027-20.008a1.667 1.667 0 01-.468-.916l-.02-.263V29.997c0-.92.746-1.666 1.666-1.666z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/close.svg
var close_excluded = ["styles"];
function close_extends() { close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }
function close_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = close_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function close_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const svg_close = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = close_objectWithoutProperties(_ref, close_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", close_extends({
    viewBox: "0 0 44 44"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M36.5 4.6a2.05 2.05 0 012.9 2.9L24.9 22l14.5 14.5a2.05 2.05 0 01-2.9 2.9L22 24.9 7.5 39.4a2.05 2.05 0 01-2.9-2.9L19.1 22 4.6 7.5a2.05 2.05 0 012.9-2.9L22 19.1 36.5 4.6z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/doctor.svg
var doctor_excluded = ["styles"];
function doctor_extends() { doctor_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return doctor_extends.apply(this, arguments); }
function doctor_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = doctor_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function doctor_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const doctor = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = doctor_objectWithoutProperties(_ref, doctor_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", doctor_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M15.5 13a2.5 2.5 0 00-.5 4.95V19a4 4 0 11-8 0v-5.025A6.504 6.504 0 0013 7.5v-6c0-.828-.672-1.5-1.5-1.5h-2a.5.5 0 000 1h2a.5.5 0 01.5.5v6a5.5 5.5 0 01-11 0v-6a.5.5 0 01.5-.5h2a.5.5 0 000-1h-2C.672 0 0 .672 0 1.5v6a6.504 6.504 0 006 6.475V19a5 5 0 0010 0v-1.05a2.5 2.5 0 00-.5-4.95zm0 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/dog-food.svg
var dog_food_excluded = ["styles"];
function dog_food_extends() { dog_food_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_food_extends.apply(this, arguments); }
function dog_food_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = dog_food_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function dog_food_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const dog_food = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = dog_food_objectWithoutProperties(_ref, dog_food_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", dog_food_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M32.374 9.061a6.28 6.28 0 00-3.998-4.678A6.284 6.284 0 0022.5.251a6.183 6.183 0 00-3.75 1.27A6.184 6.184 0 0015 .251a6.282 6.282 0 00-5.87 4.132 6.288 6.288 0 00-4 4.678 3.756 3.756 0 00-3.005 2.953l-2.1 10.487A1.252 1.252 0 001.249 24h35.002a1.25 1.25 0 001.223-1.5l-2.1-10.487a3.756 3.756 0 00-3-2.953zM10.411 6.607c.471-.105.84-.473.945-.947a3.722 3.722 0 012.726-2.798 3.715 3.715 0 013.724 1.184 1.29 1.29 0 001.889 0 3.715 3.715 0 013.724-1.184 3.722 3.722 0 012.726 2.798c.105.474.473.842.944.947A3.752 3.752 0 0129.782 9H7.718a3.752 3.752 0 012.693-2.393zM2.775 21.5l1.798-9c.12-.58.632-1 1.228-.998h25.898a1.25 1.25 0 011.228.998l1.798 9H2.775z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/facebook.svg
var facebook_excluded = ["styles"];
function facebook_extends() { facebook_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_extends.apply(this, arguments); }
function facebook_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = facebook_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function facebook_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const facebook = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = facebook_objectWithoutProperties(_ref, facebook_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", facebook_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("defs", null, /*#__PURE__*/external_react_default().createElement("path", {
    id: "prefix__a",
    d: "M.002.001H32v31.805H.002z"
  })), /*#__PURE__*/external_react_default().createElement("g", {
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/external_react_default().createElement("mask", {
    id: "prefix__b"
  }, /*#__PURE__*/external_react_default().createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16c0 7.986 5.851 14.605 13.5 15.806V20.625H9.437V16H13.5v-3.525c0-4.01 2.389-6.225 6.043-6.225 1.751 0 3.582.313 3.582.313V10.5h-2.018c-1.987 0-2.607 1.233-2.607 2.499V16h4.438l-.71 4.625H18.5v11.18C26.149 30.606 32 23.987 32 16",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M22.228 20.625l.71-4.625H18.5v-3.001c0-1.266.62-2.499 2.607-2.499h2.018V6.562s-1.831-.312-3.582-.312c-3.654 0-6.043 2.215-6.043 6.225V16H9.437v4.625H13.5v11.18a16.105 16.105 0 005 .001V20.625h3.728"
  })));
});
;// CONCATENATED MODULE: ./src/icons/svg/fork-spoon.svg
var fork_spoon_excluded = ["styles"];
function fork_spoon_extends() { fork_spoon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fork_spoon_extends.apply(this, arguments); }
function fork_spoon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = fork_spoon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function fork_spoon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const fork_spoon = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = fork_spoon_objectWithoutProperties(_ref, fork_spoon_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", fork_spoon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M6.24 0a.48.48 0 00-.48.48v6.24H3.84V.48a.48.48 0 10-.96 0v6.24H.96V.48a.48.48 0 10-.96 0v8.16c0 1.06.86 1.92 1.92 1.92h.96v3.928a1.436 1.436 0 00-.96 1.352v6.72a1.44 1.44 0 002.88 0v-6.72a1.436 1.436 0 00-.96-1.352V10.56h.96c1.06 0 1.92-.86 1.92-1.92V.48A.48.48 0 006.24 0zm-2.4 22.56a.48.48 0 11-.96 0v-6.72a.48.48 0 11.96 0v6.72zM5.76 8.64c0 .53-.43.96-.96.96H1.92a.96.96 0 01-.96-.96v-.96h4.8v.96zm10.56-1.92c0-3.181-1.504-6.72-3.36-6.72C11.104 0 9.6 3.54 9.6 6.72c0 2.9 1.253 4.485 2.88 4.746v3.022a1.436 1.436 0 00-.96 1.352v6.72a1.44 1.44 0 002.88 0v-6.72a1.436 1.436 0 00-.96-1.352v-3.021c1.627-.261 2.88-1.847 2.88-4.747zm-2.88 15.84a.48.48 0 11-.96 0v-6.72a.48.48 0 11.96 0v6.72zm-.48-12c-1.48 0-2.4-1.47-2.4-3.84 0-3.124 1.474-5.76 2.4-5.76.926 0 2.4 2.637 2.4 5.76 0 2.37-.92 3.84-2.4 3.84z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/heart-outline.svg
var heart_outline_excluded = ["styles"];
function heart_outline_extends() { heart_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_outline_extends.apply(this, arguments); }
function heart_outline_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = heart_outline_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function heart_outline_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const heart_outline = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = heart_outline_objectWithoutProperties(_ref, heart_outline_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", heart_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M7.502 0C4.215 0 0 2.89 0 8.561c0 3.19 2.033 6.122 4.689 8.712 2.656 2.589 6.005 4.856 8.955 6.601a.903.903 0 00.919 0c2.95-1.745 6.299-4.012 8.955-6.601 2.656-2.59 4.689-5.522 4.689-8.712 0-5.67-4.215-8.561-7.502-8.561-3.114 0-5.228 1.36-6.601 3.029C12.73 1.36 10.616 0 7.502 0zm0 1.8c3.141 0 4.783 1.436 5.833 3.16a.9.9 0 001.537 0c1.05-1.724 2.692-3.16 5.833-3.16 2.229 0 5.702 1.973 5.702 6.761 0 2.396-1.657 5.002-4.145 7.427-2.36 2.3-5.398 4.377-8.158 6.039-2.76-1.662-5.798-3.74-8.159-6.039-2.488-2.425-4.144-5.03-4.144-7.427 0-4.788 3.473-6.76 5.701-6.76zM4.2 6.283a.9.9 0 00-.881.722c-.54 2.508.888 4.864 2.25 6.226a.902.902 0 001.313.047.904.904 0 00-.038-1.313c-1.038-1.038-2.1-3.008-1.763-4.576A.9.9 0 004.2 6.283z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/heart.svg
var heart_excluded = ["styles"];
function heart_extends() { heart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_extends.apply(this, arguments); }
function heart_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = heart_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function heart_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const heart = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = heart_objectWithoutProperties(_ref, heart_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", heart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M21.836 40.703l17.88-17.894c4.932-5.046 5.088-13.058.354-18.291-4.733-5.233-12.721-5.88-18.234-1.476C16.317-1.499 8.2-.889 3.423 4.425-1.355 9.74-1.101 17.875 4 22.881l17.836 17.822z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/house.svg
var house_excluded = ["styles"];
function house_extends() { house_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return house_extends.apply(this, arguments); }
function house_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = house_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function house_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const house = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = house_objectWithoutProperties(_ref, house_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", house_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M18.284 4.09l.07.058 13.498 13.498a.5.5 0 01-.638.765l-.069-.057-2.646-2.646.001 14.8c0 .78-.595 1.421-1.356 1.494l-.144.007H9a1.5 1.5 0 01-1.493-1.356L7.5 30.51V15.712l-2.642 2.642a.501.501 0 01-.638.057l-.07-.057a.501.501 0 01-.057-.638l.058-.07L17.646 4.148a.501.501 0 01.638-.057zM24 31.009h3a.5.5 0 00.492-.41l.008-.09v-15.8l-9.5-9.5-9.5 9.502v15.798a.5.5 0 00.41.492l.09.008h9V21a1 1 0 011-1h4a1 1 0 011 1v10.008zM23 21h-4v10h4V21zm-9-1a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm0 1h-2v2h2v-2z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/information.svg
var information_excluded = ["styles"];
function information_extends() { information_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return information_extends.apply(this, arguments); }
function information_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = information_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function information_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const information = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = information_objectWithoutProperties(_ref, information_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", information_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16a16 16 0 01-16 16zm0-30.5C9.992 3.5 3.5 9.992 3.5 18S9.992 32.5 18 32.5 32.5 26.008 32.5 18C32.491 9.996 26.004 3.509 18 3.5zM17.25 25h1.5V15h-1.5v10zm0-12.5h1.5V11h-1.5v1.5z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/leaf.svg
var leaf_excluded = ["styles"];
function leaf_extends() { leaf_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return leaf_extends.apply(this, arguments); }
function leaf_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = leaf_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function leaf_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const leaf = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = leaf_objectWithoutProperties(_ref, leaf_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", leaf_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M31.481 4c.3 0 .537.253.518.551C30.843 22.792 21.637 32 4.519 32l-.087-.007a.517.517 0 01-.43-.544C5.156 13.207 14.363 4 31.481 4zM5.808 30.588l-.227.402c6.613-.165 11.935-1.78 15.977-4.856l-11.42-2.186a68.406 68.406 0 00-4.33 6.64zm8.394-20.534c-5.206 4.09-8.233 10.668-9.101 19.76 2.893-4.995 6.302-9.495 10.227-13.498zm-3.396 13.004L22.57 25.31c2.706-2.356 4.77-5.445 6.197-9.27l-8.978-2.554a65.094 65.094 0 00-8.983 9.572zM29.948 5.025l-.31.012c-5.906.254-10.75 1.702-14.54 4.352l1.09 6.065c4.057-3.987 8.644-7.463 13.76-10.429zm1.004.577l.293-.166A69.075 69.075 0 0020.7 12.707l8.4 2.388c.947-2.821 1.567-6.02 1.862-9.596l-.01.103z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/lock.svg
var lock_excluded = ["styles"];
function lock_extends() { lock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_extends.apply(this, arguments); }
function lock_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = lock_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function lock_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const lock = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = lock_objectWithoutProperties(_ref, lock_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", lock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.333 31.667v21.666h33.334V31.667C76.667 19.7 69.205 10 60 10c-9.205 0-16.667 9.7-16.667 21.667zM80 53.333h18a2 2 0 012 2v56a2 2 0 01-2 2H22a2 2 0 01-2-2v-56a2 2 0 012-2h18V30c0-12.887 8.954-23.333 20-23.333S80 17.113 80 30v23.333zM69.897 94.162c.203.58.101 1.218-.274 1.714s-.978.79-1.62.79H52.008a2.032 2.032 0 01-1.622-.79 1.828 1.828 0 01-.275-1.714l3.384-7.455c-3.041-2.466-4.237-6.426-3.035-10.053.987-3.063 3.551-5.433 6.797-6.28 4.51-1.24 9.317.683 11.545 4.616 2.228 3.933 1.274 8.813-2.292 11.719l3.386 7.453z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/mail.svg
var mail_excluded = ["styles"];
function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }
function mail_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = mail_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function mail_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const mail = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = mail_objectWithoutProperties(_ref, mail_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", mail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M34 7.92v1.71l-15.021 8.901a1.92 1.92 0 01-1.958 0L2 9.63V7.92C2 6.86 2.86 6 3.92 6h28.16C33.14 6 34 6.86 34 7.92zM18 20.08a3.185 3.185 0 01-1.631-.449L2 11.117V28.4c0 1.06.86 1.92 1.92 1.92h28.16c1.06 0 1.92-.86 1.92-1.92V11.117L19.631 19.63a3.185 3.185 0 01-1.631.449z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/minus.svg
var minus_excluded = ["styles"];
function minus_extends() { minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_extends.apply(this, arguments); }
function minus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = minus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function minus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const minus = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = minus_objectWithoutProperties(_ref, minus_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("rect", {
    width: "20",
    height: "1.5",
    y: ".25",
    fillRule: "evenodd",
    rx: ".75",
    transform: "translate(8 17)"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/navigation.svg
var navigation_excluded = ["styles"];
function navigation_extends() { navigation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return navigation_extends.apply(this, arguments); }
function navigation_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = navigation_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function navigation_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const navigation = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = navigation_objectWithoutProperties(_ref, navigation_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", navigation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("defs", null, /*#__PURE__*/external_react_default().createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/external_react_default().createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.082353 0 0 0 0 0.227451 0 0 0 0 0.200000 0 0 0 1.000000 0"
  }))), /*#__PURE__*/external_react_default().createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/external_react_default().createElement("path", {
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/external_react_default().createElement("g", {
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/external_react_default().createElement("g", {
    transform: "translate(6 9)"
  }, /*#__PURE__*/external_react_default().createElement("rect", {
    width: "24",
    height: "1.5",
    rx: ".75"
  }), /*#__PURE__*/external_react_default().createElement("rect", {
    width: "24",
    height: "1.5",
    y: "8",
    rx: ".75"
  }), /*#__PURE__*/external_react_default().createElement("rect", {
    width: "24",
    height: "1.5",
    y: "16",
    rx: ".75"
  })))));
});
;// CONCATENATED MODULE: ./src/icons/svg/parcel.svg
var parcel_excluded = ["styles"];
function parcel_extends() { parcel_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return parcel_extends.apply(this, arguments); }
function parcel_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = parcel_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function parcel_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const parcel = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = parcel_objectWithoutProperties(_ref, parcel_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", parcel_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M25.643 4.354L20.67.377A1.719 1.719 0 0019.599 0H6.686c-.389 0-.766.133-1.07.376L.643 4.356A1.706 1.706 0 000 5.693v16.592A1.711 1.711 0 001.71 24h.003c4.183-.006 18.674-.023 22.857-.009a1.767 1.767 0 001.212-.497c.324-.322.506-.76.504-1.217V5.694a1.709 1.709 0 00-.643-1.34zM13.714 1.143H19.6c.13 0 .256.045.356.126l4.129 3.302h-10.37V1.143zm-7.383.126a.566.566 0 01.355-.126h5.885V4.57H2.202l4.13-3.302zm18.812 21.008a.578.578 0 01-.566.58h-.002c-4.189 0-18.679-.001-22.864.005l-.001-.005a.569.569 0 01-.567-.571V5.714H12.57v4a.571.571 0 101.143 0v-4h11.429v16.563z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/play.svg
var play_excluded = ["styles"];
function play_extends() { play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_extends.apply(this, arguments); }
function play_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = play_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function play_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const play = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = play_objectWithoutProperties(_ref, play_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", play_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M15.654 12.569a.424.424 0 00-.654.355v10.152a.426.426 0 00.424.424.417.417 0 00.23-.069l7.615-5.076a.424.424 0 000-.71l-7.615-5.076zM34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/plus.svg
var plus_excluded = ["styles"];
function plus_extends() { plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }
function plus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = plus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function plus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const plus = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = plus_objectWithoutProperties(_ref, plus_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M18 8a.75.75 0 01.75.75v8.5h8.5a.75.75 0 010 1.5h-8.5v8.5a.75.75 0 01-1.5 0v-8.5h-8.5a.75.75 0 010-1.5h8.5v-8.5A.75.75 0 0118 8z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/refund.svg
var refund_excluded = ["styles"];
function refund_extends() { refund_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return refund_extends.apply(this, arguments); }
function refund_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = refund_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function refund_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const refund = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = refund_objectWithoutProperties(_ref, refund_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", refund_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M3.383 23.625a.5.5 0 00-.766.643l.766-.643zM13.87 1.5C21.402 1.5 27.5 7.549 27.5 15h1C28.5 6.988 21.945.5 13.87.5v1zM27.5 15c0 7.451-6.098 13.5-13.63 13.5v1c8.075 0 14.63-6.488 14.63-14.5h-1zM3.383 6.375A13.653 13.653 0 0113.87 1.5v-1C9.346.5 5.3 2.535 2.617 5.732l.766.643zM13.87 28.5a13.653 13.653 0 01-10.487-4.875l-.766.643A14.653 14.653 0 0013.87 29.5v-1z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M3 6l-.498-.05a.5.5 0 00.548.548L3 6zm5.05-.002a.5.5 0 00-.1-.996l.1.996zM3.998 1.05a.5.5 0 00-.996-.1l.996.1zM3.05 6.498l5-.5-.1-.996-5 .5.1.996zm.448-.448l.5-5-.996-.1-.5 5 .996.1zM14.175 21.86v-1.392c-1.184-.085-2.097-.459-2.737-1.12-.64-.661-.986-1.493-1.04-2.496h1.008c.054.8.315 1.445.784 1.936.48.48 1.142.757 1.985.832v-4.528c-1.142-.245-1.985-.57-2.529-.976-.533-.405-.8-1.045-.8-1.92 0-.843.304-1.525.912-2.048.609-.523 1.414-.805 2.417-.848v-.912h.736V9.3c.96.075 1.711.373 2.255.896.555.523.88 1.21.976 2.064h-.976c-.074-.608-.309-1.093-.704-1.456-.394-.363-.912-.576-1.551-.64v4.112c.565.117 1.034.24 1.408.368.373.117.736.288 1.088.512.352.224.613.517.784.88.17.352.256.779.256 1.28 0 .907-.331 1.653-.992 2.24-.651.576-1.5.885-2.544.928v1.376h-.736zm0-7.728v-3.984c-.726.043-1.302.245-1.729.608-.415.363-.623.832-.623 1.408 0 .555.175.976.527 1.264.363.277.971.512 1.825.704zm.736 5.504c.725-.043 1.322-.261 1.792-.656.48-.405.72-.939.72-1.6 0-.63-.187-1.088-.56-1.376-.374-.299-1.024-.55-1.952-.752v4.384z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/scale.svg
var scale_excluded = ["styles"];
function scale_extends() { scale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return scale_extends.apply(this, arguments); }
function scale_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = scale_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function scale_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const scale = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = scale_objectWithoutProperties(_ref, scale_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", scale_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M16.004 15.864l2.36-4.096 2.36 4.096h-4.72zm-5.1-13.308a.88.88 0 01-.884-.884.88.88 0 01.884-.884.88.88 0 01.884.884.88.88 0 01-.884.884zM5.808 13.444H1.064l2.36-4.096 2.384 4.096zm16 2.772v-.06c0-.02-.02-.04-.02-.06 0 0 0-.02-.02-.02L18.776 10.9V7.16a.395.395 0 00-.336-.392l-7.144-1.18V3.304a1.69 1.69 0 001.28-1.632 1.671 1.671 0 10-3.344 0c0 .788.552 1.456 1.28 1.632v2.164l-7.008-1.14a.361.361 0 00-.316.1.342.342 0 00-.156.296v3.74L.06 13.64c-.04.06-.06.12-.06.196v.1c0 .02.02.02.02.04s.02.04.02.06l.02.04c.708 1.22 1.948 1.948 3.368 1.948s2.656-.728 3.368-1.948l.02-.04c.04-.06.06-.136.06-.196s-.02-.136-.06-.196L3.824 8.468V5.18l6.692 1.084v14.584L5.34 22.856a.375.375 0 00-.236.432c.04.196.196.316.392.316H16.34a.396.396 0 00.392-.316.375.375 0 00-.236-.432L11.3 20.848V6.396l6.672 1.084v3.404L14.98 16.08c-.04.06-.06.12-.06.196 0 .06.02.136.06.196l.02.04a3.86 3.86 0 003.368 1.948c.708 0 1.376-.176 1.948-.512a3.964 3.964 0 001.416-1.436l.02-.04c.02-.02.02-.04.02-.06 0-.02 0-.02.02-.04v-.116c.016-.02.016-.02.016-.04z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/square-fill.svg
var square_fill_excluded = ["styles"];
function square_fill_extends() { square_fill_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return square_fill_extends.apply(this, arguments); }
function square_fill_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = square_fill_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function square_fill_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const square_fill = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = square_fill_objectWithoutProperties(_ref, square_fill_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", square_fill_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M28.266 4H7.733A3.735 3.735 0 004 7.733v20.533A3.733 3.733 0 007.733 32h20.533A3.734 3.734 0 0032 28.266V7.733A3.733 3.733 0 0028.266 4zm-3.533 7.402a.751.751 0 011.189.908l-.068.089L16.11 23.35a.75.75 0 01-1.002.108l-.088-.075-4.863-4.852a.749.749 0 01.975-1.134l.085.072 4.3 4.29 9.216-10.357z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/square.svg
var square_excluded = ["styles"];
function square_extends() { square_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return square_extends.apply(this, arguments); }
function square_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = square_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function square_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const square = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = square_objectWithoutProperties(_ref, square_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", square_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    fillRule: "evenodd",
    d: "M32 7.733v20.533A3.735 3.735 0 0128.266 32H7.733A3.733 3.733 0 014 28.266V7.733A3.735 3.735 0 017.733 4h20.533A3.733 3.733 0 0132 7.733zm-1.5.148A2.381 2.381 0 0028.119 5.5H7.881A2.381 2.381 0 005.5 7.881v20.24A2.38 2.38 0 007.881 30.5h20.238a2.38 2.38 0 002.381-2.38V7.881z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/stand-on-scale.svg
var stand_on_scale_excluded = ["styles"];
function stand_on_scale_extends() { stand_on_scale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stand_on_scale_extends.apply(this, arguments); }
function stand_on_scale_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = stand_on_scale_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function stand_on_scale_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const stand_on_scale = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = stand_on_scale_objectWithoutProperties(_ref, stand_on_scale_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", stand_on_scale_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M18 4a5.002 5.002 0 014.9 4h6.926a2 2 0 011.993 2.166l-1.666 20A2 2 0 0128.16 32H7.84a2 2 0 01-1.993-1.834l-1.666-20a2.002 2.002 0 011.827-2.16l.082-.004L13.1 8A5 5 0 0118 4zm.217 9.995L18 14a5 5 0 01-5-5H6.132l-.041.003c-.512.043-.9.463-.917.963l.003.117 1.667 20a1 1 0 00.878.91L7.84 31h20.32c.48 0 .886-.34.98-.8l.016-.117 1.667-20A1 1 0 0029.826 9H23a4.999 4.999 0 01-4.783 4.995zM21.5 28a.5.5 0 010 1h-7a.5.5 0 010-1h7zM18 5a3.999 3.999 0 00-.5 7.969V10.5a.5.5 0 011 0v2.469A4.001 4.001 0 0018 5z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/star.svg
var star_excluded = ["styles"];
function star_extends() { star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return star_extends.apply(this, arguments); }
function star_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = star_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function star_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const star = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = star_objectWithoutProperties(_ref, star_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M12 0l3.523 8.17L24 9.167l-6.301 6.045L19.416 24 12 19.567 4.584 24l1.717-8.787L0 9.168l8.477-.999z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/truck.svg
var truck_excluded = ["styles"];
function truck_extends() { truck_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return truck_extends.apply(this, arguments); }
function truck_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = truck_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function truck_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const truck = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = truck_objectWithoutProperties(_ref, truck_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", truck_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M24.5 6a1.5 1.5 0 011.493 1.356L26 7.5v3.526h4c.116 0 .227.04.315.113l.062.06 3.503 4.021c.06.069.099.151.115.24l.008.089v9.977a1.5 1.5 0 01-1.356 1.493l-.144.007H28.96A3.5 3.5 0 0122.035 27h-6.07a3.502 3.502 0 01-6.929 0H7.5a1.5 1.5 0 01-1.493-1.356L6 25.5V13H4.5a.5.5 0 010-1H6v-2H3.5a.5.5 0 010-1H6V7H2.5a.5.5 0 010-1h22zm-12 18a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm13 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.501-7.003H26v6.039a3.5 3.5 0 012.968 2.99h3.534a.5.5 0 00.492-.41l.008-.09L33 16.998zM24.5 7H7v2h2.5a.5.5 0 010 1H7v2h1.5a.5.5 0 010 1H7v12.5a.5.5 0 00.41.492L7.5 26h1.535a3.502 3.502 0 016.93 0h6.07A3.504 3.504 0 0125 23.035V7.5a.5.5 0 00-.41-.492L24.5 7zm5.271 5.026H26v3.971h7.001v-.261l-3.23-3.71z",
    fillRule: "nonzero"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/twitter.svg
var twitter_excluded = ["styles"];
function twitter_extends() { twitter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }
function twitter_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = twitter_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function twitter_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const twitter = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = twitter_objectWithoutProperties(_ref, twitter_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M12.063 31.06c12.076 0 18.68-10.005 18.68-18.68 0-.285 0-.568-.019-.85A13.309 13.309 0 0034 8.133c-1.198.531-2.47.88-3.77 1.033a6.59 6.59 0 002.886-3.631c-1.29.765-2.7 1.303-4.17 1.593a6.571 6.571 0 00-11.187 5.988 18.637 18.637 0 01-13.532-6.86 6.572 6.572 0 002.033 8.765 6.516 6.516 0 01-2.98-.822v.083a6.567 6.567 0 005.267 6.436 6.554 6.554 0 01-2.964.113 6.575 6.575 0 006.133 4.56A13.176 13.176 0 012 28.111a18.573 18.573 0 0010.063 2.944"
  }));
});
;// CONCATENATED MODULE: ./src/icons/svg/vegetable.svg
var vegetable_excluded = ["styles"];
function vegetable_extends() { vegetable_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vegetable_extends.apply(this, arguments); }
function vegetable_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = vegetable_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function vegetable_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const vegetable = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = vegetable_objectWithoutProperties(_ref, vegetable_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", vegetable_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M7.764 21.397c-.76-.412-3.596-2.052-5.256-4.396H4.08c.352 0 .64-.288.64-.64a.642.642 0 00-.64-.64H1.768a5.601 5.601 0 01-.404-1.28h4.36c.352 0 .64-.288.64-.64a.642.642 0 00-.64-.64H1.292c.028-.444.104-.868.22-1.28h2.572c.352 0 .64-.288.64-.64a.642.642 0 00-.64-.64h-2.04c1.072-1.908 3.168-3.18 5.632-3.18.032 0 .064 0 .092-.008.028.004.06.008.092.008 3.588 0 6.396 2.688 6.396 6.124-.004 4.124-5.396 7.256-6.492 7.852zM5.436 3.705c-.364-.712-.536-1.44-.496-2.064.876.576 2.244 1.82 1.984 3.848-.58-.416-1.116-1.056-1.488-1.784zm3.44-.32a5.303 5.303 0 011.364-1.696c.012.988-.252 2.588-1.86 3.76-.036-.624.132-1.352.496-2.064zm.508 2.9c2.228-1.816 2.324-4.488 2-5.8a.632.632 0 00-.332-.416.635.635 0 00-.532-.02c-1.092.452-2.132 1.48-2.78 2.756a.12.12 0 01-.016.032C7.008 1.417 5.692.485 4.756.085a.636.636 0 00-.84.344c-.452 1.092-.312 2.5.384 3.86a6.415 6.415 0 001.628 2.044C2.492 7.077 0 9.981 0 13.549c0 .064.004.124.008.188-.004.024-.008.044-.008.068 0 .044.004.092.012.132.292 4.576 5.668 7.788 7.06 8.544l.056.548a.638.638 0 00.636.572.638.638 0 00.636-.572l.056-.548c1.432-.776 7.076-4.148 7.076-8.932 0-3.648-2.6-6.6-6.148-7.264z"
  }));
});
;// CONCATENATED MODULE: ./src/icons/Icon.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Icon = ({"kale-3":"r39VCY","kale3":"r39VCY","white":"tnCLTb","charcoal-3":"LEpjfa","charcoal3":"LEpjfa","charcoal-1":"NQImBp","charcoal1":"NQImBp","carrot-2":"kiMyfs","carrot2":"kiMyfs","gunmetal":"fVtx7p","bluey-gray":"uqBfje","blueyGray":"uqBfje","salmon":"GqdDMb"});
;// CONCATENATED MODULE: ./src/icons/withIconProps.tsx
function withIconProps_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withIconProps_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withIconProps_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withIconProps_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = withIconProps_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function withIconProps_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function withIconProps(IconComponent) {
    var Wrapped = function(props) {
        var WithFillProp = function(_param) {
            var fill = _param.fill, _param_size = _param.size, size = _param_size === void 0 ? 24 : _param_size, className = _param.className, otherProps = withIconProps_object_without_properties(_param, [
                "fill",
                "size",
                "className"
            ]);
            var fillClass = fill ? Icon[fill] : "";
            return /*#__PURE__*/ external_react_default().createElement(IconComponent, withIconProps_object_spread({
                className: external_classnames_default()(fillClass, className),
                fill: fillClass ? undefined : fill,
                height: size
            }, otherProps));
        };
        return /*#__PURE__*/ external_react_default().createElement(WithFillProp, props);
    };
    return Wrapped;
}

;// CONCATENATED MODULE: ./src/icons/PropTypes.tsx

var IconPropTypes = function(param) {
    var children = param.children;
    return /*#__PURE__*/ external_react_default().createElement("div", null, children);
};

;// CONCATENATED MODULE: ./src/icons/index.ts















































/** @deprecated Import `Arrow` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Arrow = withIconProps(arrow);
/** @deprecated Import `Back` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Back = withIconProps(back);
/** @deprecated Import `Blob` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Blob = withIconProps(blob);
/** @deprecated Import `Bolt` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Bolt = withIconProps(bolt);
/** @deprecated Import `BowlSteaming` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var BowlSteaming = withIconProps(bowl_steaming);
/** @deprecated Import `Calendar` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Calendar = withIconProps(calendar);
/** @deprecated Import `Caret` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Caret = withIconProps(caret);
/** @deprecated Import `Carrot` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Carrot = withIconProps(carrot);
/** @deprecated Import `Check` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Check = withIconProps(check);
/** @deprecated Import `CheckCircle` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CheckCircle = withIconProps(check_circle);
/** @deprecated Import `Chevron` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Chevron = withIconProps(chevron);
/** @deprecated Import `Circle` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Circle = withIconProps(circle);
/** @deprecated Import `CircleAlert` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleAlert = withIconProps(circle_alert);
/** @deprecated Import `CircleCross` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleCross = withIconProps(circle_cross);
/** @deprecated Import `CircleFill` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleFill = withIconProps(circle_fill);
/** @deprecated Import `CircleMinus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CircleMinus = withIconProps(circle_minus);
/** @deprecated Import `CirclePlus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var CirclePlus = withIconProps(circle_plus);
/** @deprecated Import `Clipboard` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Clipboard = withIconProps(clipboard);
/** @deprecated Import `Clock` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Clock = withIconProps(clock);
/** @deprecated Import `Close` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Close = withIconProps(svg_close);
/** @deprecated Import `Doctor` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Doctor = withIconProps(doctor);
/** @deprecated Import `DogFood` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var DogFood = withIconProps(dog_food);
/** @deprecated Import `Facebook` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Facebook = withIconProps(facebook);
/** @deprecated Import `ForkSpoon` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var ForkSpoon = withIconProps(fork_spoon);
/** @deprecated Import `Heart` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Heart = withIconProps(heart);
/** @deprecated Import `HeartOutline` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var HeartOutline = withIconProps(heart_outline);
/** @deprecated Import `House` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var HoImport = withIconProps(house);
/** @deprecated Import `Information` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Information = withIconProps(information);
/** @deprecated Import `Leaf` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Leaf = withIconProps(leaf);
/** @deprecated Import `Lock` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Lock = withIconProps(lock);
/** @deprecated Import `Mail` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Mail = withIconProps(mail);
/** @deprecated Import `Minus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Minus = withIconProps(minus);
/** @deprecated Import `Navigation` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Navigation = withIconProps(navigation);
/** @deprecated Import `Parcel` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Parcel = withIconProps(parcel);
/** @deprecated Import `Play` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Play = withIconProps(play);
/** @deprecated Import `Plus` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Plus = withIconProps(plus);
/** @deprecated Import `Refund` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Refund = withIconProps(refund);
/** @deprecated Import `Scale` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Scale = withIconProps(scale);
/** @deprecated Import `Square` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Square = withIconProps(square);
/** @deprecated Import `SquareFill` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var SquareFill = withIconProps(square_fill);
/** @deprecated Import `StandOnScale` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var StandOnScale = withIconProps(stand_on_scale);
/** @deprecated Import `Star` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Star = withIconProps(star);
/** @deprecated Import `Truck` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Truck = withIconProps(truck);
/** @deprecated Import `Twitter` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Twitter = withIconProps(twitter);
/** @deprecated Import `Vegetable` from the corgi-x {@link https://corgi-x.tfd.engineering/system/icons | Icons Library}. */ var Vegetable = withIconProps(vegetable);

;// CONCATENATED MODULE: ./src/components/Text/Text.tsx
// TODO: Rework Typography to not return any
// https://app.clubhouse.io/farmersdog/story/42358/Text-types-no-any-type-from-typography-in-Text
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ function Text_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Text_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Text_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Text_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Text_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Text_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Text_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Text_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Text_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Text_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Text_sliced_to_array(arr, i) {
    return Text_array_with_holes(arr) || Text_iterable_to_array_limit(arr, i) || Text_unsupported_iterable_to_array(arr, i) || Text_non_iterable_rest();
}
function Text_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Text_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Text_array_like_to_array(o, minLen);
}



var TextVariants = [
    "heading-72",
    "heading-52",
    "heading-40",
    "heading-28",
    "heading-22",
    "heading-21",
    "heading-16",
    "heading-12",
    "body-21",
    "body-16",
    "body-12",
    "article-21",
    "article-20",
    "article-16",
    "article-12"
];
/**
 * ## Text
 *
 * The `Text` component renders textual content following the CORGI styles.
 *
 * ### Usage
 *
 * - Use this component to render block of texts.
 * - Follow the designer guidelines to choose the right `variant`.
 * - Make sure you use the proper semantic HTML tags for the `as` property.
 *
 * ### Example
 *
 * ```jsx
 * import { Text } from '@farmersdog/corgi';
 *
 * function () {
 *  return (
 *    <Text color="charcoal-3" as="h1" bold variant="heading-52">
 *      This is a bold title!
 *    </Text>
 *  )
 * }
 * ```
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/text | Text} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Text_Text = function(_param) {
    var tmp = _param.as, HTMLElement = tmp === void 0 ? "span" : tmp, _param_variant = _param.variant, variant = _param_variant === void 0 ? "heading-52" : _param_variant, bold = _param.bold, fontStyle = _param.fontStyle, color = _param.color, className = _param.className, children = _param.children, props = Text_object_without_properties(_param, [
        "as",
        "variant",
        "bold",
        "fontStyle",
        "color",
        "className",
        "children"
    ]);
    var _variant_split = Text_sliced_to_array(variant.split("-"), 2), type = _variant_split[0], size = _variant_split[1];
    var weight = "normal";
    if (bold) {
        if (type === "heading" && Number(size) > 22) {
            weight = "dynamicBold";
        } else {
            weight = "bold";
        }
    }
    // @ts-expect-error not sure why this works at runtime, but typescript isn't happy
    var typographyStyles = typography_namespaceObject[type].create({
        size: size,
        weight: weight,
        fontStyle: fontStyle,
        color: color
    });
    return /*#__PURE__*/ external_react_namespaceObject.createElement(HTMLElement, Text_object_spread({
        className: external_classnames_default()(className, typographyStyles.className)
    }, props), children);
};

;// CONCATENATED MODULE: ./src/components/LabeledSelector/LabeledSelector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const LabeledSelector = ({"container":"Nfs3ox","input":"d_ALhl","label":"h9TNWk","disabled":"w1GYdj","kale-3":"r1s09c","kale3":"r1s09c","charcoal-3":"BIFFTl","charcoal3":"BIFFTl","charcoal-1":"I5irap","charcoal1":"I5irap"});
;// CONCATENATED MODULE: ./src/components/LabeledSelector/LabeledSelector.tsx
function LabeledSelector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LabeledSelector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LabeledSelector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LabeledSelector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = LabeledSelector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LabeledSelector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









/**
 * Component to attach a label to a design radio or checkbox
 *
 * @deprecated Use corgi-x {@link https://corgi-x.tfd.engineering/components/radiobutton | RadioButton} or {@link https://corgi-x.tfd.engineering/components/checkbox | Checkbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var LabeledSelector_LabeledSelector = withRef(function(_param) {
    var children = _param.children, stateProp = _param.state, checked = _param.checked, type = _param.type, _param_color = _param.color, color = _param_color === void 0 ? "kale-3" : _param_color, className = _param.className, forwardedRef = _param.forwardedRef, props = LabeledSelector_object_without_properties(_param, [
        "children",
        "state",
        "checked",
        "type",
        "color",
        "className",
        "forwardedRef"
    ]);
    var isCheckbox = type === "checkbox";
    var getDesign = isCheckbox ? getCheckboxDesign_getCheckboxDesign : getRadioDesign_getRadioDesign;
    return /*#__PURE__*/ external_react_namespaceObject.createElement(Selector_Selector, LabeledSelector_object_spread({
        type: type,
        checked: checked,
        className: external_classnames_default()(className, LabeledSelector.container),
        ref: forwardedRef
    }, props), function(state) {
        var inputDesign = getDesign({
            state: stateProp !== null && stateProp !== void 0 ? stateProp : state,
            checked: checked
        });
        return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_namespaceObject.Fragment, null, /*#__PURE__*/ external_react_namespaceObject.createElement("span", {
            className: external_classnames_default()(LabeledSelector.input, inputDesign, LabeledSelector[type])
        }, isCheckbox && /*#__PURE__*/ external_react_namespaceObject.createElement(Check, {
            fill: "white",
            size: 12
        })), /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
            as: "span",
            variant: "heading-16",
            className: external_classnames_default()(LabeledSelector.label, LabeledSelector[state], LabeledSelector[type], LabeledSelector[color])
        }, children));
    });
});

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Checkbox = ({"container":"q0s1q6","wrap":"rcYZMw"});
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.tsx
function Checkbox_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Checkbox_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Checkbox_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Checkbox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Checkbox_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Checkbox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Checkbox_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Checkbox_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Checkbox_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/checkbox | Checkbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Checkbox_Checkbox = withRef(function(_param) {
    var label = _param.label, _param_labelWrap = _param.labelWrap, labelWrap = _param_labelWrap === void 0 ? false : _param_labelWrap, forwardedRef = _param.forwardedRef, props = Checkbox_object_without_properties(_param, [
        "label",
        "labelWrap",
        "forwardedRef"
    ]);
    return /*#__PURE__*/ external_react_default().createElement(LabeledSelector_LabeledSelector, Checkbox_object_spread_props(Checkbox_object_spread({
        className: external_classnames_default()(Checkbox.container, Checkbox_define_property({}, Checkbox.wrap, labelWrap))
    }, props), {
        type: "checkbox",
        ref: forwardedRef
    }), label);
});

;// CONCATENATED MODULE: ./src/components/Checkbox/CheckboxView.tsx



var CheckboxView = function(param) {
    var state = param.state, checked = param.checked;
    var inputDesign = getCheckboxDesign_getCheckboxDesign({
        state: state !== null && state !== void 0 ? state : "normal",
        checked: checked
    });
    return /*#__PURE__*/ external_react_namespaceObject.createElement("span", {
        className: inputDesign
    }, " ", /*#__PURE__*/ external_react_namespaceObject.createElement(Check, {
        fill: "white",
        size: 12
    }));
};

;// CONCATENATED MODULE: ./src/components/Checkbox/index.ts



;// CONCATENATED MODULE: ./src/util/browserOnly.ts
/**
 * Safely execute browser only code.
 *
 * @deprecated Use `browserOnly` from `@farmersdog/utils`.
 */ var browserOnly = function(fn, fallback) {
    if (typeof window !== "undefined") {
        return fn(window, document);
    }
    if (fallback) return fallback();
    return;
};

;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/spring-down.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spring_down = ({"entering":"LF8j6O","spring-down-in":"FwCjzI","springDownIn":"FwCjzI","fade-in":"jpVPMw","fadeIn":"jpVPMw","exiting":"gfpXFs","spring-down-out":"SsV1eD","springDownOut":"SsV1eD","fade-out":"e7e9nr","fadeOut":"e7e9nr"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/spring-up.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spring_up = ({"entering":"F6SMI1","spring-up-in":"eUHVgE","springUpIn":"eUHVgE","fade-in":"OoQwUE","fadeIn":"OoQwUE","exiting":"lU3Ko1","spring-up-out":"wHJaHQ","springUpOut":"wHJaHQ","fade-out":"N7V8bc","fadeOut":"N7V8bc"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/slide-down.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const slide_down = ({"entering":"m8i25R","slide-down-in":"tftlzT","slideDownIn":"tftlzT","fade-in":"kK01Up","fadeIn":"kK01Up","exiting":"UAJhTf","slide-down-out":"GHp3w3","slideDownOut":"GHp3w3","fade-out":"VLRhAg","fadeOut":"VLRhAg"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/slide-up.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const slide_up = ({"entering":"gaLEYt","slide-up-in":"nEqnNf","slideUpIn":"nEqnNf","fade-in":"pKgkF3","fadeIn":"pKgkF3","exiting":"b5QQxQ","slide-up-out":"hFNkqF","slideUpOut":"hFNkqF","fade-out":"qk8aE9","fadeOut":"qk8aE9"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/fade.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const fade = ({"entering":"yMAEcN","fade-in":"FNnso6","fadeIn":"FNnso6","exiting":"kV4tgr","fade-out":"iC8m0Y","fadeOut":"iC8m0Y"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitionStyles/base.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const transitionStyles_base = ({"init":"MAu91p","entered":"txDvaL","exited":"QX2_pe"});
;// CONCATENATED MODULE: ./src/components/ContentReveal/transitions.ts






/* harmony default export */ const transitions = ({
    springDown: {
        transitions: spring_down,
        defaultOut: spring_up,
        duration: 600
    },
    springUp: {
        transitions: spring_up,
        defaultOut: spring_down,
        duration: 600
    },
    slideDown: {
        transitions: slide_down,
        defaultOut: slide_up,
        duration: 300
    },
    slideUp: {
        transitions: slide_up,
        defaultOut: slide_down,
        duration: 300
    },
    fade: {
        transitions: fade,
        defaultOut: fade,
        duration: 300
    },
    base: {
        transitions: transitionStyles_base
    }
});

;// CONCATENATED MODULE: ./src/components/ContentReveal/ContentReveal.tsx
function ContentReveal_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ContentReveal_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ContentReveal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentReveal_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ContentReveal_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ContentReveal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentReveal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ContentReveal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ContentReveal_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ContentReveal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ContentReveal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ContentReveal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ContentReveal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ContentReveal_sliced_to_array(arr, i) {
    return ContentReveal_array_with_holes(arr) || ContentReveal_iterable_to_array_limit(arr, i) || ContentReveal_unsupported_iterable_to_array(arr, i) || ContentReveal_non_iterable_rest();
}
function ContentReveal_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ContentReveal_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContentReveal_array_like_to_array(o, minLen);
}





var useState = external_react_namespaceObject.useState, useEffect = external_react_namespaceObject.useEffect;
var ContentRevealAnimations = [
    "springUp",
    "springDown",
    "slideUp",
    "slideDown",
    "fade"
];
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/contentreveal | ContentReveal} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ContentReveal = function(_param) {
    var inAnimation = _param.inAnimation, _param_inDelay = _param.inDelay, inDelay = _param_inDelay === void 0 ? 0 : _param_inDelay, outAnimation = _param.outAnimation, _param_outDelay = _param.outDelay, outDelay = _param_outDelay === void 0 ? 0 : _param_outDelay, children = _param.children, props = ContentReveal_object_without_properties(_param, [
        "inAnimation",
        "inDelay",
        "outAnimation",
        "outDelay",
        "children"
    ]);
    var _useState = ContentReveal_sliced_to_array(useState(false), 2), inState = _useState[0], setInState = _useState[1];
    var inTransition = transitions[inAnimation];
    var outTransition = outAnimation ? transitions[outAnimation] : ContentReveal_object_spread_props(ContentReveal_object_spread({}, inTransition), {
        transitions: inTransition.defaultOut
    });
    var stateTransitions = ContentReveal_object_spread({
        entering: inTransition.transitions.entering,
        exiting: outTransition.transitions.exiting,
        init: transitions.base.transitions.init
    }, transitions.base.transitions);
    useEffect(function() {
        var delayTimeout;
        if (props.in !== inState) {
            delayTimeout = browserOnly(function(window) {
                return window.setTimeout(function() {
                    setInState(props.in);
                    clearTimeout(delayTimeout);
                    delayTimeout = undefined;
                }, props.in ? inDelay : outDelay);
            });
        }
        return function() {
            clearTimeout(delayTimeout);
            delayTimeout = undefined;
        };
    }, [
        inDelay,
        inState,
        outDelay,
        props.in
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_transition_group_namespaceObject.Transition, {
        timeout: {
            enter: inTransition.duration,
            exit: outTransition.duration
        },
        in: inState
    }, function(state) {
        var child = external_react_namespaceObject.Children.only(children);
        if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) {
            return child;
        }
        var className = external_classnames_default()(child.props.className, stateTransitions.init, stateTransitions[state]);
        return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
            className: className
        });
    });
};

;// CONCATENATED MODULE: ./src/components/ContentReveal/index.ts


;// CONCATENATED MODULE: ./src/components/LiveMessage/LiveMessage.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const LiveMessage = ({"message":"_gFTaX","invalid":"jBfybM"});
;// CONCATENATED MODULE: ./src/components/LiveMessage/LiveMessage.tsx
function LiveMessage_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LiveMessage_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LiveMessage_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LiveMessage_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = LiveMessage_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LiveMessage_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/**
 * The valid string values for the aria-live attribute. This is used to indicate
 * to screen readers how frequently they should announce new message content.
 */ var AriaLiveAttributes = [
    "off",
    "assertive",
    "polite"
];
/**
 * An WCAG compliant component for rendering messages whose content is dynamic.
 * It's content can be visually show or visually hidden. Commonly used for
 * inline error messages.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/statusmessage | StatusMessage} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var LiveMessage_LiveMessage = function(_param) {
    var id = _param.id, invalid = _param.invalid, _param_hidden = _param.hidden, hidden = _param_hidden === void 0 ? false : _param_hidden, className = _param.className, children = _param.children, props = LiveMessage_object_without_properties(_param, [
        "id",
        "invalid",
        "hidden",
        "className",
        "children"
    ]);
    var _obj;
    return /*#__PURE__*/ external_react_namespaceObject.createElement(ContentReveal, {
        inAnimation: "fade",
        outAnimation: "fade",
        in: !hidden
    }, /*#__PURE__*/ external_react_namespaceObject.createElement("div", LiveMessage_object_spread({
        id: id,
        role: "status",
        className: external_classnames_default()(className, LiveMessage.message, (_obj = {}, LiveMessage_define_property(_obj, LiveMessage.invalid, invalid), LiveMessage_define_property(_obj, accessibility.hidden, hidden), _obj))
    }, props), children));
};

;// CONCATENATED MODULE: ./src/components/LiveMessage/index.ts


;// CONCATENATED MODULE: ./src/components/FormControl/FormControl.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const FormControl = ({"container":"L0wV3v","message":"a_2Xxn"});
;// CONCATENATED MODULE: ./src/components/FormControl/FormControl.tsx
function FormControl_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormControl_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = FormControl_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function FormControl_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var FormControl_typography = heading.create({
    size: 16,
    color: "charcoal-1"
});
/**
 * This component is used for including inline error messages along with form
 * elements.
 *
 * https://www.w3.org/WAI/tutorials/forms/notifications/#listing-errors
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/formcontrol | FormControl} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var FormControl_FormControl = function(_param) {
    var children = _param.children, message = _param.message, invalid = _param.invalid, className = _param.className, _param_disableAriaProps = _param.disableAriaProps, disableAriaProps = _param_disableAriaProps === void 0 ? false : _param_disableAriaProps, props = FormControl_object_without_properties(_param, [
        "children",
        "message",
        "invalid",
        "className",
        "disableAriaProps"
    ]);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var hidden = !message;
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(FormControl.container, className)
    }, /*#__PURE__*/ external_react_default().isValidElement(children) && !disableAriaProps ? /*#__PURE__*/ external_react_default().cloneElement(children, (_obj = {
        // @ts-ignore
        invalid: invalid
    }, FormControl_define_property(_obj, "aria-describedby", id), FormControl_define_property(_obj, "aria-invalid", invalid), _obj)) : children, /*#__PURE__*/ external_react_default().createElement(LiveMessage_LiveMessage, {
        id: id,
        "aria-live": props["aria-live"],
        hidden: hidden,
        invalid: invalid,
        className: external_classnames_default()(FormControl_typography.className, FormControl.message)
    }, message));
};
FormControl_FormControl.defaultProps = FormControl_define_property({}, "aria-live", "polite");

;// CONCATENATED MODULE: ./src/components/FormControl/index.ts


;// CONCATENATED MODULE: ./src/util/getHasValue.ts
/**
 * Return if an input has a value. Inputs can have values of number type which
 * can make naive `Boolean` coercion incorrect.
 *
 * @example
 *
 *   hasValue(null) // false
 *   hasValue('') // false
 *   hasValue(0) // true
 *   hasValue(undefined) // false
 *   hasValue('some string') // true
 *
 */ var getHasValue = function(value) {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    if (typeof value === "number") {
        return Number.isFinite(value);
    }
    return Boolean(value);
};

;// CONCATENATED MODULE: ./src/components/Input/Input.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Input = ({"input":"oL9_CB"});
;// CONCATENATED MODULE: ./src/components/Input/Input.tsx
function Input_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Input_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Input_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Input_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Input_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Input_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Input_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Input_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Input_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Input_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Input_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Input_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Input_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Input_sliced_to_array(arr, i) {
    return Input_array_with_holes(arr) || Input_iterable_to_array_limit(arr, i) || Input_unsupported_iterable_to_array(arr, i) || Input_non_iterable_rest();
}
function Input_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Input_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Input_array_like_to_array(o, minLen);
}






var Input_typography = heading.create({
    size: 16
});
var InputComponent = function(_param) {
    var label = _param.label, className = _param.className, invalid = _param.invalid, highlighted = _param.highlighted, onChange = _param.onChange, onBlur = _param.onBlur, onFocus = _param.onFocus, forwardedRef = _param.forwardedRef, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = Input_object_without_properties(_param, [
        "label",
        "className",
        "invalid",
        "highlighted",
        "onChange",
        "onBlur",
        "onFocus",
        "forwardedRef",
        "hideLabel"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = Input_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid,
        highlighted: highlighted
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _props_value;
    var _React_useState = Input_sliced_to_array(external_react_namespaceObject.useState((_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : ""), 2), value = _React_useState[0], setValue = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        if (props.value !== undefined && props.value !== null) {
            setValue(props.value);
        }
    }, [
        props.value,
        value
    ]);
    var handleChange = function(event) {
        setValue(event.target.value);
    };
    return /*#__PURE__*/ external_react_namespaceObject.createElement(BorderLabel_BorderLabel, {
        in: props.type === "date" || state === "focus" || state === "invalid" || getHasValue(value),
        text: label || props.name || "",
        state: state,
        className: className,
        hideLabel: hideLabel
    }, /*#__PURE__*/ external_react_namespaceObject.createElement("input", Input_object_spread_props(Input_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()(Input.input, Input_typography.className),
        onChange: interceptEvent(handleChange, onChange),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        "aria-invalid": invalid
    }, props), {
        // Order is important, we want to overwrite value
        value: value,
        placeholder: undefined
    })));
};
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/input | Input} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Input_Input = withRef(InputComponent);

;// CONCATENATED MODULE: ./src/components/Input/index.ts


;// CONCATENATED MODULE: ./src/components/LabeledSelector/index.ts


;// CONCATENATED MODULE: ./src/components/Selector/index.ts


;// CONCATENATED MODULE: ./src/components/SelectorGroup/getInitialValue.ts
/**
 * Get the initial state value according to the input props. Initial state
 * depends on whether or not multiple selections are available as well as
 * whether or not a `value` prop is passed in.
 */ function getInitialValue(value, multi) {
    var isControlled = typeof value !== "undefined";
    if (isControlled) {
        return value;
    }
    if (multi) {
        return [];
    }
    return undefined;
}
/* harmony default export */ const SelectorGroup_getInitialValue = (getInitialValue);

;// CONCATENATED MODULE: ./src/components/SelectorGroup/includesCastValue.ts
/**
 * Returns a boolean indicating whether or not the array contains an item that
 * matches the stringified argument.
 */ function includesCastValue(value, child) {
    if (!Array.isArray(value)) {
        return false;
    }
    return typeof value.find(function(value) {
        return String(value) === String(child);
    }) !== "undefined";
}
/* harmony default export */ const SelectorGroup_includesCastValue = (includesCastValue);

;// CONCATENATED MODULE: ./src/components/SelectorGroup/SelectorGroup.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SelectorGroup = ({"fieldset":"K434KY","message":"WrstOy"});
;// CONCATENATED MODULE: ./src/components/SelectorGroup/SelectorGroup.tsx
function SelectorGroup_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SelectorGroup_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function SelectorGroup_array_without_holes(arr) {
    if (Array.isArray(arr)) return SelectorGroup_array_like_to_array(arr);
}
function SelectorGroup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SelectorGroup_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SelectorGroup_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SelectorGroup_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SelectorGroup_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SelectorGroup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SelectorGroup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function SelectorGroup_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = SelectorGroup_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SelectorGroup_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SelectorGroup_sliced_to_array(arr, i) {
    return SelectorGroup_array_with_holes(arr) || SelectorGroup_iterable_to_array_limit(arr, i) || SelectorGroup_unsupported_iterable_to_array(arr, i) || SelectorGroup_non_iterable_rest();
}
function SelectorGroup_to_consumable_array(arr) {
    return SelectorGroup_array_without_holes(arr) || SelectorGroup_iterable_to_array(arr) || SelectorGroup_unsupported_iterable_to_array(arr) || SelectorGroup_non_iterable_spread();
}
function SelectorGroup_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SelectorGroup_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SelectorGroup_array_like_to_array(o, minLen);
}









var SelectorGroup_typography = heading.create({
    size: 16,
    color: "charcoal-1"
});
/**
 * Component to manage the state of multiple input children.  This component will
 * manage each child's props for: name, onChange, and checked.
 *
 * This allows the shared props to be set in one spot and automatically passed down.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/fieldset | Fieldset} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var SelectorGroup_SelectorGroup = function(_param) {
    var children = _param.children, name = _param.name, type = _param.type, legend = _param.legend, showLegend = _param.showLegend, className = _param.className, inputsClassName = _param.inputsClassName, propValue = _param.value, onChange = _param.onChange, invalid = _param.invalid, message = _param.message, props = SelectorGroup_object_without_properties(_param, [
        "children",
        "name",
        "type",
        "legend",
        "showLegend",
        "className",
        "inputsClassName",
        "value",
        "onChange",
        "invalid",
        "message"
    ]);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var messageHidden = !message;
    var multi = type === "checkbox" || Boolean(external_react_default().Children.toArray(children).find(function(child) {
        return /*#__PURE__*/ external_react_default().isValidElement(child) && child.props.type === "checkbox";
    }));
    var _React_useState = SelectorGroup_sliced_to_array(external_react_default().useState(SelectorGroup_getInitialValue(propValue, multi)), 2), internalValue = _React_useState[0], setInternalValue = _React_useState[1];
    var value = typeof propValue !== "undefined" ? propValue : internalValue;
    var handleChange = function(e) {
        var eventValue = e.target.value;
        if (!(multi && Array.isArray(value))) {
            setInternalValue(eventValue);
            return;
        }
        var nextValue = SelectorGroup_includesCastValue(value, eventValue) ? value.filter(function(lastValue) {
            return String(lastValue) !== eventValue;
        }) : SelectorGroup_to_consumable_array(value).concat([
            eventValue
        ]);
        setInternalValue(nextValue);
    };
    var getChecked = function(childValue) {
        if (multi && Array.isArray(value)) {
            return SelectorGroup_includesCastValue(value, childValue);
        }
        return String(value) === String(childValue);
    };
    return /*#__PURE__*/ external_react_default().createElement("fieldset", SelectorGroup_object_spread({
        className: external_classnames_default()(SelectorGroup.fieldset, className)
    }, props), /*#__PURE__*/ external_react_default().createElement("legend", {
        className: external_classnames_default()(SelectorGroup_define_property({}, accessibility.hidden, !showLegend))
    }, legend), /*#__PURE__*/ external_react_default().createElement("div", {
        className: inputsClassName
    }, external_react_default().Children.map(children, function(child) {
        if (!/*#__PURE__*/ external_react_default().isValidElement(child)) return child;
        return /*#__PURE__*/ external_react_default().cloneElement(child, {
            name: name,
            onChange: interceptEvent(child.props.onChange, handleChange, onChange),
            checked: getChecked(child.props.value),
            type: type
        });
    })), /*#__PURE__*/ external_react_default().createElement(LiveMessage_LiveMessage, {
        id: id,
        hidden: messageHidden,
        "aria-live": props["aria-live"],
        invalid: invalid,
        className: external_classnames_default()(SelectorGroup_typography.className, SelectorGroup.message)
    }, message));
};

;// CONCATENATED MODULE: ./src/components/SelectorGroup/index.ts


;// CONCATENATED MODULE: external "lodash/noop"
const noop_namespaceObject = require("lodash/noop");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop_namespaceObject);
;// CONCATENATED MODULE: external "lodash/omit"
const omit_namespaceObject = require("lodash/omit");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit_namespaceObject);
;// CONCATENATED MODULE: external "react-dom"
const external_react_dom_namespaceObject = require("react-dom");
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_namespaceObject);
;// CONCATENATED MODULE: ./src/components/Lightbox/Lightbox.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Lightbox = ({"tfd-lightbox":"zLBb0J","tfdLightbox":"zLBb0J","has-lightbox":"ioHTY4","hasLightbox":"ioHTY4","container":"dWlauE","background":"yiimnQ","disableAnimation":"ekSfoP","content":"i0x9Jz","autoBox":"greOkd"});
;// CONCATENATED MODULE: ./src/components/Lightbox/dom.ts

var DOCUMENT_ELEMENT;
var DOCUMENT;
if (typeof window !== "undefined") {
    DOCUMENT_ELEMENT = window.document.documentElement;
    DOCUMENT = window.document;
}
var lightboxes = 0;
var previousPadding = null;
/**
 * Initialize the body element by setting a padding right of the same width as
 * any active body scrollbars.
 */ function setScrollBarGap() {
    if (!(DOCUMENT && DOCUMENT_ELEMENT && typeof window !== "undefined")) {
        return;
    }
    var gap = window.innerWidth - DOCUMENT_ELEMENT.clientWidth;
    previousPadding = DOCUMENT.body.style.paddingRight;
    DOCUMENT.body.style.paddingRight = "".concat(gap, "px");
}
/**
 * Cleanup the body element by reseting the padding right to the initial stored
 * value.
 */ function unsetScrollBarGap() {
    if (!DOCUMENT || previousPadding === null) {
        return;
    }
    DOCUMENT.body.style.paddingRight = previousPadding;
}
/**
 * Initialize the root dom element by adding a css class. This class is used to
 * add specific overflow and scrolling related css.
 */ var initializeDOM = function() {
    if (lightboxes < 1 && DOCUMENT_ELEMENT) {
        setScrollBarGap();
        DOCUMENT_ELEMENT.classList.add(Lightbox.hasLightbox);
    }
    lightboxes += 1;
};
/**
 * Cleanup the root dom element by removing a css class. This class is used to
 * add specific overflow and scrolling related css. Removal of the class will
 * restore normal scrolling behavior.
 */ var cleanupDOM = function() {
    lightboxes -= 1;
    if (lightboxes < 1 && DOCUMENT_ELEMENT) {
        DOCUMENT_ELEMENT.classList.remove(Lightbox.hasLightbox);
        unsetScrollBarGap();
    }
};
/**
 * Add a new Element with the specified id. If the element already exists, it
 * returns it.
 */ var addDOMElementById = function(id) {
    var tagName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div";
    if (!DOCUMENT) return;
    var el = DOCUMENT.getElementById(id);
    if (!el) {
        el = DOCUMENT.createElement(tagName);
        el.id = id;
        DOCUMENT.body.appendChild(el);
    }
    return el;
};

;// CONCATENATED MODULE: ./src/components/Lightbox/transitions/background.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const transitions_background = ({"entering":"kH7X3P","entered":"Prmd8_","exiting":"EDGR0E"});
;// CONCATENATED MODULE: ./src/components/Lightbox/transitions/content.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const content = ({"entering":"Ekeec6","entered":"UdzmZ5","exiting":"fBKSdE","exited":"OQSZMQ"});
;// CONCATENATED MODULE: external "bowser"
const external_bowser_namespaceObject = require("bowser");
;// CONCATENATED MODULE: ./src/components/Lightbox/device.ts

var hasSupport;
var hasPassiveTouchSupport = function() {
    if (hasSupport !== undefined) return hasSupport;
    try {
        var options = {
            get passive () {
                // This function will be called when the browser attempts to access
                // the passive property.
                hasSupport = true;
                return undefined;
            }
        };
        // Ignore the next lines to set a "fake" event listener
        // @ts-ignore
        window.addEventListener("test", options, options);
        // @ts-ignore
        window.removeEventListener("test", options, options);
    } catch (err) {
        hasSupport = false;
    }
    hasSupport = Boolean(hasSupport);
    return hasSupport;
};
var isIosDevice;
var isIos = function() {
    if (typeof navigator === "undefined") return false;
    if (isIosDevice !== undefined) return isIosDevice;
    var userAgent = navigator.userAgent;
    var deviceInfo = (0,external_bowser_namespaceObject.parse)(userAgent);
    var osName = deviceInfo.os.name || "";
    isIosDevice = osName.toLowerCase() === "ios";
    return isIosDevice;
};

;// CONCATENATED MODULE: ./src/components/Lightbox/blockBodyScroll.ts


/**
 * Imperative effect that blocks scrollling on the body element. The bounds for
 * scrolling are determined by the the height of the content element rectangle
 * compared to the height of container element rectangle. When the content has
 * been scrolled all the way up or down then this effect will block any further
 * scrolling action. Usually used to correct iOS behavior that does not respect
 * body overflow css.
 */ var blockBodyScroll = function(containerElement, contentElement) {
    if (!containerElement || !contentElement || typeof window === "undefined") {
        return {
            initialize: (noop_default()),
            cleanup: (noop_default())
        };
    }
    var BODY = window.document.body;
    var touchStartClientY = 0;
    var handleTouchMove = function(e) {
        if (e.targetTouches.length !== 1) {
            return;
        }
        if (!e.cancelable || e.defaultPrevented) {
            return;
        }
        var scrollUp = touchStartClientY - e.targetTouches[0].clientY < 0;
        var scrollTop = containerElement.scrollTop, clientHeight = containerElement.clientHeight;
        /** is the lightbox scrolled up? */ if (scrollTop <= 0 && scrollUp) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        var contentHeight = contentElement.clientHeight;
        /** is the lightbox scrolled down? */ if (scrollTop + clientHeight >= contentHeight && !scrollUp) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    var handleTouchStart = function(e) {
        if (e.targetTouches.length === 1) {
            touchStartClientY = e.targetTouches[0].clientY;
        }
    };
    var initialize = function() {
        var passiveSupported = hasPassiveTouchSupport();
        BODY.addEventListener("touchstart", handleTouchStart, passiveSupported ? {
            passive: false
        } : false);
        BODY.addEventListener("touchmove", handleTouchMove, passiveSupported ? {
            passive: false
        } : false);
    };
    var cleanup = function() {
        BODY.removeEventListener("touchstart", handleTouchStart);
        BODY.removeEventListener("touchmove", handleTouchMove);
    };
    return {
        initialize: initialize,
        cleanup: cleanup
    };
};

;// CONCATENATED MODULE: external "lodash/debounce"
const debounce_namespaceObject = require("lodash/debounce");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_namespaceObject);
;// CONCATENATED MODULE: ./src/components/Lightbox/trapFocus.ts
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}

/**
 * Return two functions that will initialize and cleanup trapping focus inside a
 * dom node. If focus goes outside the hierarchy of the dom node then
 * programmatically refocus the dom node.
 */ function trapFocus(modalRoot) {
    var lastActiveElement = document.activeElement;
    var handleFocus = function(e) {
        if (_instanceof(e.target, Node) && !modalRoot.contains(e.target)) {
            debounce_default()(function() {
                modalRoot.focus();
            }, 100);
        }
    };
    var initialize = function() {
        if (!modalRoot) {
            return;
        }
        debounce_default()(function() {
            modalRoot.focus();
        }, 100);
        document.addEventListener("focusin", handleFocus);
    };
    var cleanup = function() {
        document.removeEventListener("focusin", handleFocus);
        if (lastActiveElement && _instanceof(lastActiveElement, HTMLElement)) {
            debounce_default()(function() {
                lastActiveElement.focus();
            }, 100);
        }
    };
    return {
        initialize: initialize,
        cleanup: cleanup
    };
}

;// CONCATENATED MODULE: ./src/util/wait.ts
/**
 * Return a promise that resolves when certain amount of milliseconds has
 * elapsed. This is used so we can wait the same duration as our css animation.
 * Will also optionally call a callback function at the same point.
 *
 * TODO: See if we can listen to `transitionend` event in a better way.
 * http://reactcommunity.org/react-transition-group/transition#Transition-prop-addEndListener
 */ var wait = function(duration, callback) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
            if (callback) {
                callback();
            }
        }, duration);
    });
};

;// CONCATENATED MODULE: ./src/components/Lightbox/Lightbox.tsx
function Lightbox_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Lightbox_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Lightbox_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Lightbox_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Lightbox_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Lightbox_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







// root styles need to be imported before the transition styles for CSS specificity








var Lightbox_ANIMATION_DURATION = 300;
var ESCAPE = 27;
var rootEl = browserOnly(function() {
    return addDOMElementById(Lightbox.tfdLightbox);
});
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/lightbox | Lightbox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Lightbox_Lightbox = function(_param) {
    var background = _param.background, _param_width = _param.width, width = _param_width === void 0 ? "100%" : _param_width, _param_height = _param.height, height = _param_height === void 0 ? "100vh" : _param_height, offsetTop = _param.offsetTop, children = _param.children, isOpen = _param.isOpen, className = _param.className, close = _param.close, _param_withAnimation = _param.withAnimation, withAnimation = _param_withAnimation === void 0 ? true : _param_withAnimation, _param_disableInteractions = _param.disableInteractions, disableInteractions = _param_disableInteractions === void 0 ? false : _param_disableInteractions, props = Lightbox_object_without_properties(_param, [
        "background",
        "width",
        "height",
        "offsetTop",
        "children",
        "isOpen",
        "className",
        "close",
        "withAnimation",
        "disableInteractions"
    ]);
    var contentEl = external_react_namespaceObject.useRef(null);
    var containerEl = external_react_namespaceObject.useRef(null);
    var calculatedHeight = offsetTop ? "calc(".concat(height, " - ").concat(offsetTop, "px)") : height;
    var animationDuration = withAnimation ? Lightbox_ANIMATION_DURATION : 0;
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen) {
            return (noop_default());
        }
        initializeDOM();
        return function() {
            return wait(animationDuration, cleanupDOM);
        };
    }, [
        animationDuration,
        isOpen
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (!isIos() || !isOpen || !containerEl.current || !contentEl.current) {
            return (noop_default());
        }
        var _blockBodyScroll = blockBodyScroll(containerEl.current, contentEl.current), initialize = _blockBodyScroll.initialize, cleanup = _blockBodyScroll.cleanup;
        initialize();
        return cleanup;
    }, [
        contentEl,
        containerEl,
        isOpen
    ]);
    // trapModalFocus
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen || !containerEl.current) {
            return (noop_default());
        }
        var _trapFocus = trapFocus(containerEl.current), initialize = _trapFocus.initialize, cleanup = _trapFocus.cleanup;
        initialize();
        return cleanup;
    }, [
        isOpen,
        containerEl
    ]);
    // addEscKeyListener
    external_react_namespaceObject.useEffect(function() {
        if (!isOpen) {
            return (noop_default());
        }
        var handleKeyUp = function(e) {
            if (e.code === "Escape") {
                close();
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        return function() {
            return window.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        isOpen,
        close,
        disableInteractions
    ]);
    if (!rootEl) {
        return null;
    }
    return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_transition_group_namespaceObject.Transition, {
        in: isOpen,
        component: null,
        timeout: animationDuration,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: true
    }, function(state) {
        return /*#__PURE__*/ external_react_dom_default().createPortal(/*#__PURE__*/ external_react_namespaceObject.createElement("aside", Lightbox_object_spread({
            className: external_classnames_default()(Lightbox.container, !withAnimation && Lightbox.disableAnimation),
            style: {
                marginTop: offsetTop
            },
            ref: containerEl
        }, omit_default()(props, [
            "overflow",
            "open",
            "labelProps",
            "descriptionProps"
        ])), /*#__PURE__*/ external_react_namespaceObject.createElement("button", {
            name: "background",
            "aria-label": "close",
            onClick: close,
            disabled: disableInteractions,
            className: external_classnames_default()(Lightbox.background, transitions_background[state]),
            style: {
                background: background
            }
        }), /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            className: Lightbox.autoBox
        }, /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            ref: contentEl,
            className: external_classnames_default()(Lightbox.content, content[state], className),
            style: {
                width: width,
                minHeight: calculatedHeight
            }
        }, children))), rootEl);
    });
};

;// CONCATENATED MODULE: ./src/components/Lightbox/useLightboxControl.ts
function useLightboxControl_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useLightboxControl_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useLightboxControl_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useLightboxControl_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useLightboxControl_sliced_to_array(arr, i) {
    return useLightboxControl_array_with_holes(arr) || useLightboxControl_iterable_to_array_limit(arr, i) || useLightboxControl_unsupported_iterable_to_array(arr, i) || useLightboxControl_non_iterable_rest();
}
function useLightboxControl_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useLightboxControl_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useLightboxControl_array_like_to_array(o, minLen);
}



/**
 * Hook for managing lightbox dialog state
 */ var useLightboxControl = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_initialIsOpen = _ref.initialIsOpen, initialIsOpen = _ref_initialIsOpen === void 0 ? false : _ref_initialIsOpen, onClose = _ref.onClose, onOpen = _ref.onOpen, onToggle = _ref.onToggle, idProp = _ref.id;
    var _useState = useLightboxControl_sliced_to_array((0,external_react_namespaceObject.useState)(initialIsOpen), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = idProp || reactId;
    var labelId = (0,external_react_namespaceObject.useId)();
    var descriptionId = (0,external_react_namespaceObject.useId)();
    var open = (0,external_react_namespaceObject.useCallback)(function() {
        if (isOpen) return;
        setIsOpen(true);
        onToggle ? onToggle(true) : undefined;
        return wait(Lightbox_ANIMATION_DURATION, onOpen ? function() {
            return onOpen();
        } : undefined);
    }, [
        onOpen,
        onToggle,
        isOpen
    ]);
    var close = (0,external_react_namespaceObject.useCallback)(function() {
        if (!isOpen) return;
        setIsOpen(false);
        onToggle ? onToggle(false) : undefined;
        return wait(Lightbox_ANIMATION_DURATION, onClose ? function() {
            return onClose();
        } : undefined);
    }, [
        onClose,
        onToggle,
        isOpen
    ]);
    var toggle = function() {
        setIsOpen(!isOpen);
        onToggle ? onToggle(!isOpen) : undefined;
        if (!isOpen) {
            return wait(Lightbox_ANIMATION_DURATION, onOpen ? function() {
                return onOpen();
            } : undefined);
        }
        if (isOpen) {
            return wait(Lightbox_ANIMATION_DURATION, onClose ? function() {
                return onClose();
            } : undefined);
        }
    };
    var labelProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: labelId
        };
    }, [
        labelId
    ]);
    var descriptionProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: descriptionId
        };
    }, [
        descriptionId
    ]);
    var rootProps = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            id: id,
            isOpen: isOpen,
            role: "dialog",
            "aria-modal": true,
            "aria-labelledby": labelId,
            "aria-describedby": descriptionId,
            tabIndex: -1,
            close: close
        };
    }, [
        id,
        isOpen,
        labelId,
        descriptionId,
        close
    ]);
    return {
        isOpen: isOpen,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        rootProps: rootProps,
        // these return promises but don't declare that in the type
        // it's a large change to fix that so we'll just ignore it
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        open: open,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        close: close,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        toggle: toggle
    };
};

;// CONCATENATED MODULE: ./src/components/Lightbox/CloseButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CloseButton = ({"button":"WT4nQs qdKc3_"});
;// CONCATENATED MODULE: ./src/components/Lightbox/CloseButton.tsx
function CloseButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CloseButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CloseButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CloseButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = CloseButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CloseButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




/**
 * Default modal close button.
 */ var CloseButton_CloseButton = function(_param) {
    var className = _param.className, props = CloseButton_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ external_react_default().createElement("button", CloseButton_object_spread({
        type: "button",
        "aria-label": "close",
        className: external_classnames_default()(CloseButton.button, className)
    }, props), /*#__PURE__*/ external_react_default().createElement(Close, null));
};

;// CONCATENATED MODULE: ./src/components/Lightbox/index.ts




;// CONCATENATED MODULE: external "react-router-dom"
const external_react_router_dom_namespaceObject = require("react-router-dom");
;// CONCATENATED MODULE: ./src/components/Link/Link.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Link = ({"link":"wXb2Ef","as-button":"EUN6nH","asButton":"EUN6nH"});
;// CONCATENATED MODULE: ./src/components/Link/linkType.ts
/**
 * Determines if the props provided are for a react-router Link component
 */ function isLink(props) {
    if (typeof props !== "object" || !props) return false;
    var keys = Object.keys(props);
    return keys.includes("to") && Boolean(props.to);
}
/**
 * Determines if the props provided are for a react-router NavLink component
 */ function isNavLink(props) {
    if (typeof props !== "object" || !props) return false;
    var keys = Object.keys(props);
    return keys.includes("activeClassName") || keys.includes("activeStyle");
}
/**
 * Determines if the props provided are for an anchor element
 */ function isAnchor(props) {
    if (typeof props !== "object" || !props) return false;
    var keys = Object.keys(props);
    return keys.includes("href") && Boolean(props.href);
}

;// CONCATENATED MODULE: ./src/components/Link/Link.tsx
function Link_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Link_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Link_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Link_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Link_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Link_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Link_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Link_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Link_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







function isAnchorLink(item) {
    return Boolean(!item.to && item.href);
}
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/link | Link} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Link_Link = function(_param) {
    var _param_asButton = _param.asButton, asButton = _param_asButton === void 0 ? false : _param_asButton, variant = _param.variant, mode = _param.mode, highContrast = _param.highContrast, className = _param.className, children = _param.children, hover = _param.hover, active = _param.active, asPill = _param.asPill, asMini = _param.asMini, props = Link_object_without_properties(_param, [
        "asButton",
        "variant",
        "mode",
        "highContrast",
        "className",
        "children",
        "hover",
        "active",
        "asPill",
        "asMini"
    ]);
    var designClass = asButton ? getButtonDesign_getButtonDesign({
        variant: variant !== "tertiary" ? variant : undefined,
        active: active,
        hover: hover,
        asPill: asPill,
        asMini: asMini,
        disabled: props.disabled
    }) : getLinkDesign_getLinkDesign({
        variant: variant,
        mode: mode,
        active: active,
        hover: hover,
        disabled: props.disabled,
        highContrast: highContrast
    });
    var linkProps = Link_object_spread_props(Link_object_spread({}, props), {
        className: external_classnames_default()(className, Link.link, designClass, asButton && Link.asButton)
    });
    if (props.disabled) {
        linkProps["aria-disabled"] = true;
    }
    if (isAnchor(linkProps)) {
        var _omit = omit_default()(linkProps, [
            "activeClassName"
        ]), className1 = _omit.className, restProps = Link_object_without_properties(_omit, [
            "className"
        ]);
        return /*#__PURE__*/ external_react_namespaceObject.createElement("a", Link_object_spread_props(Link_object_spread({}, restProps), {
            className: external_classnames_default()(className1)
        }), children);
    }
    if (isNavLink(linkProps)) {
        return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_router_dom_namespaceObject.NavLink, linkProps, children);
    }
    return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_router_dom_namespaceObject.Link, linkProps, children);
};

;// CONCATENATED MODULE: ./src/components/Link/index.ts


;// CONCATENATED MODULE: ./src/components/Radio/Radio.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Radio = ({"container":"feeYkp"});
;// CONCATENATED MODULE: ./src/components/Radio/Radio.tsx
function Radio_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Radio_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Radio_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Radio_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Radio_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Radio_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Radio_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Radio_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Radio_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/radiobutton | RadioButton} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Radio_Radio = function(_param) {
    var label = _param.label, color = _param.color, props = Radio_object_without_properties(_param, [
        "label",
        "color"
    ]);
    return /*#__PURE__*/ external_react_default().createElement(LabeledSelector_LabeledSelector, Radio_object_spread_props(Radio_object_spread({
        className: Radio.container
    }, props), {
        type: "radio",
        color: color
    }), label);
};

;// CONCATENATED MODULE: ./src/components/Radio/RadioView.tsx


var RadioView = function(param) {
    var state = param.state, checked = param.checked;
    var inputDesign = getRadioDesign_getRadioDesign({
        state: state,
        checked: checked
    });
    return /*#__PURE__*/ external_react_namespaceObject.createElement("span", {
        className: inputDesign
    });
};

;// CONCATENATED MODULE: ./src/components/Radio/index.ts



;// CONCATENATED MODULE: ./src/components/ScrollSnap/ScrollSnap.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ScrollSnap = ({"container":"ORsqNR","item":"WbrDZW"});
;// CONCATENATED MODULE: ./src/components/ScrollSnap/ScrollSnap.tsx
function ScrollSnap_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ScrollSnap_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ScrollSnap_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ScrollSnap_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ScrollSnap_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ScrollSnap_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




/**
 * Wraps child elements in a scroll-snap parent, ensuring one child
 * is always centered in the parent.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/scrollsnap | ScrollSnap} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ScrollSnapComponent = function(_param) {
    var _param_as = _param.as, as = _param_as === void 0 ? "div" : _param_as, children = _param.children, className = _param.className, forwardedRef = _param.forwardedRef, props = ScrollSnap_object_without_properties(_param, [
        "as",
        "children",
        "className",
        "forwardedRef"
    ]);
    var Component = as;
    return /*#__PURE__*/ external_react_namespaceObject.createElement(Component, ScrollSnap_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()([
            ScrollSnap.container,
            className
        ])
    }, props), external_react_namespaceObject.Children.map(children, function(child) {
        if (!/*#__PURE__*/ external_react_namespaceObject.isValidElement(child)) {
            return child;
        }
        var className = external_classnames_default()(child.props.className, ScrollSnap.item);
        return /*#__PURE__*/ external_react_namespaceObject.cloneElement(child, {
            className: className
        });
    }));
};
var ScrollSnap_ScrollSnap = withRef(ScrollSnapComponent);

;// CONCATENATED MODULE: ./src/components/ScrollSnap/index.ts


;// CONCATENATED MODULE: ./src/components/Text/index.ts

// TODO: Remove these exports when website no longer uses TextV2
// This V2 export is to make the rename a none breaking change


;// CONCATENATED MODULE: ./src/components/AppBar/constants.ts
var LOGO_SIZE = 74;
var LOGO_TRANSLATE = 12;
var SHADOW_OPACITY = 0.12;

;// CONCATENATED MODULE: ./src/components/AppBar/CallToAction.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CallToAction = ({"container":"RnmUzF","padding":"n__mKT","link":"Q57MYT","fullWidth":"tIK1F0"});
;// CONCATENATED MODULE: ./src/components/AppBar/CallToAction.tsx
function CallToAction_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var CallToAction_CallToAction = function(param) {
    var href = param.href, to = param.to, title = param.title, onClick = param.onClick, _param_asPill = param.asPill, asPill = _param_asPill === void 0 ? false : _param_asPill, _param_withPadding = param.withPadding, withPadding = _param_withPadding === void 0 ? false : _param_withPadding, isMobile = param.isMobile;
    return /*#__PURE__*/ external_react_default().createElement("div", {
        "data-name": "CallToAction",
        className: external_classnames_default()(CallToAction.container, CallToAction_define_property({}, CallToAction.padding, withPadding))
    }, /*#__PURE__*/ external_react_default().createElement(Link_Link, {
        className: external_classnames_default()(isMobile ? CallToAction.fullWidth : undefined),
        asButton: true,
        asPill: asPill,
        to: to,
        href: href,
        variant: "primary",
        onClick: onClick
    }, title));
};

;// CONCATENATED MODULE: ./src/styles/colors/palette.ts
var KALE_0 = "#E5EFE7";
var KALE_1 = "#b5d3ba";
var KALE_2 = "#417C67";
var KALE_3 = "#173b33";
var BLUEBERRY_0 = "#E6ECF5";
var BLUEBERRY_1 = "#B7C6E6";
var BLUEBERRY_2 = "#385A9D";
var BLUEBERRY_3 = "#03184E";
var CARROT_0 = "#FFF4F1";
var CARROT_1 = "#FFD9CC";
var CARROT_2 = "#f2674b";
var CARROT_3 = "#D2563D";
var CHARCOAL_0 = "#c2c3c5";
var CHARCOAL_1 = "#969799";
var CHARCOAL_2 = "#717377";
var CHARCOAL_3 = "#39383C";
var CHICKPEA_0 = "#FFFAF3";
var CHICKPEA_1 = "#fff3e1";
var CHICKPEA_2 = "#f2e1c8";
var CHICKPEA_3 = "#D3BFA2";
var OYSTER_0 = "#F6F5F3";
var OYSTER_1 = "#EFEDEA";
var OYSTER_2 = "#DBD6D1";
var OYSTER_3 = "#C6BFB7";
var TFD_LOGO = "#F5694D";
var WHITE = "#ffffff";
var ERROR_RED = "#f54c5a";

;// CONCATENATED MODULE: ./src/components/Logo/assets/background.svg
var background_excluded = ["styles"];
function background_extends() { background_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return background_extends.apply(this, arguments); }
function background_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = background_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function background_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const background = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = background_objectWithoutProperties(_ref, background_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", background_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.097 421.318"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M462.672 182.35c-.012-.163-.032-.325-.048-.488-.5-5-.836-10.029-1.551-14.991-.612-4.2-1.258-8.326-1.308-7.665-2.914-17.292-8.7-34.369-15.9-50.368-6.136-13.631-13.662-26.749-23.42-37.983-5.853-6.737-12.451-12.735-19.03-18.714-2.952-2.682-5.905-5.365-8.953-7.927a151.248 151.248 0 00-37.873-23.308 310.565 310.565 0 00-7.751-3.167c-.864-.512-1.72-1.026-2.548-1.547-2.325-1.463-8.026-3.29-8.026-3.29s-7.842-2.768-10.844-3.368c-1.494-.3-3.722-.692-6.4-1.134q-6.142-1.671-12.28-2.958c-6.88-1.433-13.828-2.415-20.784-3.2Q269.271.367 252.526.018C242.1-.2 232.76 1.6 222.553 3.281A406.836 406.836 0 00172.6 14.758a204.233 204.233 0 00-26.066 9.6c-9.7 4.4-17.621 10.631-27.682 14.484C94 48.355 75.719 65.663 55.934 82.924c-8.788 7.667-17.7 15.469-24.546 25.106-7.141 10.052-12.328 21.92-17.364 33.251C3.142 165.765 1.1 196.228.165 223.149c-.09 2.586.068 6.762-.076 8.419.468 6.235-.286 3.067-.037 7.126-.13 1.23.188 5.536.521 9.684.4 4.623.651 7.911.323 6.568.571 5.377.91 8.745 1.007 10.025a786.428 786.428 0 001.254 10.184 57.24 57.24 0 00.919 5.981c.073-.035.878 5.113 1.751 10.475 1.183 7.683 1.217 6.487 1.259 5.051.266.238.982 3.549 1.786 7.22.592 2.076 1.193 3.93 2.06 7.459 6.195 14.582 11.137 28.565 20.576 41.545a126.592 126.592 0 0034.15 32.314c3.878 2.469 7.879 4.712 11.879 6.954a72.044 72.044 0 009.863 4.887c5.6 2.09 11.549 2.705 17.335 4.047 14.7 3.411 28.461 11.589 43.45 13.428 16.723 2.051 33.636 3.625 50.417 5.4 26.695 2.818 52.239.986 78.642-1.881 9.925-1.077 19.7-3.553 29.32-6.169 9.589-2.608 19.483-4.03 28.962-7.216 10.562-3.549 20.472-8.694 30.492-13.5 8.677-4.165 16.426-8.511 23.418-15.25a146.925 146.925 0 0013.48-15.338c4.039-5.153 8.606-9.748 12.571-14.985 2.026-2.676 4.036-5.583 6.027-8.653.038.07.07.146.11.215 4.455-7.817 9.281-14.548 13.982-22.13 4.747-7.657 6.733-16.236 9.664-24.7 3-8.675 7-17.349 10-26.023 2.916-8.427 5.336-36.186 6.535-44.906.1-.739.093-1.124-.007-1.222a204.619 204.619 0 00.874-35.808z"
  }));
});
;// CONCATENATED MODULE: ./src/components/Logo/assets/text.svg
var text_excluded = ["styles"];
function text_extends() { text_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return text_extends.apply(this, arguments); }
function text_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = text_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function text_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const assets_text = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = text_objectWithoutProperties(_ref, text_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", text_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.097 421.318"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M100.925 184.68c-.757-3.7-7.039-4.138-10.057-4.416a25.954 25.954 0 00-9.326.527c-4 1.1-7.9 2.524-11.831 3.856-2 .678-4.008 1.336-6.041 1.914-2.73.777-5.222 2.228-8.037 2.736-.834.15-1.681.221-2.521.34-1.074.152-3.517.308-4.344 1.045-.516.46-.344 1.18-.345 1.779a19.52 19.52 0 01-.254 2.584c-.577 4.163-1.352 8.31-2.064 12.452-1.18 6.986-2.584 13.954-3.607 20.962-.524 3.586-.91 7.189-1.273 10.794-.091.9-.189 1.8-.357 2.693a54.02 54.02 0 00-.839 5.968 35.275 35.275 0 01-.446 3.6c-.526 2.908-.776 5.855-1.055 8.8-.144 1.513-.29 3.027-.486 4.535-.136 1.048-.6 2.4.062 3.352.736 1.061 1.342 2.206 2.114 3.244a12.48 12.48 0 004.6 3.572c3.279 1.4 8.351 1.183 10.013-2.464a18.193 18.193 0 001.2-4.643c.592-3.614 1.087-7.4 1.663-11.076.307-1.961.64-3.918 1.034-5.864q.283-1.4.61-2.792c.313-1.318.79-4.215 2.24-4.654 1.713-.517 3.479-.061 5.3-.754 1.727-.655 3.334-1.608 5.1-2.165a23.779 23.779 0 003.743-1.236 15.68 15.68 0 003.351-2.769 2.348 2.348 0 00.421-.623 25.535 25.535 0 002.267-5.484c.222-.871 1.2-3.278.862-4.047-.348-.784-1.333-1.171-1.942-1.711-3.093-2.741-10.243-2.058-13.725-.613-1.383.574-2.918 1.764-3.607-.065-.521-1.383.083-3.195.159-4.633a52.187 52.187 0 01.518-6.306c.348-1.986.938-3.914 1.444-5.862.465-1.792.438-4.08 1.75-5.309a3.635 3.635 0 001.009.1 5.267 5.267 0 01.879-.115c9.129.236 18.38-2.837 26.469-6.98 1.64-.839 3.561-1.843 4.5-3.511a4.612 4.612 0 00.4-2.523c.012-1.383.712-2.721.474-4.112l-.025-.126zm121.322 39.37q.361-3.642.725-7.284a24.928 24.928 0 01.913-5.285 8.6 8.6 0 012.07-3.754 11.576 11.576 0 011.877-1.027c.661-.39 1.266-.814 1.948-1.164s1.055-.852 1.706-1.217c.349-.2.713-.368 1.077-.535.243-.111.474.045.538.34.01.049.02.1.032.147a13.332 13.332 0 01.237 3.9c-.066 1.2-.183 2.408-.278 3.611q-.165 2.106-.332 4.21c-.012.15-.034.3-.055.449-.247 1.743-.5 3.485-.742 5.228-.077.548-.116 1.1-.212 1.645a12.763 12.763 0 00-.173 2.405c.021 1.426.046 2.851.059 4.277a8.462 8.462 0 001.632 4.305c2.14 3.345 5.021 4.459 8.284 1.228.712-.7 2.013-.963 2.12-2.049.746-7.595 1.858-15.558 3.187-23.106a47.866 47.866 0 001.095-11 14.05 14.05 0 00-1.692-6.617 8.654 8.654 0 00-4.558-3.266c-3.653-1.449-7.543-3.146-11.553-2.612a10.616 10.616 0 00-3.656 1.018 19.971 19.971 0 00-3.542 2.951 21.056 21.056 0 00-3.466 3.493l-.788 1.1a.692.692 0 01-.8.265c-1.66-.383-3.283-.944-4.915-1.424a13.791 13.791 0 00-12.321 2.818c-.186.169-.379.33-.573.489-.078.064-.165.115-.249.171a.517.517 0 01-.565-.04 22.267 22.267 0 00-1.852-1.281c-1.051-.722-2.9-2.2-4.247-2.041a2.523 2.523 0 01-.6.069c-.353-.044-.6-.364-.916-.526a1.494 1.494 0 00-1.859.782c-.512.973-.273 2.224-.516 3.282-1.345 5.863-2.9 11.622-3.853 17.6A186.611 186.611 0 00183 234.792c-.082 1.456-.086 2.917-.121 4.376-.051 2.146 3.043 5.811 5 6.545 1.994.746 4.532-.31 6.486-.79a.953.953 0 00.572-.456 7.184 7.184 0 00.92-2.375 30.149 30.149 0 01.657-3.091 22.067 22.067 0 00.865-6.746c.064-3.383.826-6.592 1.224-9.928.262-2.2.814-4.346 1.243-6.515a1.938 1.938 0 01.8-1.232c.931-.686 1.831-1.414 2.752-2.114a9.749 9.749 0 01.881-.578c.861-.517 1.77-.968 2.581-1.553a29.674 29.674 0 013.726-2.261c.06-.031.175.027.255.063a.148.148 0 01.049.126 8.984 8.984 0 01-.2 1.037c-.6 2.03-.973 4.109-1.377 6.183a15.945 15.945 0 01-.526 2.043c-.821 2.437-1.206 4.978-1.821 7.464a40.865 40.865 0 00-.652 3.253 12.637 12.637 0 00-.277 2.693 10.167 10.167 0 002.206 6.327l2.106 2.661a4.061 4.061 0 001.064 1.048c.941.553 2.139.308 3.175.4 1.106.095 2.21.222 3.322.284a1.351 1.351 0 001.2-.514 10.471 10.471 0 00.682-.99c.208-.344.358-.723.575-1.06a2.55 2.55 0 00.389-1.121c.16-1.345.291-2.7.568-4.022.238-1.136.373-2.278.533-3.423.305-2.171.174-4.316.39-6.476zm-14.617-77.919a134.627 134.627 0 00.722-17.734 31.181 31.181 0 00-2.956-8.453 14.458 14.458 0 00-7.342-7c-2.8-1.051-5.877-.9-8.857-.737-1.777.1-3.555-.027-5.141.895-.478.278-.983.509-1.479.753a1.323 1.323 0 01-.423.139.332.332 0 01-.248-.124c-.221-.29-.135-.724-.429-1a11.571 11.571 0 00.256-2.148 21.986 21.986 0 01.581-3.548c.339-1.728.445-3.465.774-5.207a17.161 17.161 0 00.44-4.186 5.776 5.776 0 00-1.559-3.819 8.564 8.564 0 00-2.245-1.422 6.486 6.486 0 00-1.853-.695c-1.123-.176-2.351-.291-3.481-.4a30.156 30.156 0 00-8.268.369 2.482 2.482 0 00-.568.2.548.548 0 00-.352.452 10.593 10.593 0 01-.584 2.8 4.175 4.175 0 00-.1 1.791 1.585 1.585 0 00.425.944 5.676 5.676 0 00.655.623c.218.18.464.3.673.488-.613 1.353-.5 3.3-.656 4.78l-.582 5.356-.895 8.248c-.263 2.425-.238 5.12-1.024 7.442a29.971 29.971 0 00-.974 4.259c-.888 4.873-1.668 9.767-2.483 14.658a82.79 82.79 0 00-1.072 10.778 2.826 2.826 0 00-.027 1.04 1.6 1.6 0 01.083 1.148c.313.478.253 1.094.676 1.561a2.878 2.878 0 00.795 1.633 2.359 2.359 0 010 .337c-.119 1.944 2 3.655 3.685 3.959a11.546 11.546 0 004.341-.284c1.694-.348 3.374-.757 5.054-1.166a4.788 4.788 0 003.958-3.913q.777-4.176 1.462-8.368.768-4.712 1.417-9.441.332-2.426.633-4.855c.089-.715-.083-3.516.779-3.766.481-.139.981-.217 1.461-.359 1.655-.487 2.738-1.835 3.794-3.109a40.387 40.387 0 014.075-3.924.54.54 0 01.57-.073.944.944 0 01.734.854c.457 9.51-2.61 18.882-2.729 28.432-.023 1.8.272 4.675 2.148 5.582 1.631.789 3.78.307 5.541.292a7.137 7.137 0 003.69-.81 8.381 8.381 0 00.807-.582 14.761 14.761 0 003.765-3.509 14.473 14.473 0 001.607-5.129q.365-2.03.726-4.052zm34.451-26.955zm13.519 2.339a1.76 1.76 0 00-.248-.712 2.549 2.549 0 00-.145-.24c-.006-.044-.011-.087-.019-.132a8.752 8.752 0 00-.419-1.591 5.539 5.539 0 00-.732-1.5.99.99 0 00-.09-.1 2.138 2.138 0 00-.485-.875c-.231-.266-.456-.546-.71-.788-.963-1.662-2.96-2.837-4.553-3.764a25.515 25.515 0 00-3.692-1.754 4.852 4.852 0 00-1.275-.643 9.008 9.008 0 00-1.308-.509 5.6 5.6 0 00-2.309-.64 54.259 54.259 0 00-3.8-.121c-2.987-.247-6.2-.143-8.774 1.126a15.8 15.8 0 00-1.8.651 31.228 31.228 0 00-2.488 2.036 19.745 19.745 0 00-1.954 1.959c-.757.9-1.452 1.857-2.124 2.824a27.219 27.219 0 00-3.674 6.9c-.4 1.216-.82 2.429-1.185 3.657a15.681 15.681 0 00-.675 5.576 16.657 16.657 0 00.462 4.321c.914 3.489 1.619 6.253 4.23 8.859l2.193 2.189c6.282 6.27 15.713 5.034 23.474 2.377 3.361-1.151 6.071-2.986 7.052-6.553a7.259 7.259 0 00.193-1.626 9.088 9.088 0 00-.688-4.155c-.072-.136-.124-.283-.2-.416a.4.4 0 01-.054-.187c-.385-.308-.758-.632-1.14-.943a1.258 1.258 0 01-.182-.183 45.242 45.242 0 01-1.971-.208 10.04 10.04 0 00-4.25.444c-1.567.479-3.1 1.069-4.654 1.593a92.483 92.483 0 01-3.511 1.129 7.133 7.133 0 01-4.095-.056 5.25 5.25 0 01-2.6-1.818.793.793 0 010-1 12.1 12.1 0 011.392-1.2 13.084 13.084 0 011.733-.994 4.024 4.024 0 012.424-.8c.181.027.386-.118.584-.171a1.433 1.433 0 01.583-.116 4.735 4.735 0 001.669-.19 22.094 22.094 0 005.929-1.548 5.118 5.118 0 01.873-.293 42.691 42.691 0 005.643-1.99 12.648 12.648 0 011.872-.681 5.573 5.573 0 001.423-.553 32.98 32.98 0 001.862-1.081c.567-.349 1.128-.71 1.671-1.095a1.226 1.226 0 00.579-1.032c-.013-1.128-.004-2.256-.037-3.383zm-12.225-.485c-1.694.37-3.327.969-5.045 1.263a19.768 19.768 0 00-3.1.95 17.959 17.959 0 01-3.767.968 10.675 10.675 0 00-3.878 1.13 3.214 3.214 0 01-1.245.345c-.046 0-.13-.025-.138-.056a.437.437 0 01-.024-.281c.014-.025.03-.047.044-.071a.463.463 0 01.006-.307c.905-2.675 3.763-3.963 6.14-5.078a15.191 15.191 0 014.545-1.58 16.4 16.4 0 014.683.359 3.1 3.1 0 001.33.624c.1.016.192.038.286.063a2.968 2.968 0 00.782.536 2.829 2.829 0 00.395.744 4.533 4.533 0 01-1.014.391zm-63.022 90.59a3.486 3.486 0 00.926-4.02 10.906 10.906 0 00-.7-1.639 3.85 3.85 0 00-1.208-1.328 24.425 24.425 0 00-8.381-3.461 15.531 15.531 0 00-10.074.608 5.262 5.262 0 00-.937.485c-.79.535-1.564 1.1-2.342 1.65-.245.175-.477.369-.724.542a.883.883 0 01-.856.127 12.022 12.022 0 01-2.213-.925 11.156 11.156 0 00-2.057-.924 9.862 9.862 0 00-3.43-.355.944.944 0 00-.15.017 2.452 2.452 0 00-2.1 1.5 3.9 3.9 0 01-.632 1.022 6.55 6.55 0 00-.8 2.755 71.835 71.835 0 00-.8 3.921c-.479 2.708-.819 5.438-1.089 8.174-.775 7.85-1.046 15.349-1.133 23.232-.033 2.983 1.209 5.49 2.4 8.146a2.753 2.753 0 001.186 1.317c.218.123.411.288.622.426 2.075 1.362 4.783.741 6.8-.408 2.384-1.356 3.133-3.653 3.058-6.363a43.674 43.674 0 01.742-9.616c.348-1.772.773-3.528 1.2-5.283.689-2.852.487-5.328 2.2-7.766a55.949 55.949 0 015.72-6.576c1.786-1.847 4.857-4.053 7.637-3.987a22.762 22.762 0 003.9.2 6.676 6.676 0 002.5-.933 5.121 5.121 0 00.735-.538zm174.939-55.148v.006l.022-.041v.005c-.014.007-.023.009-.034.014l.01.019zm-63.445 34.744a9.872 9.872 0 00-.533-1.353c-.572-1.268-1.057-3.268-1.986-4.3a31.389 31.389 0 00-3.008-2.726c-1.258-1.052-2.7-2.607-4.2-3.264a7.078 7.078 0 00-3.116-.355 37.315 37.315 0 00-9.133 1.055 8.029 8.029 0 01-1.164.309 5.208 5.208 0 00-2.091.805 6.062 6.062 0 01-.656.371 7.3 7.3 0 00-3.042 2.845c-.434.676-.91 1.325-1.359 1.992a21.986 21.986 0 00-1.235 1.887 37.074 37.074 0 00-2.543 5.8 12.848 12.848 0 01-1.014 2.516.988.988 0 00-.135.424 6.585 6.585 0 01-.515 1.885 42.643 42.643 0 00-1.955 9.588c-.4 3.348-.884 6.819.506 10.02a16.7 16.7 0 002.3 3.6 17.8 17.8 0 002.609 2.806 20.629 20.629 0 004.06 2.411 28.069 28.069 0 0016.531 2.141c2.188-.336 5.175-.8 6.568-2.723a6.4 6.4 0 00.973-3.223c.078-.873.587-4.329-.1-4.991a1.909 1.909 0 01-.519-.6 10.1 10.1 0 00-1.1-1.6 2.857 2.857 0 00-1.351-1.146 7.8 7.8 0 00-.983-.368c-.721-.215-1.454-.391-2.172-.617a17.4 17.4 0 00-3.239-.64c-1-.116-1.991-.254-3-.282a.164.164 0 01-.174-.2c0-.046.008-.111.037-.133.48-.361.965-.714 1.445-1.075 1.638-1.23 3.247-2.451 4.926-3.654 1.595-1.143 2.912-2.658 4.583-3.688a17.3 17.3 0 005.506-4.869 6.116 6.116 0 00.976-2.663 16 16 0 00-.345-3.565 16.113 16.113 0 00-.352-2.42zm-11.347 3.058a4.041 4.041 0 01-1.066.825c-1.138.643-2.245 1.343-3.393 1.967a36.007 36.007 0 00-6.852 4.9c-.484.435-1.027.805-1.549 1.2a.476.476 0 01-.551-.087 1.026 1.026 0 01-.349-.8 3.014 3.014 0 01.384-1.444c.439-.688.453-1.537.865-2.233a4.618 4.618 0 01.361-1.755c.139-.32.289-.636.433-.954a1.478 1.478 0 01.738-.711 22.057 22.057 0 002.659-1.71c.284-.2.594-.364.892-.545.61.042 1.14-.385 1.77-.285a3.268 3.268 0 001.049 0 8.718 8.718 0 013.577.327 1.769 1.769 0 011.091.758.987.987 0 01.077.28 1.2 1.2 0 01-.136.267z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M266 227.946l.03.028-.024-.027zm-135.455 96.377l-.033.037.007.006-.007.01.028.008z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M175.233 300.475a29.57 29.57 0 00-.23-2.32 14.006 14.006 0 00-2.046-7.964 29.243 29.243 0 00-2.171-4.636 7.308 7.308 0 00-1.256-2.052 7.138 7.138 0 00-1.583-1.917 27.091 27.091 0 00-8.218-6.851 6.907 6.907 0 00-2.933-1.668l-3.43-1.294a3.715 3.715 0 00-.5-.147 35.156 35.156 0 00-5.013-1.315 8.522 8.522 0 00-1.183-.126c-2.062-.5-4.439-.056-6.493.236a69.179 69.179 0 00-7.289 1.436 27 27 0 00-4.361 1.423c-1.405.624-2.714 1.436-4.095 2.108-.421.205-3.981 1.211-4.012 1.338-.009.039-.021.074-.031.11l-.044.015a4.639 4.639 0 00-1.224.631c-.1.04-.213.1-.315.134a.294.294 0 00-.205.312 3.962 3.962 0 00-1.04 3.4c.233 1.511-.834 4.137-1.138 5.635 0 2.326-1 5.056-1.461 7.349l-.036.052a1.163 1.163 0 00-.188 1.051 133.329 133.329 0 00-2.155 14.591c-.4 4.257-1.2 8.46-1.819 12.688-.312 2.13-.579 4.269-.721 6.419a32.186 32.186 0 00-.2 6.082c.1.792.366 1.555.507 2.342a10.466 10.466 0 00.405 2 6.287 6.287 0 002.245 2.484l10.059 7.713a3.368 3.368 0 001.915.534c5.374.606 9.906-1.824 14.386-4.508q3.213-1.926 6.4-3.888a48.722 48.722 0 004.322-2.881c3.059-2.363 5.515-5.455 8.711-7.641a14.312 14.312 0 001.533-1.107c.994-.889 1.749-2.037 2.705-2.975q1.585-1.555 3.032-3.246a54.705 54.705 0 005.227-7.192 28.138 28.138 0 003.97-13.469q.056-1.443-.027-2.886zm-19.873 2.572c-3 6.878-8.02 12.571-13.663 17.414a38.487 38.487 0 01-3.775 2.961 35.781 35.781 0 00-3.729 2.8c-.9.785-1.88 1.49-2.837 2.213a.933.933 0 01-1.335-.191c-.1-.116-.183-.243-.269-.368a16.094 16.094 0 01.45-2.588c.459-2.236.417-4.713.652-7q.376-3.674.759-7.347l.59-5.681.216-2.079.643-6.2c.128-1.23.1-4.924 1.258-5.688a.34.34 0 01.5.12c0-.5.507-.834.963-1.037 2.28-1.017 4.78-.977 7.218-1.2a18.085 18.085 0 017.908.644l.048.018a9.838 9.838 0 015.782 5.312c1.037 2.693-.299 5.423-1.379 7.897z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M174.329 309.976l.043-.025-.042.022-.001.003zm52.356 47.179c-.01-.013-.021-.021-.031-.032h-.009l.021.019-.021-.019c0 .02.012.039.018.059l.025-.02z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M226.489 357.332c-.018.019 0 .1.025.121.088.076.177.047.192-.075a.494.494 0 00-.043-.2 1.6 1.6 0 00-.174.154zm-8.227-48.975c1.195-2.557 1.2-5.32 1.391-8.064a20.247 20.247 0 00-.261-5.989 13.2 13.2 0 00-.771-2.347 32.892 32.892 0 00-12-13.2 11.675 11.675 0 00-4.275-1.555c-1.7-.166-3 .719-4.482 1.4a53.024 53.024 0 00-5.159 2.243 19.014 19.014 0 00-6.27 6.609c-3.752 5.9-7.377 12.382-7.151 19.37a35.1 35.1 0 00.6 4.851c.308 1.768.654 4.6 1.637 6.1a38.777 38.777 0 012.493 3.666 14.81 14.81 0 004.517 5.362c.344.281.669.6 1 .887a4.652 4.652 0 001.219.565 17.63 17.63 0 005.653 1.566 12.6 12.6 0 005.446-.589c.18-.083.334-.23.519-.293a9.31 9.31 0 001.426-.458 7.149 7.149 0 011.266-.773 3.8 3.8 0 001.018-.616 12.558 12.558 0 001.185-.924c1.491-1.288 2.522-3.414 3.636-5.029l4.005-5.808c.637-.924.915-2.42 1.467-3.453m-11.271-9.571c-.38 1.049-.9 2.045-1.373 3.056a24.8 24.8 0 01-1.128 2.209 16.594 16.594 0 01-1.371 1.929c-.153.189-.309.376-.466.561-.484.568-1.139 1.091-1.561 1.694-.127.18-.22.382-.345.563-.333.482-.859.791-1.187 1.276-.38.563-.672 1.217-1.029 1.8a4.592 4.592 0 01-.446.6.428.428 0 01-.649-.074 10.192 10.192 0 01-.927-5.914c.342-1.892.683-3.785 1.121-5.657a13.849 13.849 0 012.022-5.084c.94-1.293 2.258-2.256 3.191-3.552a7.388 7.388 0 011.315-1.744c.637-.5 1.467-.662 2.124-1.129a1.132 1.132 0 01.443-.155c1.118-.223 2.656-.616 2.585 1-.007.151-.042.3-.035.45.146 2.8-1.353 5.604-2.284 8.171zm59.277-6.114l-.028-.054h-.037l-.036.017.1.029zm-89.232 8.322l-.03.038.038-.021zm0 0c.016-.021.031-.04.028-.042-.065-.066-.073-.049-.028.042zm-.719 5.514l-.067-.036-.02.061zm209.101-141.856h.027v-.373h-.026l-.001.373zm-248.61 82.174a41.077 41.077 0 01-2.725-2.4c-.621-.6-1.937-1.556-2.265-2.336a8.031 8.031 0 00-.831-1.712 1.146 1.146 0 01-.1-.174c1.077-8.186.822-16.795 2.472-24.864.3-1.471.543-2.846.7-4.334a14.748 14.748 0 01.428-2.006q-.082-.269-.188-.531c-.961-2.389-3.009-3.4-5.04-4.849-.734-.523-1.5-.908-2.234-1.446a4.267 4.267 0 00-2.321-.834.456.456 0 00-.545.374c-.254.8-.49 1.6-.769 2.386-.218.614-.431.7-.991.414-1.971-1.008-3.607-2.6-5.923-2.79a9.089 9.089 0 00-2.436.208 29.189 29.189 0 00-5.921 1.755 9.285 9.285 0 00-3.46 3.129A71.975 71.975 0 0089.8 238.351a27.313 27.313 0 00-.561 3.5 23.875 23.875 0 00.235 5.01 10.561 10.561 0 00.618 2.73 10.662 10.662 0 01.5 1.849c.926 4.2 3.207 8.018 7.614 9.318 2.457.724 5.087.183 7.589-.362a19.411 19.411 0 006.035-2.042 14.391 14.391 0 003.923-4.134.65.65 0 01.207-.2.924.924 0 00.621-.75c.006-.063.137-.144.223-.164a1.366 1.366 0 011.01 0 3.054 3.054 0 001.277.307c1.437.14 2.507 1.048 3.813 1.468s2.686.558 4.018.9c1.251.318 2.386.96 3.641 1.288a6.186 6.186 0 002.177-.234.8.8 0 00.513-.265 3.484 3.484 0 01.893-.759.924.924 0 00.295-.323 15.313 15.313 0 001.147-3.309 1.249 1.249 0 00.034-.293 1.784 1.784 0 00-.705-1.539zM118.1 220.834c-.935 3.593-1.6 7.247-2.3 10.892-.645 3.377-1.9 6.968-1.768 10.427a1.479 1.479 0 01-.587 1.286 19.562 19.562 0 01-6.963 4.084c-.976.271-3.012 1.375-3.832.376a1.5 1.5 0 01-.267-.564c-.712-2.584 1.371-5.974 2.278-8.286 0-1.013 1.024-2.609 1.4-3.565l1.526-3.891c.936-2.392 1.82-4.8 2.881-7.145.766-1.69 2.121-4.538 4.319-4.662a9.793 9.793 0 012.974-.612c.146.017.267 0 .336.047.108.079.265.217.254.312a10.086 10.086 0 01-.251 1.301zm120.525 103.928l.094-.048s-.03-.026-.03-.022-.064.07-.064.07zm-.55.906l.02.057c.064-.054.055-.072-.02-.057z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M383.452 165.78a5.786 5.786 0 00-.363-1.661 7.335 7.335 0 00-.964-1.544c-1.593-2.135-3.327-4.149-4.916-6.283a1.6 1.6 0 00-1.115-.7c-3.429-.387-7.132 1.2-10.217 2.549a12.593 12.593 0 00-3.4 2c-1.362 1.213-2.113 2.875-3.1 4.351a48.048 48.048 0 00-3.02 5.242c-1.186 2.357-1.258 5.792-1.375 8.395-.072 1.617-.142 4.522 1.015 5.814l.049.051a6.115 6.115 0 00.373.752 4.721 4.721 0 001 1.2c1.837 3.194 4.674 5.224 7.566 7.473 1.291 1 1.056 1.39.013 2.429a9.078 9.078 0 01-3.267 1.971c-1.6.6-3.284.916-4.907 1.435a20.683 20.683 0 00-4.868 2.3c-1.6 1.024-2.861 2.362-4.684 3a2.666 2.666 0 00-.316-.082.609.609 0 00-.8.643c.137 2.305-.514 9.223 2.63 9.791 4.56.825 9.69.973 14.111-.479a24.682 24.682 0 0010.723-6.354c2.639-2.806 5.306-6.805 6.174-10.614a6.4 6.4 0 00-.2-3.8 6.55 6.55 0 00-.281-.824l-.014-.041a1.912 1.912 0 00-.216-.437q-.144-.273-.313-.53a17.583 17.583 0 00-1.8-3.241l-3.707-5.632a29.348 29.348 0 00-2.254-3.074c-1.179-1.366-1-2.152-.471-3.734a3.472 3.472 0 012.119-2.51c2.732-1.072 5.877-1.062 8.491-2.344 2.186-1.071 2.524-2.8 2.344-5.108-.015-.129-.026-.267-.04-.404zM234.573 330.053v.183a.668.668 0 00.039-.135c.002-.014-.012-.031-.039-.048zm.001.294v-.111c-.011.032-.024.064-.035.1zm-.053-.335c.014.013.034.027.052.041v-.06zm112.41-155.528a7.762 7.762 0 002.07-2.713c1.23-2.684 1.785-5.579 3.224-8.179a27.32 27.32 0 003.412-8.6 11.777 11.777 0 00-2.57-8.994c-1.328-1.792-5.789-5.347-8.009-3a11.709 11.709 0 00-1.964 3.836q-2.055 5.321-3.784 10.758c-.576 1.813-1.085 3.644-1.644 5.461-.406 1.321-1.058 3-.554 4.377.081.222.213.421.309.637a4.159 4.159 0 01.224.743l.7 2.959a5.452 5.452 0 004.267 4.018 5.373 5.373 0 004.319-1.303zM231.137 334.565s.043.007.05.01-.021-.028-.021-.028zm34.847-106.49l.013-.091c-.107.029-.115.059-.013.091z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M266 227.946l-.006.038c.013 0 .021-.007.036-.01zm67.729-49.281c-1.573-1.327-2.977-3.233-4.837-4.152a18.4 18.4 0 00-5.6-1.217 3 3 0 00-1.041.043c-.491.1-.994.157-1.482.276a15.4 15.4 0 00-2.32.647c-1.155.487-2.261 1.09-3.384 1.651-.178.089-.328.238-.51.318-.909.4-1.556.946-2.138-.053a7.572 7.572 0 00-1.012-1.838 12.983 12.983 0 00-2.657-1.834 1.893 1.893 0 00-.622-.284 1.752 1.752 0 00-.863.126 12.778 12.778 0 00-3.729 2 2.547 2.547 0 00-.732.774 2.823 2.823 0 00-.246.936c-.591 4.124-1.358 8.191-1.659 12.359-.558 7.732-1.25 15.479-1.539 23.211a35.524 35.524 0 00.047 4.366 14.858 14.858 0 001.222 4.48 11.1 11.1 0 001.038 2 2.113 2.113 0 001.322.926 3.672 3.672 0 001.643-.041 16.2 16.2 0 012.068-.338 8.637 8.637 0 003.246-1.122c.546-.337.9-.948 1.6-1.086.123-.024.236-.186.319-.308 1.924-2.822 1.464-6.466 1.294-9.7a68.584 68.584 0 01.419-11.969 4.917 4.917 0 01.32-1.428c1.04-2.3 3.413-4.375 5.4-5.844a21.945 21.945 0 013.982-2.341c1.237-.561 2.93-1.478 4.29-1.058a12.171 12.171 0 011.849.622 2.66 2.66 0 001.61.192 9.42 9.42 0 001.033-.246c.476-.117 1.823-2.065 2.169-2.542a8.771 8.771 0 001.267-3.862 2.311 2.311 0 00-.155-1.331 6.186 6.186 0 00-1.612-2.333zm-199.357 113.69l.102.016-.033-.132-.069.116zM88.809 123.132c.8 1.087.659 2.537.874 3.808a10.31 10.31 0 001.51 4.091c1.729 2.578 4.8 4.593 8 4.235a18.111 18.111 0 004.049-1.1l8.516-3.052c1.624-.582 4.326-2.238 3.72.592q-.411 1.917-.812 3.838-.833 3.959-1.638 7.924c-1.332 6.91-2.44 13.886-4.759 20.528a6.359 6.359 0 00-.379 3.75c.584 2.1 2.913 3.541 4.379 5.02a5.475 5.475 0 001.279 1.052 4.613 4.613 0 001.35.411c2.517.449 5.109.04 7.632-.134a33.2 33.2 0 003.744-.909c1.538-.26 2.029-1.67 2.4-2.983a13.533 13.533 0 01.864-3.083l1-3.558c.308-1.1.7-2.2.93-3.322.213-1.023.14-2.075.357-3.107a1.842 1.842 0 00.01-.452 6.817 6.817 0 01.161-1.646c.314-1.587.318-3.269.585-4.882l.965-5.835a66.214 66.214 0 001.2-7.283c.411-2.483.666-4.827.862-7.311a9.463 9.463 0 00.222-2.892c-.173-.81-1.293-2.338-.739-3.115.292-.409 1.832-.767 2.32-.925 2.245-.726 4.482-1.273 6.793-1.786l1.82-.4c.979-.217 1.959-.435 2.934-.672a48.291 48.291 0 005.109-1.515c1.568-.572 2.987-1.463 4.707-1.372a1.2 1.2 0 001.269-1.064 2.531 2.531 0 00.085-.891 20.944 20.944 0 00-1.809-5.059 14.944 14.944 0 00-.916-1.93c-1.759-2.942-5.431-4.612-8.691-5.2-3.2-.58-6.73.263-9.866.888a316.9 316.9 0 00-36.068 9.51c-4.9 1.6-10.725 3.209-14.68 6.668a1.846 1.846 0 00-.482.568 1.507 1.507 0 00.229 1.436c.274.411.664.75.964 1.159zm149.276 202.515l-.025-.02-.03.051a.323.323 0 01.042-.009v-.013zm19.342-1.006h-.026l.017.015v-.009z"
  }), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M263.633 286.4a35.707 35.707 0 00-2.524-7.725c-.932-2.1-1.949-4.557-3.9-5.917a6.558 6.558 0 00-.655-.44 3.606 3.606 0 00-.275-.354 11.537 11.537 0 00-3.042-2.465 7.374 7.374 0 00-.805-.728 1.785 1.785 0 00-.459-.247c-.052-.048-.1-.1-.153-.148a35.267 35.267 0 01-3.758-1.153 3.979 3.979 0 00-.682.249 3.64 3.64 0 01-.573.064 7.355 7.355 0 00-3.306.861c-.311.165-.62.334-.93.5-1.464.781-3.594 1.577-4.983 2.487a28.993 28.993 0 00-5.869 5.172 22.491 22.491 0 00-2.416 3.084c-.629 1.031-1.168 2.106-1.735 3.167a22.62 22.62 0 00-2.724 12.063c.119 5.994.523 12.326 3.862 17.513A13.282 13.282 0 00231 315.6a8.208 8.208 0 001.639.693q.923.4 1.83.845c1 .486 2.671.973 3.669 1.459a21.6 21.6 0 002.444 1.353.439.439 0 01.179.384 6.416 6.416 0 01-.5 1.858 56.846 56.846 0 01-10.343 13.438 169.171 169.171 0 00-6.288 6.362 1.313 1.313 0 00-.216.372 11.7 11.7 0 01-1.091 1.916 1.111 1.111 0 00-.279.646c0 .13.056.255.059.385a1.148 1.148 0 01-.107.414c-.715 1.883.389 3.482.576 5.361.11 1.115.308.851.454 1.958a4.21 4.21 0 00.417 1.5 5.191 5.191 0 003.271 2.55 21.455 21.455 0 002.291.391 3.5 3.5 0 002.5-1.17 32.7 32.7 0 015.023-4.5 39.034 39.034 0 004.584-3.517c1.306-1.246 2.37-2.806 3.566-4.177l2.481-2.844 4.107-4.71a22.036 22.036 0 001.491-1.838 19.353 19.353 0 001.625-2.976 76.281 76.281 0 005.023-14.769c.311-1.325.546-2.666.843-3.994.5-2.223 1.165-4.4 1.694-6.618.517-2.166.647-4.355 1.112-6.529.277-1.3.642-2.575.855-3.885.043-.26.077-.52.105-.779a30.131 30.131 0 00-.381-8.779zM223.9 342.428c-.1.026-.157-.043-.13-.171a.129.129 0 01.115-.054c.033.01.052.07.078.108-.021.041-.034.11-.063.117zm26.312-53.084c-.328 2.231-.748 4.448-1.2 6.657-.06.293-.078.6-.116.893a69.538 69.538 0 01-.711 4.3 13.826 13.826 0 01-.855 2.879.743.743 0 01-.425.383 5.564 5.564 0 01-1.184.171c-1.1.043-2.21.055-3.315.08v.02c-.951.019-1.9.045-2.854.052-.4 0-.8-.041-1.2-.053a1.077 1.077 0 01-1.084-.869c-.082-.289-.144-.584-.215-.877-.606-2.521-1.173-4.376-.415-6.946a24.314 24.314 0 011.553-4.262c2-3.889 5.594-5.842 9.729-6.624a6.771 6.771 0 011.04-.133 1.357 1.357 0 011.5 1.481 25.88 25.88 0 01-.248 2.848zm-54.774 16.438l.029-.042-.088-.048.059.09z"
  }));
});
;// CONCATENATED MODULE: ./src/components/Logo/Logo.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Logo = ({"logo":"m78spP","path":"_6eAZll"});
;// CONCATENATED MODULE: ./src/components/Logo/Logo.tsx
function Logo_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Logo_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Logo_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Logo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Logo_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Logo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Logo_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Logo_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Logo_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var LogoModes = [
    "light",
    "dark",
    "product"
];
function getTextFill(mode) {
    switch(mode){
        case "light":
        case "product":
        default:
            return WHITE;
        case "dark":
            return KALE_3;
    }
}
function getBackgroundFill(mode) {
    switch(mode){
        case "light":
        default:
            return KALE_3;
        case "product":
            return TFD_LOGO;
        case "dark":
            return WHITE;
    }
}
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/logo | Logo} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Logo_Logo = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? 100 : _param_size, _param_mode = _param.mode, mode = _param_mode === void 0 ? "light" : _param_mode, className = _param.className, style = _param.style, props = Logo_object_without_properties(_param, [
        "size",
        "mode",
        "className",
        "style"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement("svg", Logo_object_spread_props(Logo_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 463.097 421.318",
        className: external_classnames_default()(Logo.logo, className),
        style: Logo_object_spread({
            height: size
        }, style)
    }, props), {
        "aria-label": "Logo"
    }), /*#__PURE__*/ external_react_namespaceObject.createElement("g", {
        fillRule: "nonzero",
        fill: "none"
    }, /*#__PURE__*/ external_react_namespaceObject.createElement(background, {
        className: Logo.path,
        style: {
            fill: getBackgroundFill(mode)
        }
    }), /*#__PURE__*/ external_react_namespaceObject.createElement(assets_text, {
        className: Logo.path,
        style: {
            fill: getTextFill(mode)
        }
    })));
};

;// CONCATENATED MODULE: ./src/components/AppBar/Logo.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const AppBar_Logo = ({"logo":"gkGOeX","link":"s4MLkp"});
;// CONCATENATED MODULE: ./src/components/AppBar/Logo.tsx






var AppBar_Logo_Logo = function(param) {
    var _param_to = param.to, to = _param_to === void 0 ? "/" : _param_to, href = param.href, translate = param.translate, className = param.className;
    return /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(AppBar_Logo.logo, className),
        style: {
            transform: "translateY(".concat(translate, "px)")
        }
    }, href ? /*#__PURE__*/ external_react_default().createElement("a", {
        href: href,
        className: AppBar_Logo.link,
        "aria-label": "The Farmer's Dog Logo"
    }, /*#__PURE__*/ external_react_default().createElement(Logo_Logo, {
        size: LOGO_SIZE,
        mode: "product"
    })) : /*#__PURE__*/ external_react_default().createElement(external_react_router_dom_namespaceObject.Link, {
        to: to,
        className: AppBar_Logo.link,
        "aria-label": "The Farmer's Dog Logo"
    }, /*#__PURE__*/ external_react_default().createElement(Logo_Logo, {
        size: LOGO_SIZE,
        mode: "product"
    })));
};

;// CONCATENATED MODULE: ./src/components/AppBar/MaxWidth.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MaxWidth = ({"container":"T5eSs5"});
;// CONCATENATED MODULE: ./src/components/AppBar/MaxWidth.tsx
function MaxWidth_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MaxWidth_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MaxWidth_define_property(target, key, source[key]);
        });
    }
    return target;
}
function MaxWidth_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = MaxWidth_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MaxWidth_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var MaxWidth_MaxWidth = function(_param) {
    var children = _param.children, className = _param.className, props = MaxWidth_object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ external_react_default().createElement("div", MaxWidth_object_spread({
        className: external_classnames_default()(MaxWidth.container, className)
    }, props), children);
};

;// CONCATENATED MODULE: ./src/components/AppBar/Large.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Large = ({"nav":"nBJQ4i g97HzC","items":"svdnAP","left":"V1EfXu","link":"U9gzXk","right":"UyIJTe","callToAction":"U1m0Tb","active":"pFIoUj","horizontalNavContainer":"BL9QUb","horizontalNavContentRow":"hlkuY8"});
;// CONCATENATED MODULE: external "intersection-observer"
const external_intersection_observer_namespaceObject = require("intersection-observer");
;// CONCATENATED MODULE: external "lodash/isEqual"
const isEqual_namespaceObject = require("lodash/isEqual");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual_namespaceObject);
;// CONCATENATED MODULE: ./src/hooks/useSafeOptions.ts
function useSafeOptions_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSafeOptions_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSafeOptions_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSafeOptions_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSafeOptions_sliced_to_array(arr, i) {
    return useSafeOptions_array_with_holes(arr) || useSafeOptions_iterable_to_array_limit(arr, i) || useSafeOptions_unsupported_iterable_to_array(arr, i) || useSafeOptions_non_iterable_rest();
}
function useSafeOptions_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSafeOptions_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSafeOptions_array_like_to_array(o, minLen);
}


/**
 * Return an object that updates based on a deep equality reference rather then
 * a shallow one.
 *
 * This is useful when you need to pass parameters into 3rd party objects and
 * you want to avoid needlessly destroying and creating those objects inside of
 * a useEffect hook.
 *
 * @param currentOptions - Any object that you want to update based on a deep equality comparison
 */ function useSafeOptions(currentOptions) {
    var _React_useState = useSafeOptions_sliced_to_array(external_react_namespaceObject.useState(currentOptions), 2), safeOptions = _React_useState[0], setSafeOptions = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        setSafeOptions(function(prevOptions) {
            if (!isEqual_default()(prevOptions, currentOptions)) {
                return currentOptions;
            }
            return prevOptions;
        });
    }, [
        currentOptions
    ]);
    return safeOptions;
}

;// CONCATENATED MODULE: ./src/hooks/useIntersection.ts
function useIntersection_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIntersection_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useIntersection_array_without_holes(arr) {
    if (Array.isArray(arr)) return useIntersection_array_like_to_array(arr);
}
function useIntersection_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIntersection_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useIntersection_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIntersection_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIntersection_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIntersection_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIntersection_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useIntersection_sliced_to_array(arr, i) {
    return useIntersection_array_with_holes(arr) || useIntersection_iterable_to_array_limit(arr, i) || useIntersection_unsupported_iterable_to_array(arr, i) || useIntersection_non_iterable_rest();
}
function useIntersection_to_consumable_array(arr) {
    return useIntersection_array_without_holes(arr) || useIntersection_iterable_to_array(arr) || useIntersection_unsupported_iterable_to_array(arr) || useIntersection_non_iterable_spread();
}
function useIntersection_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIntersection_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIntersection_array_like_to_array(o, minLen);
}



/**
 * Return an array of decimal points between 0 and 1
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Building_the_array_of_threshold_ratios
 */ function buildThresholdList(steps) {
    return steps > -1 ? useIntersection_to_consumable_array(new Array(steps)).map(function(_, i) {
        return i / steps;
    }) : [];
}
/**
 * Hook for creating an intersection observer.
 *
 * @param referenceEl - A target html element to observe.
 * @param root - An element used as the viewport for checking visibility.
 * @param rootMargin - A css margin around the root.
 * @param threshold - Which percentage of visibility to execute the callback.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useIntersection | useIntersection} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useIntersection(referenceEl) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState = useIntersection_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), entry = _useState[0], setEntry = _useState[1];
    // Having stateful options allows us run our effect based on deep equality
    // rather then shallow object reference.
    var safeOptions = useSafeOptions(useIntersection_object_spread({
        referenceEl: referenceEl
    }, options));
    (0,external_react_namespaceObject.useEffect)(function() {
        var root = safeOptions.root, rootMargin = safeOptions.rootMargin, threshold = safeOptions.threshold, _$referenceEl = safeOptions.referenceEl;
        if (!_$referenceEl) {
            return;
        }
        var handleIntersections = function(entries) {
            setEntry(entries[0] || {});
        };
        var observer = new IntersectionObserver(handleIntersections, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold
        });
        observer.observe(_$referenceEl);
        return function() {
            return observer.disconnect();
        };
    }, [
        safeOptions
    ]);
    return entry;
}

;// CONCATENATED MODULE: ./src/components/AppBar/useCallToActionObserver.ts


var useCallToActionObserver = function(showCTA, callToAction) {
    var _showCTA;
    var _showCTA_current;
    var intersection = useIntersection((_showCTA_current = (_showCTA = showCTA) === null || _showCTA === void 0 ? void 0 : _showCTA.current) !== null && _showCTA_current !== void 0 ? _showCTA_current : undefined, {
        rootMargin: "0px 0px -95% 0px"
    });
    return (0,external_react_namespaceObject.useMemo)(function() {
        var _showCTA;
        if (!intersection || !callToAction || !((_showCTA = showCTA) === null || _showCTA === void 0 ? void 0 : _showCTA.current)) {
            return false;
        }
        var bottom = intersection.boundingClientRect.bottom;
        return intersection.isIntersecting || bottom < 0;
    }, [
        callToAction,
        intersection,
        showCTA
    ]);
};

;// CONCATENATED MODULE: ./src/components/AppBar/getProgressOfRange.ts
/**
 * Given a percent, max, and min.  Determine the number that is some percent between
 * max and min.
 *
 * @example
 * getProgressOfRange(.5, 0, 10) // 5
 */ var getProgressOfRange = function(percent, min, max) {
    return percent * 100 * (max - min) / 100 + min;
};

;// CONCATENATED MODULE: external "fastdom"
const external_fastdom_namespaceObject = require("fastdom");
var external_fastdom_default = /*#__PURE__*/__webpack_require__.n(external_fastdom_namespaceObject);
;// CONCATENATED MODULE: ./src/components/AppBar/useScrollProgress.ts
function useScrollProgress_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useScrollProgress_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useScrollProgress_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useScrollProgress_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useScrollProgress_sliced_to_array(arr, i) {
    return useScrollProgress_array_with_holes(arr) || useScrollProgress_iterable_to_array_limit(arr, i) || useScrollProgress_unsupported_iterable_to_array(arr, i) || useScrollProgress_non_iterable_rest();
}
function useScrollProgress_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useScrollProgress_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useScrollProgress_array_like_to_array(o, minLen);
}





var threshold = buildThresholdList(LOGO_SIZE * 5);
function getScrollY() {
    var _browserOnly;
    return (_browserOnly = browserOnly(function(window) {
        return typeof window.scrollY === "number" ? window.scrollY : window.pageYOffset;
    })) !== null && _browserOnly !== void 0 ? _browserOnly : 0;
}
function getScrollProgress() {
    var scrollY = getScrollY();
    var scrollProgress = scrollY / LOGO_SIZE;
    return Math.min(scrollProgress, 1);
}
function useScrollProgress(content) {
    var _useState = useScrollProgress_sliced_to_array((0,external_react_namespaceObject.useState)(getScrollProgress()), 2), scrollProgress = _useState[0], setScrollProgress = _useState[1];
    var intersection = useIntersection(content, {
        threshold: threshold
    });
    (0,external_react_namespaceObject.useEffect)(function() {
        return browserOnly(function(window) {
            if (!intersection || !content) return;
            var intersectionTop = intersection.intersectionRect.top;
            var boundingTop = intersection.boundingClientRect.top;
            var attachListener = false;
            if (boundingTop > 0) {
                // Content above the AppBar
                attachListener = intersectionTop > 0;
            } else {
                // Nothing above the AppBar
                attachListener = Math.abs(boundingTop) <= LOGO_SIZE;
            }
            var scrollListener = function() {
                external_fastdom_default().measure(function() {
                    setScrollProgress(getScrollProgress());
                });
            };
            if (attachListener) {
                window.addEventListener("scroll", scrollListener);
            } else if (!attachListener) {
                // Set to 1 on detach to ensure we don't get stuck in a smaller progress value
                // This also fixes scroll position restore after a refresh
                setScrollProgress(1);
                window.removeEventListener("scroll", scrollListener);
            }
            return function() {
                return window.removeEventListener("scroll", scrollListener);
            };
        });
    }, [
        content,
        intersection
    ]);
    return scrollProgress;
}

;// CONCATENATED MODULE: ./src/components/AppBar/useScrollingStyles.ts





var calculateOpacity = function(isOpen, overlay, scrollProgress) {
    return isOpen || !overlay ? 1 : scrollProgress;
};
var calculateTranslate = function(isOpen, scrollProgress, hasContentAbove) {
    if (isOpen) return LOGO_TRANSLATE;
    var logoDown = !hasContentAbove || scrollProgress >= 0.7;
    return logoDown ? LOGO_TRANSLATE : LOGO_TRANSLATE * -1;
};
var calculateShadowOpacity = function(isOpen, scrollProgress) {
    if (isOpen) return SHADOW_OPACITY;
    return getProgressOfRange(scrollProgress, 0, SHADOW_OPACITY);
};
var calculateLinkTheme = function(isOpen, scrollProgress, overlay, darkTheme) {
    var canBeDark = overlay && darkTheme;
    if (isOpen || !canBeDark) return LinkModes[1];
    return scrollProgress > 0.7 ? LinkModes[1] : LinkModes[0];
};
var useScrollingStyles = function(param) {
    var _param_overlay = param.overlay, overlay = _param_overlay === void 0 ? false : _param_overlay, _param_darkTheme = param.darkTheme, darkTheme = _param_darkTheme === void 0 ? false : _param_darkTheme, content = param.content, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, _param_hasContentAbove = param.hasContentAbove, hasContentAbove = _param_hasContentAbove === void 0 ? false : _param_hasContentAbove;
    var scrollProgress = useScrollProgress(content);
    return (0,external_react_namespaceObject.useMemo)(function() {
        var opacity = calculateOpacity(isOpen, overlay, scrollProgress);
        var shadowOpacity = calculateShadowOpacity(isOpen, scrollProgress);
        var logoTranslate = calculateTranslate(isOpen, scrollProgress, hasContentAbove);
        var linkTheme = calculateLinkTheme(isOpen, scrollProgress, overlay, darkTheme);
        return {
            linkTheme: linkTheme,
            backgroundColor: "rgba(255, 255, 255, ".concat(opacity, ")"),
            boxShadow: "0 2px 12px 0 rgba(0, 0, 0, ".concat(shadowOpacity, ")"),
            logoTranslate: logoTranslate
        };
    }, [
        darkTheme,
        hasContentAbove,
        isOpen,
        overlay,
        scrollProgress
    ]);
};

;// CONCATENATED MODULE: external "lodash/isFunction"
const isFunction_namespaceObject = require("lodash/isFunction");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction_namespaceObject);
;// CONCATENATED MODULE: ./src/components/ArrowButton/ArrowButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ArrowButton = ({"horizontal-offset":"-2px","horizontalOffset":"-2px","vertical-offset":"-1px","verticalOffset":"-1px","button":"bfnQ5G","default":"DJf5qN","white-bg":"r_l5bc","whiteBg":"r_l5bc","right":"ryJxkf","left":"Z4__tI","down":"SfLqsk","up":"p8SXdm","sm":"zdDa1k","md":"aEtz0L","lg":"rlXy7f"});
;// CONCATENATED MODULE: ./src/components/ArrowButton/ArrowButton.tsx
function ArrowButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ArrowButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ArrowButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ArrowButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ArrowButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ArrowButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





/** All of the available directions for this arrow to point */ var ArrowButtonDirections = (/* unused pure expression or super */ null && ([
    "up",
    "down",
    "left",
    "right"
]));
/** All available sizes for the arrow */ var ArrowButtonSize = (/* unused pure expression or super */ null && ([
    "sm",
    "md",
    "lg"
]));
/**
 * A button containing an arrow icon with a configurable direction.
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/iconbutton | IconButton} from corgi-x instead. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ArrowButton_ArrowButton = function(_param) {
    var direction = _param.direction, className = _param.className, _param_size = _param.size, size = _param_size === void 0 ? "md" : _param_size, _param_variant = _param.variant, variant = _param_variant === void 0 ? "default" : _param_variant, props = ArrowButton_object_without_properties(_param, [
        "direction",
        "className",
        "size",
        "variant"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement("button", ArrowButton_object_spread({
        type: "button",
        className: external_classnames_default()(styles_button.button, ArrowButton.button, className, ArrowButton[variant], ArrowButton[size])
    }, props), /*#__PURE__*/ external_react_namespaceObject.createElement(Arrow, {
        height: 24,
        width: 12,
        className: ArrowButton[direction],
        fill: "kale-3"
    }));
};

;// CONCATENATED MODULE: ./src/components/Carousel/CarouselItem.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CarouselItem = ({"container":"geGht0","fullWidth":"bIn5_D"});
;// CONCATENATED MODULE: ./src/components/Carousel/CarouselItem.tsx
function CarouselItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



/**
 * List item for the carousel.  Maintains a ref to the root li
 * to be sent to the click handler.  This is so the event handler
 * always receives the li element instead of a descendant of the li.
 */ var CarouselItem_CarouselItem = function(param) {
    var children = param.children, onMouseUp = param.onMouseUp, fullWidth = param.fullWidth, className = param.className;
    var self = (0,external_react_namespaceObject.useRef)(null);
    var handleMouseUp = function() {
        if (self.current) {
            onMouseUp(self.current);
        }
    };
    return /*#__PURE__*/ external_react_default().createElement("li", {
        ref: self,
        onMouseUp: handleMouseUp,
        className: external_classnames_default()(CarouselItem.container, CarouselItem_define_property({}, CarouselItem.fullWidth, fullWidth), className)
    }, children);
};
/* harmony default export */ const Carousel_CarouselItem = (CarouselItem_CarouselItem);

;// CONCATENATED MODULE: ./src/components/Carousel/isOverflowingLeft.ts
/**
 * Given an element and it's parent, where the parent has overflow x,
 * returns true if the element is partially or completely
 * out of view to the left.
 *
 * @param {Node} element
 * @param {Node} parentElement
 * @returns Boolean
 */ function isOverflowingLeft(element, parentElement) {
    if (!parentElement) return false;
    var offsetLeft = element.offsetLeft;
    var scrollLeft = parentElement.scrollLeft;
    var positionInVisibleArea = offsetLeft - scrollLeft;
    return positionInVisibleArea < 0;
}
/* harmony default export */ const Carousel_isOverflowingLeft = (isOverflowingLeft);

;// CONCATENATED MODULE: ./src/components/Carousel/isOverflowingRight.ts
/**
 * Given an element and it's parent, where the parent has overflow x,
 * returns true if the element is partially or completely
 * out of view to the right.
 *
 * @param {Node} element
 * @param {Node} parentElement
 * @returns Boolean
 */ function isOverflowingRight(element, parentElement) {
    if (!parentElement) return false;
    var offsetLeft = element.offsetLeft;
    var elementWidth = element.getBoundingClientRect().width;
    var scrollLeft = parentElement.scrollLeft;
    var scrollSnapWidth = parentElement.getBoundingClientRect().width;
    var positionInVisibleArea = offsetLeft + elementWidth - scrollLeft;
    return positionInVisibleArea > scrollSnapWidth;
}
/* harmony default export */ const Carousel_isOverflowingRight = (isOverflowingRight);

;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Carousel = ({"container":"j_fnQe","horizontalSnap":"yNnRlb","next":"q9QnBN","previous":"V89huM","blank":"NWj09_"});
;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.tsx
function Carousel_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Carousel_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Carousel_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Carousel_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Carousel_sliced_to_array(arr, i) {
    return Carousel_array_with_holes(arr) || Carousel_iterable_to_array_limit(arr, i) || Carousel_unsupported_iterable_to_array(arr, i) || Carousel_non_iterable_rest();
}
function Carousel_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Carousel_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Carousel_array_like_to_array(o, minLen);
}










/**
 * A horizontal scrolling carousel to display a collection of rich elements.
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/carousel | Carousel} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Carousel_Carousel = function(param) {
    var children = param.children, _param_withButtons = param.withButtons, withButtons = _param_withButtons === void 0 ? false : _param_withButtons, _param_centerFirstAndLast = param.centerFirstAndLast, centerFirstAndLast = _param_centerFirstAndLast === void 0 ? false : _param_centerFirstAndLast, _param_loop = param.loop, loop = _param_loop === void 0 ? false : _param_loop, _param_asSlides = param.asSlides, asSlides = _param_asSlides === void 0 ? false : _param_asSlides, className = param.className;
    var scrollSnap = (0,external_react_namespaceObject.useRef)(null);
    var _useState = Carousel_sliced_to_array((0,external_react_namespaceObject.useState)(""), 2), blankWidth = _useState[0], setBlankWidth = _useState[1];
    var id = (0,external_react_namespaceObject.useId)();
    var handlePreviousClick = function() {
        var nextChild;
        external_fastdom_default().measure(function() {
            if (!scrollSnap.current) {
                return;
            }
            if (loop && scrollSnap.current.scrollLeft === 0) {
                nextChild = centerFirstAndLast ? scrollSnap.current.children.item(scrollSnap.current.children.length - 2) : scrollSnap.current.lastChild;
            } else if (scrollSnap.current) {
                nextChild = Array.from(scrollSnap.current.children).reverse().filter(function(child) {
                    return Boolean(child);
                }).find(function(child) {
                    return Carousel_isOverflowingLeft(child, scrollSnap.current);
                });
                if (!nextChild) {
                    nextChild = centerFirstAndLast ? scrollSnap.current.children.item(1) : scrollSnap.current.firstChild;
                }
            }
        });
        external_fastdom_default().mutate(function() {
            if (nextChild) {
                nextChild.scrollIntoView({
                    inline: "center",
                    block: "nearest",
                    behavior: "smooth"
                });
            }
        });
    };
    var handleNextClick = function() {
        var nextChild;
        external_fastdom_default().measure(function() {
            if (!scrollSnap.current) {
                return;
            }
            var maxScroll = scrollSnap.current.scrollWidth - scrollSnap.current.clientWidth;
            if (loop && scrollSnap.current.scrollLeft === maxScroll) {
                nextChild = centerFirstAndLast ? scrollSnap.current.children.item(1) : scrollSnap.current.firstChild;
            } else {
                nextChild = Array.from(scrollSnap.current.children).filter(function(child) {
                    return Boolean(child);
                }).find(function(child) {
                    return Carousel_isOverflowingRight(child, scrollSnap.current);
                });
                if (!nextChild) {
                    nextChild = centerFirstAndLast ? scrollSnap.current.children.item(scrollSnap.current.children.length - 2) : scrollSnap.current.lastChild;
                }
            }
        });
        external_fastdom_default().mutate(function() {
            if (nextChild) {
                nextChild.scrollIntoView({
                    inline: "center",
                    block: "nearest",
                    behavior: "smooth"
                });
            }
        });
    };
    var handleChildMouseUp = function(element) {
        var isOverflow;
        external_fastdom_default().measure(function() {
            isOverflow = Carousel_isOverflowingRight(element, scrollSnap.current) || Carousel_isOverflowingLeft(element, scrollSnap.current);
        });
        external_fastdom_default().mutate(function() {
            if (isOverflow) {
                element.scrollIntoView({
                    inline: "center",
                    block: "nearest",
                    behavior: "smooth"
                });
            }
        });
    };
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!scrollSnap.current) return;
        var firstRealChild = scrollSnap.current.children.item(1);
        if (!firstRealChild) return;
        var childWidth = firstRealChild.getBoundingClientRect().width;
        setBlankWidth("calc(50% - ".concat(childWidth / 2, "px)"));
    }, []);
    var childProps = {
        onMouseUp: handleChildMouseUp,
        fullWidth: asSlides
    };
    return /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(Carousel.container, className)
    }, withButtons && /*#__PURE__*/ external_react_default().createElement(ArrowButton_ArrowButton, {
        onClick: handlePreviousClick,
        direction: "left",
        "aria-label": "previous",
        "aria-controls": id,
        className: Carousel.previous
    }), /*#__PURE__*/ external_react_default().createElement(ScrollSnap_ScrollSnap, {
        as: "ul",
        id: id,
        ref: scrollSnap,
        className: Carousel.horizontalSnap
    }, centerFirstAndLast && /*#__PURE__*/ external_react_default().createElement("li", {
        className: external_classnames_default()(Carousel.blank, Carousel.left),
        style: {
            marginRight: blankWidth
        }
    }), isFunction_default()(children) ? children(childProps) : external_react_namespaceObject.Children.map(children, function(child) {
        return /*#__PURE__*/ external_react_default().createElement(Carousel_CarouselItem, childProps, child);
    }), centerFirstAndLast && /*#__PURE__*/ external_react_default().createElement("li", {
        className: external_classnames_default()(Carousel.blank, Carousel.right),
        style: {
            marginLeft: blankWidth
        }
    })), withButtons && /*#__PURE__*/ external_react_default().createElement(ArrowButton_ArrowButton, {
        onClick: handleNextClick,
        direction: "right",
        "aria-label": "next",
        "aria-controls": id,
        className: Carousel.next
    }));
};

;// CONCATENATED MODULE: ./src/components/HorizontalNavigation/HorizontalNavigation.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HorizontalNavigation = ({"carousel":"s8yHlP"});
;// CONCATENATED MODULE: ./src/components/HorizontalNavigation/HorizontalNavigation.tsx




/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/navbar | NavBar} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var HorizontalNavigation_HorizontalNavigation = function(param) {
    var withButtons = param.withButtons, children = param.children, className = param.className;
    return /*#__PURE__*/ external_react_default().createElement(Carousel_Carousel, {
        withButtons: withButtons,
        className: external_classnames_default()(HorizontalNavigation.carousel, className)
    }, children);
};

;// CONCATENATED MODULE: ./src/components/HorizontalNavigationItem/HorizontalNavigationItem.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HorizontalNavigationItem = ({"nav-item":"yOqosL","navItem":"yOqosL","active":"BW2XKF"});
;// CONCATENATED MODULE: ./src/components/HorizontalNavigationItem/HorizontalNavigationItem.tsx
function HorizontalNavigationItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/navbar | NavBar} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var HorizontalNavigationItem_HorizontalNavigationItem = function(param) {
    var to = param.to, href = param.href, disabled = param.disabled, active = param.active, children = param.children, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ external_react_default().createElement(Link_Link, {
        variant: "secondary",
        mode: "dark",
        to: to,
        href: href,
        disabled: disabled,
        onClick: onClick,
        activeClassName: HorizontalNavigationItem.active,
        className: external_classnames_default()(HorizontalNavigationItem.navItem, className, HorizontalNavigationItem_define_property({}, HorizontalNavigationItem.active, active))
    }, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        bold: true,
        variant: "heading-16"
    }, children));
};

;// CONCATENATED MODULE: ./src/components/AppBar/SmallLabel.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SmallLabel = ({"container":"DQoG9Z","padding":"JXRsRN","small":"rJrKsr","active":"fUsZOM"});
;// CONCATENATED MODULE: ./src/components/AppBar/SmallLabel.tsx




var SmallLabel_SmallLabel = function(param) {
    var title = param.title, className = param.className;
    return /*#__PURE__*/ external_react_default().createElement("div", null, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        color: "kale-3",
        variant: "heading-21",
        className: external_classnames_default()(SmallLabel.container, SmallLabel.padding)
    }, /*#__PURE__*/ external_react_default().createElement("label", {
        className: external_classnames_default()(className, SmallLabel.small, SmallLabel.active)
    }, title)));
};

;// CONCATENATED MODULE: ./src/components/AppBar/Large.tsx
function Large_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Large_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Large_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Large_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Large_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Large_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var Large_Large = function(param) {
    var overlay = param.overlay, content = param.content, leftItems = param.leftItems, rightItems = param.rightItems, smallRightLabel = param.smallRightLabel, persistentItem = param.persistentItem, subNavItems = param.subNavItems, callToAction = param.callToAction, showCTA = param.showCTA, onCallToActionClick = param.onCallToActionClick, darkTheme = param.darkTheme, logoTo = param.logoTo, logoHref = param.logoHref, hasContentAbove = param.hasContentAbove;
    var nav = (0,external_react_namespaceObject.useRef)(null);
    var _useScrollingStyles = useScrollingStyles({
        overlay: overlay,
        darkTheme: darkTheme,
        content: content,
        hasContentAbove: hasContentAbove
    }), backgroundColor = _useScrollingStyles.backgroundColor, boxShadow = _useScrollingStyles.boxShadow, logoTranslate = _useScrollingStyles.logoTranslate, linkTheme = _useScrollingStyles.linkTheme;
    var showCallToAction = useCallToActionObserver(showCTA, callToAction);
    var alwaysShowCallToAction = !showCTA && callToAction;
    var logoLinkProps = logoTo ? {
        to: logoTo
    } : {
        href: logoHref
    };
    return /*#__PURE__*/ external_react_default().createElement("div", {
        style: {
            backgroundColor: backgroundColor,
            boxShadow: boxShadow
        }
    }, /*#__PURE__*/ external_react_default().createElement("nav", {
        role: "navigation",
        className: Large.nav,
        style: {
            backgroundColor: backgroundColor
        },
        ref: nav
    }, /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, /*#__PURE__*/ external_react_default().createElement(AppBar_Logo_Logo, Large_object_spread_props(Large_object_spread({}, logoLinkProps), {
        translate: logoTranslate
    })), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        bold: true,
        className: external_classnames_default()(Large.items, Large.left),
        as: "ul"
    }, leftItems.map(function(item) {
        return /*#__PURE__*/ external_react_default().createElement("li", {
            key: item.title
        }, /*#__PURE__*/ external_react_default().createElement(Link_Link, Large_object_spread_props(Large_object_spread({}, item), {
            activeClassName: Large.active,
            className: external_classnames_default()(Large.link, item.className),
            variant: "secondary",
            mode: linkTheme
        }), item.title));
    })), smallRightLabel && /*#__PURE__*/ external_react_default().createElement(SmallLabel_SmallLabel, {
        title: smallRightLabel
    }), rightItems && /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        bold: true,
        className: external_classnames_default()(Large.items, Large.right),
        as: "ul"
    }, rightItems.map(function(item) {
        return /*#__PURE__*/ external_react_default().createElement("li", {
            key: item.title
        }, /*#__PURE__*/ external_react_default().createElement(Link_Link, Large_object_spread_props(Large_object_spread({}, item), {
            activeClassName: Large.active,
            className: external_classnames_default()(Large.link, item.className),
            variant: "secondary",
            mode: linkTheme
        }), item.title));
    })), callToAction && (showCallToAction || alwaysShowCallToAction) && /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(Large.items, Large.callToAction)
    }, /*#__PURE__*/ external_react_default().createElement(CallToAction_CallToAction, Large_object_spread_props(Large_object_spread({}, callToAction), {
        onClick: onCallToActionClick,
        asPill: true
    }))), persistentItem && /*#__PURE__*/ external_react_default().createElement(Link_Link, Large_object_spread_props(Large_object_spread({}, persistentItem), {
        className: external_classnames_default()(Large.link, persistentItem.className),
        variant: rightItems ? "primary" : "secondary",
        mode: linkTheme
    }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        bold: true
    }, persistentItem.title)))), subNavItems && /*#__PURE__*/ external_react_default().createElement("div", {
        className: Large.horizontalNavContainer,
        "aria-label": "subnavigation"
    }, /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, {
        className: Large.horizontalNavContentRow
    }, /*#__PURE__*/ external_react_default().createElement(HorizontalNavigation_HorizontalNavigation, {
        withButtons: false
    }, subNavItems.map(function(item) {
        var linkProps = isAnchorLink(item) ? {
            href: item.href
        } : {
            to: item.to
        };
        return /*#__PURE__*/ external_react_default().createElement(HorizontalNavigationItem_HorizontalNavigationItem, Large_object_spread({
            className: Large.horizontalNavLink,
            key: item.title
        }, linkProps), item.title);
    })))));
};

;// CONCATENATED MODULE: ./src/components/Divider/Divider.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Divider = ({"container":"Rbd79x","horizontal":"JdnPzo","vertical":"dXatUl","kale-3":"soDGQG","kale3":"soDGQG","white":"mn2P4r","charcoal-3":"lOMfWj","charcoal3":"lOMfWj","charcoal-1":"byPGJU","charcoal1":"byPGJU","charcoal-0":"S9llx6","charcoal0":"S9llx6","oyster-0":"Mvsi3y","oyster0":"Mvsi3y","kale-1":"GrZZAD","kale1":"GrZZAD","carrot-1":"XzI7er","carrot1":"XzI7er","chickpea-2":"YWj5Dj","chickpea2":"YWj5Dj","carrot-2":"FWAqcn","carrot2":"FWAqcn","carrot-3":"sTKEdh","carrot3":"sTKEdh"});
;// CONCATENATED MODULE: ./src/components/Divider/Divider.tsx
function Divider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Divider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Divider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Divider_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Divider_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Divider_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var horizontal = Divider.horizontal, vertical = Divider.vertical, container = Divider.container;
var DividerOrientations = [
    "horizontal",
    "vertical"
];
var DividerColors = [
    "kale-3",
    "white",
    "charcoal-3",
    "charcoal-1",
    "oyster-0",
    "charcoal-0",
    "kale-1",
    "carrot-1",
    "chickpea-2",
    "carrot-2",
    "carrot-3"
];
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/divider | Divider} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Divider_Divider = function(_param) {
    var orientation = _param.orientation, _param_style = _param.style, style = _param_style === void 0 ? "solid" : _param_style, _param_margin = _param.margin, margin = _param_margin === void 0 ? 13 : _param_margin, color = _param.color, _param_width = _param.width, width = _param_width === void 0 ? 2 : _param_width, className = _param.className, props = Divider_object_without_properties(_param, [
        "orientation",
        "style",
        "margin",
        "color",
        "width",
        "className"
    ]);
    var isHorizontal = orientation === "horizontal";
    var margins = isHorizontal ? {
        marginTop: margin,
        marginBottom: margin
    } : {
        marginLeft: margin,
        marginRight: margin
    };
    var colorClass = color ? Divider[color] : undefined;
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("div", Divider_object_spread({
        role: "separator",
        "aria-orientation": orientation,
        className: external_classnames_default()(container, (_obj = {}, Divider_define_property(_obj, horizontal, isHorizontal), Divider_define_property(_obj, vertical, !isHorizontal), _obj), colorClass, className),
        style: Divider_object_spread({
            borderColor: !colorClass ? color : undefined,
            borderStyle: style,
            borderTopWidth: isHorizontal ? width : 0,
            borderLeftWidth: isHorizontal ? 0 : width
        }, margins)
    }, props));
};

;// CONCATENATED MODULE: ./src/components/AppBar/HamburgerButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HamburgerButton = ({"container":"BxqR5q","bar":"lSet74","darkTheme":"dJHERF","x":"XnsV8r"});
;// CONCATENATED MODULE: ./src/components/AppBar/HamburgerButton.tsx
function HamburgerButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var HamburgerButton_HamburgerButton = function(param) {
    var onClick = param.onClick, isOpen = param.isOpen, mode = param.mode;
    var barClassName = external_classnames_default()(HamburgerButton.bar, HamburgerButton_define_property({}, HamburgerButton.darkTheme, mode === LinkModes[0]));
    return /*#__PURE__*/ external_react_default().createElement("button", {
        type: "button",
        role: "button",
        "aria-label": "".concat(isOpen ? "close" : "open", " menu"),
        "aria-expanded": isOpen,
        className: external_classnames_default()(HamburgerButton.container, HamburgerButton_define_property({}, HamburgerButton.x, isOpen)),
        onClick: onClick
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        className: barClassName
    }), /*#__PURE__*/ external_react_default().createElement("div", {
        className: barClassName
    }), /*#__PURE__*/ external_react_default().createElement("div", {
        className: barClassName
    }));
};

;// CONCATENATED MODULE: ./src/components/AppBar/Mobile.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Mobile = ({"nav":"MN7Daw g97HzC","navItem":"IgmX5G","callToAction":"llSfzN","menu":"aW5oZr","items":"Z5_pmL","logo":"iWVkyj","link":"xzhMbu","inNav":"Mr3wuh","active":"yiUZDT","persistentLink":"S8AKlI","shortDivider":"dPnqLn","ctaContainer":"cmHK7_","lastDivider":"mAp0mM","horizontalNavContainer":"KJMVV0","horizontalNavContentRow":"Yc2yTy"});
;// CONCATENATED MODULE: ./src/components/AppBar/Mobile.tsx
function Mobile_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Mobile_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Mobile_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Mobile_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Mobile_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Mobile_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var Mobile_Mobile = function(param) {
    var overlay = param.overlay, darkTheme = param.darkTheme, content = param.content, leftItems = param.leftItems, rightItems = param.rightItems, persistentItem = param.persistentItem, callToAction = param.callToAction, subNavItems = param.subNavItems, showCTA = param.showCTA, onCallToActionClick = param.onCallToActionClick, onToggle = param.onToggle, logoTo = param.logoTo, logoHref = param.logoHref, hasContentAbove = param.hasContentAbove;
    var _useLightboxControl = useLightboxControl({
        initialIsOpen: false,
        id: "appbar-lightbox",
        onToggle: onToggle
    }), rootProps = _useLightboxControl.rootProps, toggle = _useLightboxControl.toggle, isOpen = _useLightboxControl.isOpen;
    var nav = (0,external_react_namespaceObject.useRef)(null);
    var _useScrollingStyles = useScrollingStyles({
        overlay: overlay,
        darkTheme: darkTheme,
        content: content,
        hasContentAbove: hasContentAbove,
        isOpen: isOpen
    }), backgroundColor = _useScrollingStyles.backgroundColor, boxShadow = _useScrollingStyles.boxShadow, logoTranslate = _useScrollingStyles.logoTranslate, linkTheme = _useScrollingStyles.linkTheme;
    var showCallToAction = useCallToActionObserver(showCTA, callToAction);
    var logoLinkProps = logoTo ? {
        to: logoTo
    } : {
        href: logoHref
    };
    return /*#__PURE__*/ external_react_default().createElement("div", {
        style: {
            backgroundColor: backgroundColor,
            boxShadow: boxShadow
        }
    }, /*#__PURE__*/ external_react_default().createElement("nav", {
        role: "navigation",
        className: Mobile.nav,
        ref: nav
    }, /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, /*#__PURE__*/ external_react_default().createElement("div", {
        className: Mobile.navItem
    }, /*#__PURE__*/ external_react_default().createElement(HamburgerButton_HamburgerButton, {
        onClick: toggle,
        isOpen: isOpen,
        mode: linkTheme
    })), (!showCallToAction || isOpen) && /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement(AppBar_Logo_Logo, Mobile_object_spread_props(Mobile_object_spread({}, logoLinkProps), {
        translate: logoTranslate,
        className: external_classnames_default()(Mobile.logo, Mobile.navItem)
    })), /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(Mobile.persistentLink, Mobile.navItem)
    }, persistentItem && /*#__PURE__*/ external_react_default().createElement(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, persistentItem), {
        className: external_classnames_default()(Mobile.link, Mobile.inNav, persistentItem.className),
        style: {
            opacity: isOpen ? 0 : 1
        },
        variant: "secondary",
        mode: linkTheme
    }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        bold: true
    }, persistentItem.title)))), showCallToAction && callToAction && !isOpen && /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(Mobile.navItem, Mobile.callToAction)
    }, /*#__PURE__*/ external_react_default().createElement(CallToAction_CallToAction, Mobile_object_spread_props(Mobile_object_spread({}, callToAction), {
        onClick: onCallToActionClick,
        asPill: true
    }))), /*#__PURE__*/ external_react_default().createElement("div", {
        className: Mobile.navItem
    })))), subNavItems && /*#__PURE__*/ external_react_default().createElement("div", {
        className: Mobile.horizontalNavContainer,
        "aria-label": "subnavigation",
        style: {
            display: isOpen ? "none" : "block"
        }
    }, /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, {
        className: Mobile.horizontalNavContentRow
    }, /*#__PURE__*/ external_react_default().createElement(HorizontalNavigation_HorizontalNavigation, {
        withButtons: false
    }, subNavItems.map(function(item) {
        var linkProps = isAnchorLink(item) ? {
            href: item.href
        } : {
            to: item.to
        };
        return /*#__PURE__*/ external_react_default().createElement(HorizontalNavigationItem_HorizontalNavigationItem, Mobile_object_spread({
            className: Mobile.horizontalNavLink,
            key: item.title
        }, linkProps), item.title);
    })))), /*#__PURE__*/ external_react_default().createElement(Lightbox_Lightbox, Mobile_object_spread({
        offsetTop: LOGO_SIZE,
        background: "white",
        className: Mobile.menu
    }, rootProps), /*#__PURE__*/ external_react_default().createElement(Divider_Divider, {
        orientation: "horizontal",
        margin: 0,
        color: OYSTER_0
    }), /*#__PURE__*/ external_react_default().createElement("ul", {
        className: Mobile.items
    }, rightItems && /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, rightItems.map(function(item) {
        return /*#__PURE__*/ external_react_default().createElement("li", {
            key: item.title
        }, /*#__PURE__*/ external_react_default().createElement(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, item), {
            activeClassName: Mobile.active,
            className: external_classnames_default()(Mobile.link, item.className),
            onClick: interceptEvent(toggle, item.onClick),
            variant: "secondary",
            mode: "dark"
        }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
            variant: "heading-21",
            bold: true
        }, item.title)), /*#__PURE__*/ external_react_default().createElement(Divider_Divider, {
            orientation: "horizontal",
            margin: 0,
            color: OYSTER_0,
            className: Mobile.shortDivider
        }));
    })), /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, leftItems.map(function(item, index) {
        return /*#__PURE__*/ external_react_default().createElement("li", {
            key: item.title
        }, /*#__PURE__*/ external_react_default().createElement(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, item), {
            className: external_classnames_default()(Mobile.link, item.className),
            activeClassName: Mobile.active,
            onClick: interceptEvent(toggle, item.onClick),
            variant: "secondary",
            mode: "dark"
        }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
            variant: "heading-21",
            bold: true
        }, item.title)), (leftItems.length !== index + 1 || persistentItem) && /*#__PURE__*/ external_react_default().createElement(Divider_Divider, {
            orientation: "horizontal",
            margin: 0,
            color: OYSTER_0,
            className: Mobile.shortDivider
        }));
    })), persistentItem && /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, /*#__PURE__*/ external_react_default().createElement(Link_Link, Mobile_object_spread_props(Mobile_object_spread({}, persistentItem), {
        className: external_classnames_default()(Mobile.link, persistentItem.className),
        onClick: interceptEvent(toggle, persistentItem.onClick),
        variant: "secondary",
        mode: "dark"
    }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-21",
        bold: true
    }, persistentItem.title)))), /*#__PURE__*/ external_react_default().createElement("div", {
        className: Mobile.ctaContainer
    }, /*#__PURE__*/ external_react_default().createElement(MaxWidth_MaxWidth, null, isOpen && callToAction && /*#__PURE__*/ external_react_default().createElement(CallToAction_CallToAction, Mobile_object_spread_props(Mobile_object_spread({
        isMobile: true
    }, callToAction), {
        withPadding: false,
        onClick: interceptEvent(toggle, callToAction.onClick)
    }))))));
};

;// CONCATENATED MODULE: ./src/components/AppBar/AppBar.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const AppBar = ({"container":"PYLduF","static":"io9mmp","isOpen":"d59Nwm","nav":"g97HzC","logo":"G9Paht"});
;// CONCATENATED MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts

// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
/** @deprecated Don't use this hook. Create one in your code. */ var useIsomorphicLayoutEffect = typeof window !== "undefined" ? external_react_namespaceObject.useLayoutEffect : external_react_namespaceObject.useEffect;

;// CONCATENATED MODULE: ./src/components/AppBar/AppBar.tsx
function AppBar_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AppBar_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function AppBar_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AppBar_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AppBar_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AppBar_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AppBar_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AppBar_sliced_to_array(arr, i) {
    return AppBar_array_with_holes(arr) || AppBar_iterable_to_array_limit(arr, i) || AppBar_unsupported_iterable_to_array(arr, i) || AppBar_non_iterable_rest();
}
function AppBar_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AppBar_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AppBar_array_like_to_array(o, minLen);
}







/**
 * The App Bar displays information and actions relating to the current screen.
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/layout | Layout} from corgi-x to build layouts with an app bar. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var AppBar_AppBar = function(props) {
    var appBarRef = (0,external_react_namespaceObject.useRef)(null);
    var _useState = AppBar_sliced_to_array((0,external_react_namespaceObject.useState)(null), 2), content = _useState[0], setContent = _useState[1];
    var _useState1 = AppBar_sliced_to_array((0,external_react_namespaceObject.useState)(false), 2), isOpen = _useState1[0], setIsOpen = _useState1[1];
    useIsomorphicLayoutEffect(function() {
        if (appBarRef.current) {
            var nextElementSibling = appBarRef.current.nextElementSibling;
            setContent(nextElementSibling);
            if (nextElementSibling && props.overlay) {
                var currentMarginTop = nextElementSibling.style.marginTop || "0px";
                nextElementSibling.style.marginTop = "calc(".concat(currentMarginTop, " - ").concat(LOGO_SIZE, "px)");
            }
        }
    }, []);
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("div", {
        ref: appBarRef,
        "data-name": "AppBar",
        className: external_classnames_default()(AppBar.container, (_obj = {}, AppBar_define_property(_obj, AppBar.isOpen, isOpen), AppBar_define_property(_obj, AppBar.static, props.static), _obj))
    }, props.large && /*#__PURE__*/ external_react_default().createElement(Large_Large, AppBar_object_spread({
        content: content
    }, props)), !props.large && /*#__PURE__*/ external_react_default().createElement(Mobile_Mobile, AppBar_object_spread({
        onToggle: setIsOpen,
        content: content
    }, props)));
};

;// CONCATENATED MODULE: ./src/components/AppBar/index.ts


;// CONCATENATED MODULE: ./src/components/AsyncModal/AsyncModal.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const AsyncModal = ({"lightbox":"mHCwcY","message":"yf4SFH","activity-indicator":"m5udZm","activityIndicator":"m5udZm"});
;// CONCATENATED MODULE: ./src/components/AsyncModal/AsyncModalContent.tsx





var AsyncModalContent = function(param) {
    var modalText = param.modalText;
    var nonWaveDesign = getNonWaveDesign();
    return /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        className: nonWaveDesign
    }, /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
        as: "div",
        variant: "heading-21",
        color: "kale-3",
        className: AsyncModal.message
    }, modalText), /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        className: AsyncModal.activityIndicator
    }, /*#__PURE__*/ external_react_namespaceObject.createElement(ActivityIndicator_ActivityIndicator, {
        mode: "dark"
    })));
};

;// CONCATENATED MODULE: ./src/components/AsyncModal/AsyncModal.tsx
function AsyncModal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AsyncModal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AsyncModal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AsyncModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function AsyncModal_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        AsyncModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AsyncModal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = AsyncModal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function AsyncModal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var UNSET_WIDTH = "";
var MIN_HEIGHT = 0;
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/activitymodal | ActivityModal} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var AsyncModal_AsyncModal = function(_param) {
    var modalText = _param.modalText, promptText = _param.promptText, className = _param.className, rootProps = _param.rootProps, props = AsyncModal_object_without_properties(_param, [
        "modalText",
        "promptText",
        "className",
        "rootProps"
    ]);
    var modalDesign = getModalDesign_getModalDesign();
    external_react_namespaceObject.useEffect(function() {
        if (!rootProps.isOpen) return;
        var warnBeforeUnload = function(e) {
            // needs a dummy value even though message isn't customizable in all browsers
            e.returnValue = "You're in the middle of checking out. Are you sure you want to leave...?";
        };
        browserOnly(function(window) {
            return window.addEventListener("beforeunload", warnBeforeUnload);
        });
        return function() {
            return browserOnly(function(window) {
                return window.removeEventListener("beforeunload", warnBeforeUnload);
            });
        };
    }, [
        rootProps.isOpen
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(Lightbox_Lightbox, AsyncModal_object_spread_props(AsyncModal_object_spread({}, rootProps, props), {
        width: UNSET_WIDTH,
        height: MIN_HEIGHT,
        disableInteractions: true,
        className: external_classnames_default()(modalDesign, AsyncModal.lightbox, className)
    }), /*#__PURE__*/ external_react_namespaceObject.createElement(AsyncModalContent, {
        modalText: modalText
    }), /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_router_dom_namespaceObject.Prompt, {
        when: rootProps.isOpen,
        message: promptText
    }));
};

;// CONCATENATED MODULE: ./src/components/AsyncModal/index.ts


;// CONCATENATED MODULE: ./src/components/Breadcrumbs/splitPath.ts
/**
 * Split a path into an array of its component pieces.
 */ function splitPath(path) {
    if (path.startsWith("/")) {
        return path.split("/").slice(1);
    }
    return path.split("/");
}

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/stringifyUrl.ts
/**
 * Default method for converting a url fragment to a readable title string.
 */ function stringifyUrl(url) {
    var words = url.split("-");
    return words.map(function(word, index) {
        return index === 0 ? "".concat(word.charAt(0).toUpperCase()).concat(word.slice(1)) : word;
    }).join(" ");
}

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Breadcrumbs = ({"caret":"pVkLE7","active":"QugDJU"});
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.tsx
function Breadcrumbs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Breadcrumbs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Breadcrumbs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Breadcrumbs_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Breadcrumbs_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Breadcrumbs_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/breadcrumbs | BreadCrumbs} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Breadcrumbs_Breadcrumbs = function(_param) {
    var _param_stringify = _param.stringify, stringify = _param_stringify === void 0 ? stringifyUrl : _param_stringify, pathnameProp = _param.pathname, _param_stem = _param.stem, stem = _param_stem === void 0 ? "" : _param_stem, containerClassName = _param.containerClassName, props = Breadcrumbs_object_without_properties(_param, [
        "stringify",
        "pathname",
        "stem",
        "containerClassName"
    ]);
    var location = (0,external_react_router_dom_namespaceObject.useLocation)();
    var pathname = pathnameProp || location.pathname;
    var breadcrumbs = splitPath(pathname);
    var stems = splitPath(stem);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
        as: "div",
        variant: "heading-16",
        className: containerClassName
    }, breadcrumbs.map(function(breadcrumb, index) {
        var previousBreadcrumbs = breadcrumbs.slice(0, index + 1);
        var isLast = index === breadcrumbs.length - 1;
        if (stems.includes(breadcrumb)) {
            return null;
        }
        var path = "/".concat(previousBreadcrumbs.join("/"));
        return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_namespaceObject.Fragment, {
            key: path
        }, /*#__PURE__*/ external_react_namespaceObject.createElement(Link_Link, Breadcrumbs_object_spread({
            to: path,
            mode: "dark",
            variant: "secondary",
            activeClassName: Breadcrumbs.active,
            disabled: isLast
        }, props), stringify(breadcrumb)), !isLast && /*#__PURE__*/ external_react_namespaceObject.createElement(Arrow, {
            className: Breadcrumbs.caret
        }));
    }));
};

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.ts


;// CONCATENATED MODULE: ./src/components/Card/Card.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Card = ({"container":"RIf1em","shadow":"sgg9Kt"});
;// CONCATENATED MODULE: ./src/components/Card/elevation.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Card_elevation = ({"level0":"Cy_6fc","level1":"znd8uY"});
;// CONCATENATED MODULE: ./src/components/Card/Card.tsx
function Card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Card_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Card_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Card_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Card_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var CardHTMLElements = [
    "figure",
    "div"
];
function Card_Card(_param) {
    var children = _param.children, _param_elevation = _param.elevation, elevation = _param_elevation === void 0 ? 0 : _param_elevation, className = _param.className, tmp = _param.as, HTMLElement = tmp === void 0 ? "figure" : tmp, props = Card_object_without_properties(_param, [
        "children",
        "elevation",
        "className",
        "as"
    ]);
    return /*#__PURE__*/ external_react_default().createElement(HTMLElement, Card_object_spread({
        className: external_classnames_default()(Card.container, className, Card_elevation["level".concat(elevation)])
    }, props), children);
}

;// CONCATENATED MODULE: ./src/components/Card/index.ts


;// CONCATENATED MODULE: ./src/components/Carousel/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity



;// CONCATENATED MODULE: ./src/components/ContentWidth/ContentWidth.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ContentWidth = ({"content":"fUNky4","start":"uiYyJa","end":"qiCrxa","center":"OLXLGe","fr-1":"Q9mOC0","fr1":"Q9mOC0","fr-2":"e8fvJ8","fr2":"e8fvJ8","fr-3":"vJt_ej","fr3":"vJt_ej","withPadding":"MI_1O7","withGutter":"YN4efK"});
;// CONCATENATED MODULE: ./src/components/ContentWidth/ContentWidth.tsx
function ContentWidth_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentWidth_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentWidth_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ContentWidth_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ContentWidth_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ContentWidth_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ContentWidthAlignment = [
    "start",
    "center",
    "end"
];
/**
 * Limit your content into 1/3 chunks that adjust based on screen width.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/grid | Grid} from corgi-x to create grid layouts. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ContentWidth_ContentWidth = function(_param) {
    var _param_fr = _param.fr, fr = _param_fr === void 0 ? 1 : _param_fr, className = _param.className, children = _param.children, withPadding = _param.withPadding, withGutter = _param.withGutter, _param_alignSelf = _param.alignSelf, alignSelf = _param_alignSelf === void 0 ? "start" : _param_alignSelf, props = ContentWidth_object_without_properties(_param, [
        "fr",
        "className",
        "children",
        "withPadding",
        "withGutter",
        "alignSelf"
    ]);
    var _obj;
    return /*#__PURE__*/ external_react_namespaceObject.createElement("div", ContentWidth_object_spread({
        className: external_classnames_default()(ContentWidth.content, (_obj = {}, ContentWidth_define_property(_obj, ContentWidth.withPadding, withPadding), ContentWidth_define_property(_obj, ContentWidth.withGutter, withGutter), _obj), ContentWidth["fr-".concat(fr)], ContentWidth[alignSelf], className)
    }, props), children);
};

;// CONCATENATED MODULE: ./src/components/ContentWidth/index.ts



;// CONCATENATED MODULE: ./src/components/CreditCard/constants.ts

/**
 * Element style properties. Stripe applies these directly to the input element
 * inside the `iframe` while the css classes are only applied to the root
 * element. Unfortunately we must use this inline approach as the other approach
 * does not work correctly.
 */ var ELEMENT_PROPS = {
    classes: {
        base: "NOOP",
        complete: "NOOP",
        empty: "NOOP",
        focus: "NOOP",
        invalid: "NOOP"
    },
    style: {
        base: {
            color: KALE_3,
            fontWeight: "400",
            fontFamily: '"neue-haas-grotesk-display", serif',
            fontSize: "16px",
            letterSpacing: "0.5px"
        },
        invalid: {
            color: ERROR_RED
        }
    }
};

;// CONCATENATED MODULE: external "lodash/pick"
const pick_namespaceObject = require("lodash/pick");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick_namespaceObject);
;// CONCATENATED MODULE: ./src/components/Stripe/ElementsContext.tsx

var INITIAL_VALUE = {};
var ElementsContext = /*#__PURE__*/ external_react_namespaceObject.createContext(INITIAL_VALUE);

;// CONCATENATED MODULE: ./src/components/Stripe/useElements.ts


/**
 * Return the elements context value
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useStripeElements | useStripeElements} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useElements() {
    return external_react_namespaceObject.useContext(ElementsContext);
}

;// CONCATENATED MODULE: ./src/components/Stripe/elementTypes.ts
/** An enum of valid element types that is supported by this module */ var elementTypes;
(function(elementTypes) {
    elementTypes["cardNumber"] = "cardNumber";
    elementTypes["cardCvc"] = "cardCvc";
    elementTypes["cardExpiry"] = "cardExpiry";
})(elementTypes || (elementTypes = {}));

;// CONCATENATED MODULE: ./src/components/Stripe/utils.ts

/**
 * Safely get an element by only allowing the valid element types allowed by
 * this module
 */ function getElement(elements, elementType) {
    switch(elementType){
        case elementTypes.cardNumber:
            {
                return elements.getElement(elementType);
            }
        case elementTypes.cardCvc:
            {
                return elements.getElement(elementType);
            }
        case elementTypes.cardExpiry:
            {
                return elements.getElement(elementType);
            }
        default:
            {
                return null;
            }
    }
}
/**
 * Safely create an element by only allowing the valid element types allowed by
 * this module
 */ function create(elements, elementType, options) {
    switch(elementType){
        case elementTypes.cardNumber:
            {
                return elements.create(elementType, options);
            }
        case elementTypes.cardCvc:
            {
                return elements.create(elementType, options);
            }
        case elementTypes.cardExpiry:
            {
                return elements.create(elementType, options);
            }
        default:
            {
                return null;
            }
    }
}

;// CONCATENATED MODULE: ./src/components/Stripe/StripeElement.tsx
function StripeElement_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function StripeElement_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function StripeElement_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function StripeElement_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function StripeElement_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = StripeElement_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function StripeElement_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function StripeElement_sliced_to_array(arr, i) {
    return StripeElement_array_with_holes(arr) || StripeElement_iterable_to_array_limit(arr, i) || StripeElement_unsupported_iterable_to_array(arr, i) || StripeElement_non_iterable_rest();
}
function StripeElement_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return StripeElement_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return StripeElement_array_like_to_array(o, minLen);
}





/**
 * Allowed options differ based on element type. These are the options that are
 * valid based on the element types supported in this module
 *
 * {@link https://stripe.com/docs/stripe-js/reference#element-options}
 */ var ValidElementOptions = [
    "classes",
    "style",
    "disabled",
    "placeholder"
];
/**
 * Create a stripe element. Must be used inside the context of a
 * `StripeProvider` and an `ElementsProvider`
 */ var StripeElement = function(_param) {
    var className = _param.className, elementType = _param.elementType, onChange = _param.onChange, onBlur = _param.onBlur, onFocus = _param.onFocus, onReady = _param.onReady, props = StripeElement_object_without_properties(_param, [
        "className",
        "elementType",
        "onChange",
        "onBlur",
        "onFocus",
        "onReady"
    ]);
    var elements = useElements().elements;
    var _React_useState = StripeElement_sliced_to_array(external_react_default().useState(), 2), element = _React_useState[0], setElement = _React_useState[1];
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var elementId = id ? "".concat(elementType, "-").concat(id) : undefined;
    var safeOptions = useSafeOptions(pick_default()(props, ValidElementOptions));
    /**
   * Create a stripe element or update an existing stripe element. If the
   * element already exists we can update the options. Each element must belong
   * to an elements set that is created by the StripeContext.
   */ external_react_default().useEffect(function() {
        if (!elements) {
            return;
        }
        var cachedElement = getElement(elements, elementType);
        if (!element && cachedElement) {
            cachedElement.clear();
            setElement(cachedElement);
            return;
        }
        if (!element) {
            setElement(create(elements, elementType, safeOptions));
            return;
        }
        element.update(safeOptions);
    }, [
        elements,
        element,
        elementType,
        safeOptions
    ]);
    /*
   * After an element is created in-memory it must be mounted to the dom. This
   * is where the actual iframe is added to the dom.
   */ external_react_default().useEffect(function() {
        if (!elementId || !element) {
            return;
        }
        // Note: using `#${elementId}` as a selector here throws an error because
        // the element id contains characters that cannot be used in a selector
        var domElement = document.getElementById(elementId);
        if (domElement) {
            element.mount(domElement);
        }
        return function() {
            return element.unmount();
        };
    }, [
        element,
        elementId
    ]);
    /**
   * To support react style handler functions they must be stored inside a
   * mutable ref. This is so we only attach a handler once inside each iframe
   * element.
   */ var handlers = external_react_default().useRef({
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onReady: onReady
    });
    external_react_default().useEffect(function() {
        handlers.current = {
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            onReady: onReady
        };
    });
    /**
   * These handlers element.on('event') get attached inside the iframe. In order
   * to use react style syntax here we must attach a single handler for each
   * event and then call the current available handler that is passed in as a
   * prop. This works because we do not need to re-render or update anything
   * when these handlers change. Stripe doesn't even allow us to update them and
   * this is much more performative.
   */ external_react_default().useEffect(function() {
        if (!element) {
            return;
        }
        /**
     * The type definitions for element are very strange as they can one of many
     * types. We enforce our types at runtime so we can safely ignore this
     * error.
     */ // @ts-ignore
        element.on("change", function(event) {
            if (handlers.current.onChange) {
                handlers.current.onChange(event, element);
            }
        });
        // @ts-ignore
        element.on("ready", function() {
            if (handlers.current.onReady) {
                handlers.current.onReady(element);
            }
        });
        // @ts-ignore
        element.on("blur", function() {
            if (handlers.current.onBlur) {
                handlers.current.onBlur(element);
            }
        });
        // @ts-ignore
        element.on("focus", function() {
            if (handlers.current.onFocus) {
                handlers.current.onFocus(element);
            }
        });
    }, [
        element,
        handlers
    ]);
    return /*#__PURE__*/ external_react_default().createElement("div", {
        id: elementId,
        "data-name": elementType,
        className: className
    });
};

;// CONCATENATED MODULE: ./src/components/CreditCard/CardField.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CardField = ({"input":"mlUioY"});
;// CONCATENATED MODULE: ./src/components/CreditCard/CardField.tsx
function CardField_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CardField_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function CardField_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardField_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CardField_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CardField_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardField_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CardField_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = CardField_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CardField_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CardField_sliced_to_array(arr, i) {
    return CardField_array_with_holes(arr) || CardField_iterable_to_array_limit(arr, i) || CardField_unsupported_iterable_to_array(arr, i) || CardField_non_iterable_rest();
}
function CardField_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CardField_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CardField_array_like_to_array(o, minLen);
}








/**
 * Get the current error message giving preference to errors passed in from
 * props and defaulting to any error messages generated by the stripe change
 * event.
 */ function getError(event, error) {
    var _event_error, _event;
    if (error) {
        return error;
    }
    return (_event = event) === null || _event === void 0 ? void 0 : (_event_error = _event.error) === null || _event_error === void 0 ? void 0 : _event_error.message;
}
/**
 * Render a stripe card field with the CORGI input style
 */ var CardField_CardField = function(_param) {
    var label = _param.label, elementType = _param.elementType, onBlur = _param.onBlur, onFocus = _param.onFocus, onChange = _param.onChange, error = _param.error, className = _param.className, elementClassName = _param.elementClassName, children = _param.children, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = CardField_object_without_properties(_param, [
        "label",
        "elementType",
        "onBlur",
        "onFocus",
        "onChange",
        "error",
        "className",
        "elementClassName",
        "children",
        "hideLabel"
    ]);
    var _event;
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var _React_useState = CardField_sliced_to_array(external_react_default().useState(), 2), event = _React_useState[0], setEvent = _React_useState[1];
    var message = getError(event, error);
    var isEmpty = ((_event = event) === null || _event === void 0 ? void 0 : _event.empty) === false;
    var invalid = Boolean(message);
    var _useElementState = CardField_sliced_to_array(useElementState({
        invalid: invalid,
        disabled: props.disabled
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var handleChange = function(event) {
        setEvent(event);
    };
    return /*#__PURE__*/ external_react_default().createElement(FormControl_FormControl, {
        className: className,
        "aria-live": "polite",
        invalid: invalid,
        message: message,
        id: id,
        // Stripe doesn't allow passing of aria-describedby into the iframe. This
        // may be supported in the future
        disableAriaProps: true
    }, /*#__PURE__*/ external_react_default().createElement(BorderLabel_BorderLabel, {
        in: Boolean(state === "focus" || isEmpty),
        text: label,
        state: state,
        hideLabel: hideLabel
    }, /*#__PURE__*/ external_react_default().createElement(StripeElement, CardField_object_spread({
        elementType: elementType,
        onChange: interceptEvent(handleChange, onChange),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        placeholder: "",
        className: external_classnames_default()(CardField.input, elementClassName)
    }, ELEMENT_PROPS, props)), children));
};

;// CONCATENATED MODULE: ./src/components/CreditCard/CardCvc.tsx
function CardCvc_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardCvc_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardCvc_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CardCvc_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CardCvc_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CardCvc_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/**
 * Render a credit card cvc field. Must be inside an `ElementsProvider` and a
 * `StripeProvider`.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/creditcardinput | CreditCardInput} from corgi-x to create card fields. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var CardCvc = function(props) {
    return /*#__PURE__*/ external_react_namespaceObject.createElement(CardField_CardField, CardCvc_object_spread_props(CardCvc_object_spread({}, props), {
        elementType: elementTypes.cardCvc
    }));
};

;// CONCATENATED MODULE: ./src/components/CreditCard/CardExpiration.tsx
function CardExpiration_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardExpiration_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardExpiration_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CardExpiration_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CardExpiration_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CardExpiration_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/**
 * Render a credit card expiration field. Must be inside an `ElementsProvider`
 * and a `StripeProvider`
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/creditcardinput | CreditCardInput} from corgi-x to create card fields. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var CardExpiration = function(props) {
    return /*#__PURE__*/ external_react_namespaceObject.createElement(CardField_CardField, CardExpiration_object_spread_props(CardExpiration_object_spread({}, props), {
        elementType: elementTypes.cardExpiry
    }));
};

;// CONCATENATED MODULE: ./src/components/CreditCard/brandTypes.ts
var brandTypes;
(function(brandTypes) {
    brandTypes["amex"] = "amex";
    brandTypes["diners"] = "diners";
    brandTypes["discover"] = "discover";
    brandTypes["jcb"] = "jcb";
    brandTypes["mastercard"] = "mastercard";
    brandTypes["unknown"] = "unknown";
    brandTypes["visa"] = "visa";
})(brandTypes || (brandTypes = {}));

;// CONCATENATED MODULE: ./src/components/CreditCard/CardNumber.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CardNumber = ({"card-width":"40px","cardWidth":"40px","card-height":"25px","cardHeight":"25px","element":"iENZrZ","icon":"Msx43c","amex":"pc4WLx","diners":"eDK5PZ","discover":"T9_Tg0","jcb":"TO1Zi4","unknown":"oZob9k","visa":"IQ4cYf","mastercard":"VsiDMc"});
;// CONCATENATED MODULE: ./src/components/CreditCard/CardNumber.tsx
function CardNumber_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CardNumber_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function CardNumber_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CardNumber_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CardNumber_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CardNumber_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CardNumber_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CardNumber_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CardNumber_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CardNumber_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CardNumber_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = CardNumber_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CardNumber_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function CardNumber_sliced_to_array(arr, i) {
    return CardNumber_array_with_holes(arr) || CardNumber_iterable_to_array_limit(arr, i) || CardNumber_unsupported_iterable_to_array(arr, i) || CardNumber_non_iterable_rest();
}
function CardNumber_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CardNumber_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CardNumber_array_like_to_array(o, minLen);
}







/**
 * Render a credit card number field. Must be inside an `ElementsProvider` and a
 * `StripeProvider`
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/creditcardinput | CreditCardInput} from corgi-x to create card fields. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var CardNumber_CardNumber = function(_param) {
    var elementClassName = _param.elementClassName, onChange = _param.onChange, label = _param.label, brandProp = _param.brand, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = CardNumber_object_without_properties(_param, [
        "elementClassName",
        "onChange",
        "label",
        "brand",
        "hideLabel"
    ]);
    var _React_useState = CardNumber_sliced_to_array(external_react_namespaceObject.useState(), 2), eventBrand = _React_useState[0], setEventBrand = _React_useState[1];
    var brand = brandProp || eventBrand || brandTypes.unknown;
    var handleChange = function(event) {
        if (event.elementType === elementTypes.cardNumber) {
            setEventBrand(event.brand);
        }
    };
    return /*#__PURE__*/ external_react_namespaceObject.createElement(CardField_CardField, CardNumber_object_spread_props(CardNumber_object_spread({
        elementClassName: external_classnames_default()(CardNumber.element, elementClassName),
        onChange: interceptEvent(handleChange, onChange),
        label: label
    }, props), {
        elementType: elementTypes.cardNumber,
        hideLabel: hideLabel
    }), /*#__PURE__*/ external_react_namespaceObject.createElement("img", {
        alt: "Credit card by ".concat(brand),
        width: "32",
        className: external_classnames_default()(CardNumber.icon, CardNumber[brand])
    }));
};

;// CONCATENATED MODULE: ./src/components/CreditCard/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity




;// CONCATENATED MODULE: ./src/components/Divider/index.ts


;// CONCATENATED MODULE: ./src/hooks/useHtmlElement.ts
function useHtmlElement_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useHtmlElement_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useHtmlElement_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useHtmlElement_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useHtmlElement_sliced_to_array(arr, i) {
    return useHtmlElement_array_with_holes(arr) || useHtmlElement_iterable_to_array_limit(arr, i) || useHtmlElement_unsupported_iterable_to_array(arr, i) || useHtmlElement_non_iterable_rest();
}
function useHtmlElement_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useHtmlElement_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useHtmlElement_array_like_to_array(o, minLen);
}

/**
 * Obtain a reference to an underlying HTML element in a stateful manner. This
 * can be preferred to useRef for instances where an html node may not be
 * available on initial render but you would like to receive updates when it is
 * available.
 *
 * @example
 *
 * const [divElement, divRef] = useHtmlElement();
 * return <div ref={divRef} />
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useHtmlElement | useHtmlElement} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useHtmlElement() {
    var _React_useState = useHtmlElement_sliced_to_array(external_react_namespaceObject.useState(null), 2), currentHtmlElement = _React_useState[0], setCurrentHtmlElement = _React_useState[1];
    var setRef = external_react_namespaceObject.useCallback(function(node) {
        if (node !== null) {
            setCurrentHtmlElement(node);
        }
    }, []);
    return [
        currentHtmlElement,
        setRef
    ];
}

;// CONCATENATED MODULE: ./src/hooks/useSlideShow.ts
function useSlideShow_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSlideShow_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSlideShow_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSlideShow_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSlideShow_sliced_to_array(arr, i) {
    return useSlideShow_array_with_holes(arr) || useSlideShow_iterable_to_array_limit(arr, i) || useSlideShow_unsupported_iterable_to_array(arr, i) || useSlideShow_non_iterable_rest();
}
function useSlideShow_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSlideShow_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSlideShow_array_like_to_array(o, minLen);
}


/**
 * The time since the last user interaction used for determining if scrolling
 * has ceased.
 */ var SCROLL_INTERVAL = 1000 / 15; // 15 FPS
/**
 * Add programmatic control for managing slide show state to a scrollable
 * content area.
 *
 * !Requires `polyfillSmoothScroll()` on the client for full browser support.
 *
 * @deprecated Just use the {@link https://corgi-x.tfd.engineering/components/slideshow | Slideshow component} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useSlideShow(param) {
    var scrollableEl = param.scrollableEl, getIsActiveSlide = param.getIsActiveSlide, onSlideChange = param.onSlideChange, activeIndexProp = param.activeIndex, scrollBehavior = param.scrollBehavior;
    var _React_useState = useSlideShow_sliced_to_array(external_react_namespaceObject.useState(Date.now()), 2), lastScroll = _React_useState[0], setLastScroll = _React_useState[1];
    var _React_useState1 = useSlideShow_sliced_to_array(external_react_namespaceObject.useState(activeIndexProp !== null && activeIndexProp !== void 0 ? activeIndexProp : 0), 2), activeIndex = _React_useState1[0], setCurrentSlide = _React_useState1[1];
    var getIsScrolling = external_react_namespaceObject.useCallback(function() {
        var now = Date.now();
        return Boolean(lastScroll) && now < lastScroll + SCROLL_INTERVAL;
    }, [
        lastScroll
    ]);
    var handleSlideChange = external_react_namespaceObject.useCallback(function(nextIndex) {
        setCurrentSlide(nextIndex);
        if (onSlideChange) {
            onSlideChange(nextIndex);
        }
    }, [
        onSlideChange
    ]);
    var goToSlide = external_react_namespaceObject.useCallback(function(nextIndex) {
        if (!scrollableEl) {
            return;
        }
        var slides = Array.from(scrollableEl.children);
        var nextSlideEl = slides[nextIndex];
        var activeSlideEl = slides[activeIndex];
        if (nextSlideEl && activeSlideEl && scrollableEl) {
            var scrollTop = 0;
            var scrollLeft = 0;
            external_fastdom_default().measure(function() {
                var nextSlideRects = nextSlideEl.getBoundingClientRect();
                var activeSlideRects = activeSlideEl.getBoundingClientRect();
                scrollTop = nextSlideRects.top - activeSlideRects.top;
                scrollLeft = nextSlideRects.left - activeSlideRects.left;
            });
            external_fastdom_default().mutate(function() {
                scrollableEl.scrollBy({
                    top: scrollTop,
                    left: scrollLeft,
                    behavior: scrollBehavior
                });
            });
        }
    }, [
        activeIndex,
        scrollableEl,
        scrollBehavior
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (typeof activeIndexProp === "undefined") {
            return;
        }
        if (activeIndexProp === activeIndex) {
            return;
        }
        if (!getIsScrolling()) {
            goToSlide(activeIndexProp);
        }
    }, [
        activeIndexProp,
        activeIndex,
        goToSlide,
        getIsScrolling
    ]);
    external_react_namespaceObject.useEffect(function() {
        if (!scrollableEl) {
            return;
        }
        var handleScroll = function() {
            external_fastdom_default().measure(function() {
                setLastScroll(Date.now());
                var scrollableRect = scrollableEl.getBoundingClientRect();
                var slides = Array.from(scrollableEl.children);
                var nextIndex = slides.findIndex(function(slideEl) {
                    return getIsActiveSlide(slideEl.getBoundingClientRect(), scrollableRect);
                });
                if (activeIndex !== nextIndex) {
                    handleSlideChange(nextIndex);
                }
            });
        };
        scrollableEl.addEventListener("scroll", handleScroll);
        return function() {
            return scrollableEl.removeEventListener("scroll", handleScroll);
        };
    }, [
        scrollableEl,
        handleSlideChange,
        getIsActiveSlide,
        activeIndex
    ]);
    return {
        activeIndex: activeIndex,
        goToSlide: goToSlide
    };
}

;// CONCATENATED MODULE: ./src/components/IndexButton/IndexButton.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const IndexButton = ({"button-size":"12px","buttonSize":"12px","button-size-green":"10px","buttonSizeGreen":"10px","button-margin-green":"5px","buttonMarginGreen":"5px","button":"BnH_C8","dark":"jGXHes","active":"JLpdmv","light":"_rMQY5","green":"oAO_rU"});
;// CONCATENATED MODULE: ./src/components/IndexButton/IndexButton.tsx
function IndexButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IndexButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IndexButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function IndexButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = IndexButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function IndexButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Modes = [
    "light",
    "dark",
    "green"
];
/**
 * Render a small button that can be used to indicate the active index of a list
 * of items.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/indexbutton | IndexButton} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var IndexButton_IndexButton = function(_param) {
    var active = _param.active, _param_mode = _param.mode, mode = _param_mode === void 0 ? "dark" : _param_mode, className = _param.className, props = IndexButton_object_without_properties(_param, [
        "active",
        "mode",
        "className"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement("button", IndexButton_object_spread({
        type: "button",
        className: external_classnames_default()(styles_button.button, IndexButton.button, className, IndexButton[mode], IndexButton_define_property({}, IndexButton.active, active))
    }, props));
};

;// CONCATENATED MODULE: external "lodash/round"
const round_namespaceObject = require("lodash/round");
var round_default = /*#__PURE__*/__webpack_require__.n(round_namespaceObject);
;// CONCATENATED MODULE: external "bezier-easing"
const external_bezier_easing_namespaceObject = require("bezier-easing");
var external_bezier_easing_default = /*#__PURE__*/__webpack_require__.n(external_bezier_easing_namespaceObject);
;// CONCATENATED MODULE: ./src/components/Gallery/animations.ts

var notWide = {
    curve: external_bezier_easing_default()(0.25, 0.75, 1, 1),
    minScale: 0.83,
    maxScale: 1
};
var wide = {
    curve: external_bezier_easing_default()(0, 0, 1, 0.25),
    minScale: 0.83,
    maxScale: 1
};

;// CONCATENATED MODULE: ./src/components/Gallery/getScale.ts
/**
 * Return a number between min and max based on progress. Progress should be a
 * decimal between 0 and 1 that represents how much of the task (usually
 * animation) has been completed.
 *
 * @example
 *
 * const startingScale = 15;
 * const endingScale = 115;
 * const progress = 0.6 // compute this linearly or along a bezier curve
 *
 * const currentX = getScale(progress, startingScale, endingScale)
 */ function getScale(progress, minScale, maxScale) {
    var scaleDistance = maxScale - minScale;
    var scale = minScale + scaleDistance * progress;
    return scale;
}

;// CONCATENATED MODULE: ./src/components/Gallery/Slide.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Slide = ({"slide":"jRUJgP","button":"zeeKAJ","animation-reference":"BfXnax","animationReference":"BfXnax","animation-debug":"BMsCd1","animationDebug":"BMsCd1","is-not-wide":"eFQtVw","isNotWide":"eFQtVw","is-wide":"V9IFrG","isWide":"V9IFrG","active":"DoC6SB","inactive":"Yj8muw"});
;// CONCATENATED MODULE: ./src/components/Gallery/Slide.tsx
function Slide_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Slide_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Slide_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Slide_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Slide_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Slide_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var Slide_Slide = function(_param) {
    var children = _param.children, className = _param.className, _param_isWide = _param.isWide, isWide = _param_isWide === void 0 ? false : _param_isWide, index = _param.index, intersectionRatio = _param.intersectionRatio, _param_isDebug = _param.isDebug, isDebug = _param_isDebug === void 0 ? false : _param_isDebug, active = _param.active, props = Slide_object_without_properties(_param, [
        "children",
        "className",
        "isWide",
        "index",
        "intersectionRatio",
        "isDebug",
        "active"
    ]);
    var responsiveAnimation = !isWide ? notWide : wide;
    var style = external_react_namespaceObject.useMemo(function() {
        var minScale = responsiveAnimation.minScale, maxScale = responsiveAnimation.maxScale, curve = responsiveAnimation.curve;
        var progress = curve(intersectionRatio);
        var scale = getScale(progress, minScale, maxScale);
        return {
            transform: "scale(".concat(scale, ")")
        };
    }, [
        intersectionRatio,
        responsiveAnimation
    ]);
    var showDebug = index === 2 && isDebug;
    var activeStyle = active ? Slide.active : Slide.inactive;
    var _obj;
    return /*#__PURE__*/ external_react_namespaceObject.createElement("li", {
        className: external_classnames_default()(Slide.slide, className, (_obj = {}, Slide_define_property(_obj, Slide.isWide, isWide), Slide_define_property(_obj, Slide.isNotWide, !isWide), _obj))
    }, /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        className: external_classnames_default()(Slide.animationReference, showDebug && Slide.animationDebug)
    }, showDebug && "Animation reference intersection ".concat(round_default()(intersectionRatio, 2))), /*#__PURE__*/ external_react_namespaceObject.createElement("button", Slide_object_spread({
        className: external_classnames_default()(Slide.button, styles_button.button, activeStyle),
        style: style
    }, props), children));
};

;// CONCATENATED MODULE: ./src/components/Gallery/getIsActiveSlide.ts
/**
 * Return a boolean indicating if the slide should be marked as the currently
 * active slide.
 */ function getIsActiveSlide(slideRect, scrollableRect) {
    var scrollableCenter = scrollableRect.left + scrollableRect.width / 2;
    return scrollableCenter > slideRect.left && scrollableCenter < slideRect.right;
}

;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Gallery = ({"container":"JhQOJM","horizontalSnap":"PRwCB0","message":"egSv6N","dots":"MjehCr","arrow-button":"PTgj4C","arrowButton":"PTgj4C","button-icon-back":"ksmoQA","buttonIconBack":"ksmoQA","forward-button":"k_PWpW","forwardButton":"k_PWpW","is-not-wide":"DRUHtE","isNotWide":"DRUHtE","is-wide":"ktvQlB","isWide":"ktvQlB"});
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.tsx
function Gallery_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Gallery_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Gallery_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Gallery_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Gallery_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Gallery_sliced_to_array(arr, i) {
    return Gallery_array_with_holes(arr) || Gallery_iterable_to_array_limit(arr, i) || Gallery_unsupported_iterable_to_array(arr, i) || Gallery_non_iterable_rest();
}
function Gallery_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Gallery_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gallery_array_like_to_array(o, minLen);
}












/** Which contrast mode to use */ var GalleryModes = [
    "light",
    "dark"
];
var initialRatios = [];
/**
 * Render a gallery component. This component accepts any number of children
 * that will each be rendered as a slide for the gallery.
 *
 * !Requires `polyfillSmoothScroll()` on the client for full browser support.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/gallery | Gallery} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Gallery_Gallery = function(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? "dark" : _param_mode, children = param.children, label = param.label, onSlideChange = param.onSlideChange, _param_withDots = param.withDots, withDots = _param_withDots === void 0 ? false : _param_withDots, onActiveSlideClick = param.onActiveSlideClick, footnote = param.footnote, activeIndexProp = param.activeIndex, _param_isWide = param.isWide, isWide = _param_isWide === void 0 ? false : _param_isWide, className = param.className, _param_isDebug = param.isDebug, isDebug = _param_isDebug === void 0 ? false : _param_isDebug;
    var id = (0,external_react_namespaceObject.useId)();
    var messageId = (0,external_react_namespaceObject.useId)();
    var numberOfSlides = external_react_default().Children.count(children);
    var _useHtmlElement = Gallery_sliced_to_array(useHtmlElement(), 2), scrollableEl = _useHtmlElement[0], scrollableRef = _useHtmlElement[1];
    var _React_useState = Gallery_sliced_to_array(external_react_default().useState(initialRatios), 2), intersectionRatios = _React_useState[0], setIntersectionRatios = _React_useState[1];
    var _useSlideShow = useSlideShow({
        scrollableEl: scrollableEl,
        scrollBehavior: "smooth",
        getIsActiveSlide: getIsActiveSlide,
        onSlideChange: onSlideChange,
        activeIndex: activeIndexProp
    }), activeIndex = _useSlideShow.activeIndex, goToSlide = _useSlideShow.goToSlide;
    var handleScroll = external_react_default().useCallback(function() {
        var nextIntersectionRatios;
        external_fastdom_default().measure(function() {
            if (!scrollableEl) {
                return;
            }
            var scrollableRect = scrollableEl.getBoundingClientRect();
            var scrollableLeft = scrollableRect.left;
            var scrollableRight = scrollableRect.right;
            var scrollableWidth = scrollableRect.width;
            var slides = Array.from(scrollableEl.children);
            nextIntersectionRatios = slides.map(function(slide) {
                var slideRect = slide.getBoundingClientRect();
                var slideCenter = slideRect.width / 2 + slideRect.left;
                var animationReferenceRight = slideCenter + scrollableRect.width / 2;
                var animationReferenceLeft = slideCenter - scrollableRect.width / 2;
                var isIntersectingLeft = animationReferenceLeft <= scrollableLeft && animationReferenceRight > scrollableLeft;
                var isIntersectingRight = animationReferenceRight >= scrollableRight && animationReferenceLeft < scrollableRight;
                if (isIntersectingRight) {
                    return (scrollableWidth - (animationReferenceRight - scrollableRight)) / scrollableWidth;
                }
                if (isIntersectingLeft) {
                    return (animationReferenceRight - scrollableLeft) / scrollableWidth;
                }
                return 0;
            });
            external_fastdom_default().mutate(function() {
                setIntersectionRatios(nextIntersectionRatios);
            });
        });
    }, [
        scrollableEl
    ]);
    // Set up initial positions when element is rendered
    external_react_default().useEffect(function() {
        handleScroll();
    }, [
        handleScroll
    ]);
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("section", {
        "aria-label": label,
        className: external_classnames_default()(className, (_obj = {}, Gallery_define_property(_obj, Gallery.isWide, isWide), Gallery_define_property(_obj, Gallery.isNotWide, !isWide), _obj)),
        "data-active-slide": activeIndex
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        className: Gallery.container
    }, isWide && /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement("button", {
        onClick: function() {
            return goToSlide(activeIndex - 1);
        },
        className: external_classnames_default()(Gallery.arrowButton),
        disabled: activeIndex === 0,
        "aria-label": "Previous Slide"
    }, /*#__PURE__*/ external_react_default().createElement(Chevron, {
        fill: mode === "light" ? "white" : "kale-3",
        size: 72,
        className: external_classnames_default()(Gallery.buttonIcon, Gallery.buttonIconBack)
    })), /*#__PURE__*/ external_react_default().createElement("button", {
        onClick: function() {
            return goToSlide(activeIndex + 1);
        },
        className: external_classnames_default()(Gallery.arrowButton, Gallery.forwardButton),
        disabled: activeIndex === numberOfSlides - 1,
        "aria-label": "Next Slide"
    }, /*#__PURE__*/ external_react_default().createElement(Chevron, {
        fill: mode === "light" ? "white" : "kale-3",
        size: 72,
        className: Gallery.buttonIcon
    }))), /*#__PURE__*/ external_react_default().createElement(ScrollSnap_ScrollSnap, {
        as: "ul",
        id: id,
        ref: scrollableRef,
        className: Gallery.horizontalSnap,
        onScroll: handleScroll
    }, external_react_default().Children.map(children, function(child, index) {
        var handleClick = index === activeIndex ? onActiveSlideClick : function() {
            return goToSlide(index);
        };
        return /*#__PURE__*/ external_react_default().createElement(Slide_Slide, {
            "aria-label": "".concat(index + 1, " of ").concat(numberOfSlides),
            "aria-describedby": messageId,
            onClick: handleClick,
            isDebug: isDebug,
            isWide: isWide,
            index: index,
            intersectionRatio: intersectionRatios[index],
            active: index === activeIndex
        }, child);
    }))), /*#__PURE__*/ external_react_default().createElement(LiveMessage_LiveMessage, {
        "aria-live": "polite",
        id: messageId,
        className: Gallery.message
    }, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        color: mode === "dark" ? "kale-3" : "white"
    }, footnote)), withDots && /*#__PURE__*/ external_react_default().createElement("div", {
        className: Gallery.dots
    }, external_react_default().Children.map(children, function(_, childIndex) {
        return /*#__PURE__*/ external_react_default().createElement(IndexButton_IndexButton, {
            mode: mode,
            "aria-label": "Go to slide ".concat(childIndex),
            "aria-controls": id,
            active: childIndex === activeIndex,
            onClick: function() {
                return goToSlide(childIndex);
            }
        });
    })));
};

;// CONCATENATED MODULE: ./src/components/Gallery/index.ts


;// CONCATENATED MODULE: ./src/components/GridContainer/GridContainer.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const GridContainer = ({"container":"ytmIjG","skip-xs":"kdATNw","skipXs":"kdATNw","skip-sm":"TXpJbF","skipSm":"TXpJbF","skip-md":"wAk4PR","skipMd":"wAk4PR","skip-lg":"Iedy6N","skipLg":"Iedy6N","skip-xl":"kCMBqc","skipXl":"kCMBqc","disabled":"Dy05Jw"});
;// CONCATENATED MODULE: ./src/components/GridContainer/GridContainer.tsx
function GridContainer_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GridContainer_array_without_holes(arr) {
    if (Array.isArray(arr)) return GridContainer_array_like_to_array(arr);
}
function GridContainer_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GridContainer_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GridContainer_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GridContainer_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GridContainer_define_property(target, key, source[key]);
        });
    }
    return target;
}
function GridContainer_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = GridContainer_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function GridContainer_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function GridContainer_to_consumable_array(arr) {
    return GridContainer_array_without_holes(arr) || GridContainer_iterable_to_array(arr) || GridContainer_unsupported_iterable_to_array(arr) || GridContainer_non_iterable_spread();
}
function GridContainer_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GridContainer_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GridContainer_array_like_to_array(o, minLen);
}



var GridContainerBreakpoints = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var GridContainerHTMLElements = [
    "div",
    "ul"
];
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/grid | Grid} from corgi-x to create grid layouts. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function GridContainer_GridContainer(_param) {
    var children = _param.children, _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, _param_skip = _param.skip, skip = _param_skip === void 0 ? [] : _param_skip, className = _param.className, tmp = _param.as, HTMLElement = tmp === void 0 ? "div" : tmp, props = GridContainer_object_without_properties(_param, [
        "children",
        "enabled",
        "skip",
        "className",
        "as"
    ]);
    return /*#__PURE__*/ external_react_default().createElement(HTMLElement, GridContainer_object_spread({
        className: external_classnames_default().apply(void 0, [
            GridContainer.container,
            GridContainer_define_property({}, GridContainer.disabled, !enabled)
        ].concat(GridContainer_to_consumable_array(skip.map(function(s) {
            return GridContainer["skip-".concat(s)];
        })), [
            className
        ]))
    }, props), children);
}

;// CONCATENATED MODULE: ./src/components/GridContainer/index.ts


;// CONCATENATED MODULE: ./src/components/PageWidth/PageWidth.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const PageWidth = ({"container":"A8BffM","skip-xs":"o5ypPe","skipXs":"o5ypPe","skip-sm":"dHa93m","skipSm":"dHa93m","skip-md":"Al6uLK","skipMd":"Al6uLK","skip-lg":"t26bP6","skipLg":"t26bP6","skip-xl":"pe7rwu","skipXl":"pe7rwu","disabled":"aR9YQs"});
;// CONCATENATED MODULE: ./src/components/PageWidth/PageWidth.tsx
function PageWidth_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PageWidth_array_without_holes(arr) {
    if (Array.isArray(arr)) return PageWidth_array_like_to_array(arr);
}
function PageWidth_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PageWidth_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function PageWidth_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PageWidth_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PageWidth_define_property(target, key, source[key]);
        });
    }
    return target;
}
function PageWidth_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = PageWidth_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PageWidth_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PageWidth_to_consumable_array(arr) {
    return PageWidth_array_without_holes(arr) || PageWidth_iterable_to_array(arr) || PageWidth_unsupported_iterable_to_array(arr) || PageWidth_non_iterable_spread();
}
function PageWidth_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PageWidth_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PageWidth_array_like_to_array(o, minLen);
}



var PageWidthBreakpoints = (/* unused pure expression or super */ null && ([
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]));
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/pagewidth | PageWidth} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var PageWidth_PageWidth = function(_param) {
    var children = _param.children, _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, _param_skip = _param.skip, skip = _param_skip === void 0 ? [] : _param_skip, className = _param.className, props = PageWidth_object_without_properties(_param, [
        "children",
        "enabled",
        "skip",
        "className"
    ]);
    return /*#__PURE__*/ external_react_default().createElement("div", PageWidth_object_spread({
        className: external_classnames_default().apply(void 0, [
            PageWidth.container,
            PageWidth_define_property({}, PageWidth.disabled, !enabled)
        ].concat(PageWidth_to_consumable_array(skip.map(function(s) {
            return PageWidth["skip-".concat(s)];
        })), [
            className
        ]))
    }, props), children);
};

;// CONCATENATED MODULE: ./src/components/Hero/Hero.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Hero = ({"section":"axJH4n","background":"Sjqyhz","content":"nCD4ER","title":"ur3i2i","subtitle":"bCK22E","cta":"acOmCn"});
;// CONCATENATED MODULE: ./src/components/Hero/Hero.tsx
function Hero_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Hero_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Hero_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Hero_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Hero_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Hero_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/hero | Hero} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Hero_Hero = function(_param) {
    var title = _param.title, titleProps = _param.titleProps, subtitle = _param.subtitle, subtitleProps = _param.subtitleProps, ctaLabel = _param.ctaLabel, ctaProps = _param.ctaProps, _param_withCta = _param.withCta, withCta = _param_withCta === void 0 ? true : _param_withCta, background = _param.background, className = _param.className, props = Hero_object_without_properties(_param, [
        "title",
        "titleProps",
        "subtitle",
        "subtitleProps",
        "ctaLabel",
        "ctaProps",
        "withCta",
        "background",
        "className"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement("section", Hero_object_spread({
        className: external_classnames_default()(Hero.section, className)
    }, props), /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        className: Hero.background
    }, background), /*#__PURE__*/ external_react_namespaceObject.createElement(PageWidth_PageWidth, {
        className: Hero.content,
        style: {
            marginTop: LOGO_SIZE
        }
    }, /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, Hero_object_spread({
        as: "h1",
        color: "white",
        bold: true,
        className: Hero.title
    }, titleProps), title), /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, Hero_object_spread({
        as: "h2",
        color: "white",
        bold: true,
        className: Hero.subtitle
    }, subtitleProps), subtitle), withCta && /*#__PURE__*/ external_react_namespaceObject.createElement(Link_Link, Hero_object_spread({
        asButton: true,
        variant: "primary",
        className: Hero.cta
    }, ctaProps), ctaLabel)));
};

;// CONCATENATED MODULE: ./src/components/Hero/index.ts


;// CONCATENATED MODULE: ./src/components/HorizontalNavigation/index.ts


;// CONCATENATED MODULE: ./src/components/HorizontalNavigationItem/index.ts


;// CONCATENATED MODULE: ./src/components/IndexButton/index.ts


;// CONCATENATED MODULE: ./src/components/ListSelect/ListSelectOption.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ListSelectOption = ({"label":"I_hH8B","normal":"MMBmQo","badge":"NGJ_br","recommended":"yO2yo0","checkbox":"FTEkdK","disabled":"vJwd8W","focus":"uvskVj","checked":"pqBxQ4","badge-text":"q6XEv1","badgeText":"q6XEv1","input":"WDXbOj"});
;// CONCATENATED MODULE: ./src/components/ListSelect/ListSelectOption.tsx
function ListSelectOption_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListSelectOption_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListSelectOption_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListSelectOption_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListSelectOption_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelectOption_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ListSelectOption_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ListSelectOption_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ListSelectOption_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ListSelectOption_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ListSelectOption_sliced_to_array(arr, i) {
    return ListSelectOption_array_with_holes(arr) || ListSelectOption_iterable_to_array_limit(arr, i) || ListSelectOption_unsupported_iterable_to_array(arr, i) || ListSelectOption_non_iterable_rest();
}
function ListSelectOption_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListSelectOption_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListSelectOption_array_like_to_array(o, minLen);
}









var ListSelectOptionComponent = function(_param) {
    var label = _param.label, invalid = _param.invalid, forwardedRef = _param.forwardedRef, onBlur = _param.onBlur, onFocus = _param.onFocus, withCheckbox = _param.withCheckbox, withRadio = _param.withRadio, badge = _param.badge, className = _param.className, labelRef = _param.labelRef, style = _param.style, children = _param.children, props = ListSelectOption_object_without_properties(_param, [
        "label",
        "invalid",
        "forwardedRef",
        "onBlur",
        "onFocus",
        "withCheckbox",
        "withRadio",
        "badge",
        "className",
        "labelRef",
        "style",
        "children"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = ListSelectOption_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("label", {
        ref: labelRef,
        className: external_classnames_default()(ListSelectOption.label, ListSelectOption[state], className, ListSelectOption_define_property({}, ListSelectOption.checked, props.checked)),
        style: style
    }, badge && /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(ListSelectOption.badge, (_obj = {}, ListSelectOption_define_property(_obj, ListSelectOption.checked, props.checked), ListSelectOption_define_property(_obj, ListSelectOption.recommended, props.recommended), ListSelectOption_define_property(_obj, ListSelectOption.disabled, state === "disabled"), _obj))
    }, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        role: "status",
        variant: "heading-12",
        className: ListSelectOption.badgeText
    }, badge)), /*#__PURE__*/ external_react_default().createElement("div", null, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        as: "div",
        variant: "heading-22",
        color: state === "disabled" ? "charcoal-1" : "kale-3",
        bold: true
    }, label || props.name || ""), props.description && /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        as: "div",
        variant: "heading-16",
        color: state === "disabled" ? "charcoal-1" : "charcoal-3"
    }, props.description), children), withCheckbox && /*#__PURE__*/ external_react_default().createElement("div", {
        className: ListSelectOption.checkbox
    }, /*#__PURE__*/ external_react_default().createElement(CheckboxView, {
        checked: props.checked,
        state: state
    })), withRadio && /*#__PURE__*/ external_react_default().createElement(RadioView, {
        checked: props.checked,
        state: state
    }), /*#__PURE__*/ external_react_default().createElement("input", ListSelectOption_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()(accessibility.hidden, ListSelectOption.input),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        "data-checked": props.checked
    }, props)));
};
var ListSelectOption_ListSelectOption = withRef(ListSelectOptionComponent);

;// CONCATENATED MODULE: ./src/components/ListSelect/getInitialValue.ts
/**
 * Get the initial state value according to the input props. Initial state
 * depends on whether or not multiple selections are available as well as
 * whether or not a `value` prop is passed in.
 */ function getInitialValue_getInitialValue(value, multi) {
    var isControlled = typeof value !== "undefined";
    if (isControlled) {
        return value;
    }
    if (multi) {
        return [];
    }
    return undefined;
}
/* harmony default export */ const ListSelect_getInitialValue = (getInitialValue_getInitialValue);

;// CONCATENATED MODULE: ./src/components/ListSelect/includesCastValue.ts
/**
 * Returns a boolean indicating whether or not the array contains an item that
 * matches the stringified argument.
 */ function includesCastValue_includesCastValue(value, child) {
    if (!Array.isArray(value)) {
        return false;
    }
    return typeof value.find(function(value) {
        return String(value) === String(child);
    }) !== "undefined";
}
/* harmony default export */ const ListSelect_includesCastValue = (includesCastValue_includesCastValue);

;// CONCATENATED MODULE: ./src/util/accessibility/constants.ts
var PREFERS_REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

;// CONCATENATED MODULE: ./src/util/accessibility/getPreferredScrollBehavior.ts


var Behavior;
(function(Behavior) {
    Behavior["auto"] = "auto";
    Behavior["smooth"] = "smooth";
})(Behavior || (Behavior = {}));
function getPreferredScrollBehavior() {
    return browserOnly(function(window) {
        var mediaQuery = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY);
        var behavior = mediaQuery.matches ? Behavior.auto : Behavior.smooth;
        return behavior;
    });
}

;// CONCATENATED MODULE: ./src/components/ListSelect/ListSelect.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ListSelect = ({"fieldset":"EPJSoo","badge":"bHm_gU","two-column":"arO8ZL","twoColumn":"arO8ZL","horizontal":"NR_GtH"});
;// CONCATENATED MODULE: ./src/components/ListSelect/ListSelect.tsx
function ListSelect_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ListSelect_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ListSelect_array_without_holes(arr) {
    if (Array.isArray(arr)) return ListSelect_array_like_to_array(arr);
}
function ListSelect_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ListSelect_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ListSelect_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ListSelect_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelect_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ListSelect_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ListSelect_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ListSelect_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ListSelect_sliced_to_array(arr, i) {
    return ListSelect_array_with_holes(arr) || ListSelect_iterable_to_array_limit(arr, i) || ListSelect_unsupported_iterable_to_array(arr, i) || ListSelect_non_iterable_rest();
}
function ListSelect_to_consumable_array(arr) {
    return ListSelect_array_without_holes(arr) || ListSelect_iterable_to_array(arr) || ListSelect_unsupported_iterable_to_array(arr) || ListSelect_non_iterable_spread();
}
function ListSelect_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ListSelect_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ListSelect_array_like_to_array(o, minLen);
}







/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/togglebox | ToggleBox} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var ListSelect_ListSelect = function(_param) {
    var _param_multi = _param.multi, multi = _param_multi === void 0 ? false : _param_multi, children = _param.children, label = _param.label, name = _param.name, onChange = _param.onChange, withTwoColumn = _param.withTwoColumn, className = _param.className, _param_direction = _param.direction, direction = _param_direction === void 0 ? "vertical" : _param_direction, props = ListSelect_object_without_properties(_param, [
        "multi",
        "children",
        "label",
        "name",
        "onChange",
        "withTwoColumn",
        "className",
        "direction"
    ]);
    var horizontalDirection = direction === "horizontal";
    var _useState = ListSelect_sliced_to_array((0,external_react_namespaceObject.useState)(ListSelect_getInitialValue(props.value, multi)), 2), internalValue = _useState[0], setInternalValue = _useState[1];
    var value = typeof props.value !== "undefined" ? props.value : internalValue;
    var handleChange = function(e) {
        var eventValue = e.target.value;
        if (!(multi && Array.isArray(value))) {
            setInternalValue(eventValue);
            return;
        }
        var nextValue = ListSelect_includesCastValue(value, eventValue) ? value.filter(function(lastValue) {
            return String(lastValue) !== eventValue;
        }) : ListSelect_to_consumable_array(value).concat([
            eventValue
        ]);
        setInternalValue(nextValue);
    };
    var getChecked = function(childValue) {
        if (multi && Array.isArray(value)) {
            return ListSelect_includesCastValue(value, childValue);
        }
        return String(value) === String(childValue);
    };
    var fieldsetRef = (0,external_react_namespaceObject.useRef)(null);
    var selectedOptionRef = (0,external_react_namespaceObject.useRef)(null);
    (0,external_react_namespaceObject.useEffect)(function() {
        var _fieldsetRef_current;
        // Check that scrollTo exists as jsdom doesn't include it
        if (((_fieldsetRef_current = fieldsetRef.current) === null || _fieldsetRef_current === void 0 ? void 0 : _fieldsetRef_current.scrollTo) && selectedOptionRef.current) {
            var fieldsetBoundingRect = fieldsetRef.current.getBoundingClientRect();
            var selectedOptionBoundingRect = selectedOptionRef.current.getBoundingClientRect();
            if (horizontalDirection) {
                var scrollOffset = fieldsetBoundingRect.left;
                var centerOffset = fieldsetBoundingRect.width / 2 - selectedOptionBoundingRect.width / 2;
                var left = selectedOptionBoundingRect.left - scrollOffset - centerOffset;
                fieldsetRef.current.scrollTo({
                    left: left,
                    behavior: getPreferredScrollBehavior()
                });
            } else {
                var scrollOffset1 = fieldsetBoundingRect.top;
                var centerOffset1 = fieldsetBoundingRect.height / 2 - selectedOptionBoundingRect.height / 2;
                var top = selectedOptionBoundingRect.top - scrollOffset1 - centerOffset1;
                fieldsetRef.current.scrollTo({
                    top: top,
                    behavior: getPreferredScrollBehavior()
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _obj;
    return /*#__PURE__*/ external_react_default().createElement("fieldset", {
        ref: fieldsetRef,
        className: external_classnames_default()(ListSelect.fieldset, className, (_obj = {}, ListSelect_define_property(_obj, ListSelect.twoColumn, Boolean(withTwoColumn)), ListSelect_define_property(_obj, ListSelect.horizontal, horizontalDirection), _obj))
    }, /*#__PURE__*/ external_react_default().createElement("legend", {
        className: accessibility.hidden
    }, label || name), external_react_namespaceObject.Children.map(children, function(listSelectOption) {
        if (!(listSelectOption && listSelectOption.props)) {
            return listSelectOption;
        }
        var optionProps = listSelectOption.props;
        var checked = getChecked(listSelectOption.props.value);
        return /*#__PURE__*/ (0,external_react_namespaceObject.cloneElement)(listSelectOption, {
            name: name,
            onChange: interceptEvent(listSelectOption.props.onChange, handleChange, onChange),
            labelRef: checked ? selectedOptionRef : undefined,
            checked: checked,
            type: multi ? "checkbox" : "radio",
            className: external_classnames_default()(optionProps.className, ListSelect_define_property({}, ListSelect.badge, Boolean(optionProps.badge)))
        });
    }));
};

;// CONCATENATED MODULE: ./src/components/ListSelect/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity



;// CONCATENATED MODULE: ./src/components/Logo/index.ts


;// CONCATENATED MODULE: ./src/components/Wave/assets/wave.svg
var wave_excluded = ["styles"];
function wave_extends() { wave_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wave_extends.apply(this, arguments); }
function wave_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = wave_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function wave_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* harmony default export */ const wave = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = wave_objectWithoutProperties(_ref, wave_excluded);
  return /*#__PURE__*/external_react_default().createElement("svg", wave_extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, props), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M100 100H0V50c33.333 50 66.667-50 100 0"
  }));
});
;// CONCATENATED MODULE: ./src/components/Wave/Wave.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Wave = ({"container":"vKLL2B","background":"wPNgT2","top-wave":"XEPYRl","topWave":"XEPYRl","bottom-wave":"pMnrMO","bottomWave":"pMnrMO","margin-xxs":"PPGzZx","marginXxs":"PPGzZx","margin-xs":"Zbpawv","marginXs":"Zbpawv","margin-sm":"WSKxW8","marginSm":"WSKxW8","margin-md":"eKaeX8","marginMd":"eKaeX8","margin-lg":"v7A7Fa","marginLg":"v7A7Fa","margin-xl":"PnXKmR","marginXl":"PnXKmR","margin-xxl":"ePH_DW","marginXxl":"ePH_DW","margin-3xl":"oEqkgy","margin3Xl":"oEqkgy","margin-4xl":"BDxqyx","margin4Xl":"BDxqyx","kale-3":"QydUhu","kale3":"QydUhu","white":"r2bc9u","charcoal-3":"YIYzKo","charcoal3":"YIYzKo","charcoal-1":"h1es5V","charcoal1":"h1es5V","charcoal-0":"V5KiIy","charcoal0":"V5KiIy","oyster-0":"JVJmc1","oyster0":"JVJmc1","kale-1":"QfqhRA","kale1":"QfqhRA","carrot-1":"ngkBbp","carrot1":"ngkBbp","chickpea-2":"HdJymN","chickpea2":"HdJymN","chickpea-1":"MITxVT","chickpea1":"MITxVT"});
;// CONCATENATED MODULE: ./src/components/Wave/Wave.tsx
function Wave_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Wave_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Wave_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Wave_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Wave_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Wave_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var WaveFills = (/* unused pure expression or super */ null && ([
    "kale-3",
    "white",
    "charcoal-1",
    "charcoal-3",
    "oyster-0",
    "charcoal-0",
    "kale-1",
    "carrot-1",
    "chickpea-2",
    "chickpea-1"
]));
var WaveMargins = (/* unused pure expression or super */ null && ([
    "margin-xxs",
    "margin-xs",
    "margin-sm",
    "margin-md",
    "margin-lg",
    "margin-xl",
    "margin-xxl",
    "margin-3xl",
    "margin-4xl"
]));
/**
 * Render an interface
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/wave | Wave} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var Wave_Wave = function(_param) {
    var className = _param.className, children = _param.children, withTop = _param.withTop, withBottom = _param.withBottom, topClassName = _param.topClassName, bottomClassName = _param.bottomClassName, _param_fill = _param.fill, fill = _param_fill === void 0 ? "chickpea-1" : _param_fill, padding = _param.padding, _param_waveHeight = _param.waveHeight, waveHeight = _param_waveHeight === void 0 ? 24 : _param_waveHeight, _param_topTransform = _param.topTransform, topTransform = _param_topTransform === void 0 ? "scaleX(-1)" : _param_topTransform, _param_bottomTransform = _param.bottomTransform, bottomTransform = _param_bottomTransform === void 0 ? "scaleX(-1) rotate(180deg)" : _param_bottomTransform, props = Wave_object_without_properties(_param, [
        "className",
        "children",
        "withTop",
        "withBottom",
        "topClassName",
        "bottomClassName",
        "fill",
        "padding",
        "waveHeight",
        "topTransform",
        "bottomTransform"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        className: external_classnames_default()(Wave.container, className, Wave[fill])
    }, withTop && /*#__PURE__*/ external_react_namespaceObject.createElement(wave, {
        className: external_classnames_default()(Wave.topWave, topClassName),
        style: {
            height: waveHeight,
            transform: topTransform
        }
    }), /*#__PURE__*/ external_react_namespaceObject.createElement("div", Wave_object_spread({
        className: external_classnames_default()(Wave.background, padding ? Wave[padding] : null)
    }, props), children), withBottom && /*#__PURE__*/ external_react_namespaceObject.createElement(wave, {
        className: external_classnames_default()(Wave.bottomWave, bottomClassName),
        style: {
            height: waveHeight,
            transform: bottomTransform
        }
    }));
};

;// CONCATENATED MODULE: ./src/styles/margins/margins.ts
var MARGIN_XXS = "2px";
var MARGIN_XS = "6px";
var MARGIN_SM = "12px";
var MARGIN_MD = "24px";
var MARGIN_LG = "36px";
var MARGIN_XL = "48px";
var MARGIN_XXL = "72px";
var MARGIN_3XL = "96px";
var MARGIN_4XL = "120px";

;// CONCATENATED MODULE: ./src/components/Modal/Modal.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Modal = ({"close-button":"reAfyb","closeButton":"reAfyb"});
;// CONCATENATED MODULE: ./src/components/Modal/Modal.tsx
function Modal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Modal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Modal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Modal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Modal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Modal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var Modal_UNSET_WIDTH = "";
var Modal_MIN_HEIGHT = 0;
var Modal_Modal = function(_param) {
    var children = _param.children, rootProps = _param.rootProps, _param_disableInteractions = _param.disableInteractions, disableInteractions = _param_disableInteractions === void 0 ? false : _param_disableInteractions, waveSectionContent = _param.waveSectionContent, className = _param.className, props = Modal_object_without_properties(_param, [
        "children",
        "rootProps",
        "disableInteractions",
        "waveSectionContent",
        "className"
    ]);
    var isWaveDesign = Boolean(waveSectionContent);
    var modalDesign = getModalDesign_getModalDesign();
    var nonWaveDesign = getNonWaveDesign();
    var _getWaveDesign = getWaveDesign(), waveSectionDesign = _getWaveDesign.waveSectionDesign, belowWaveSectionDesign = _getWaveDesign.belowWaveSectionDesign;
    return /*#__PURE__*/ external_react_default().createElement(Lightbox_Lightbox, Modal_object_spread({
        width: Modal_UNSET_WIDTH,
        height: Modal_MIN_HEIGHT,
        className: external_classnames_default()(modalDesign, className, Modal_define_property({}, nonWaveDesign, !isWaveDesign)),
        disableInteractions: disableInteractions
    }, rootProps, props), !disableInteractions && /*#__PURE__*/ external_react_default().createElement(CloseButton_CloseButton, {
        onClick: props.close,
        className: Modal.closeButton
    }), isWaveDesign && /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement(Wave_Wave, {
        fill: "chickpea-1",
        waveHeight: MARGIN_XL,
        withBottom: true
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        className: waveSectionDesign
    }, waveSectionContent)), /*#__PURE__*/ external_react_default().createElement("div", {
        className: belowWaveSectionDesign
    }, children)), !isWaveDesign && children);
};

;// CONCATENATED MODULE: ./src/components/Modal/index.ts


;// CONCATENATED MODULE: ./src/components/ResponsiveText/ResponsiveText.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ function ResponsiveText_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ResponsiveText_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ResponsiveText_array_without_holes(arr) {
    if (Array.isArray(arr)) return ResponsiveText_array_like_to_array(arr);
}
function ResponsiveText_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ResponsiveText_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ResponsiveText_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ResponsiveText_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResponsiveText_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResponsiveText_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ResponsiveText_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ResponsiveText_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ResponsiveText_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ResponsiveText_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ResponsiveText_sliced_to_array(arr, i) {
    return ResponsiveText_array_with_holes(arr) || ResponsiveText_iterable_to_array_limit(arr, i) || ResponsiveText_unsupported_iterable_to_array(arr, i) || ResponsiveText_non_iterable_rest();
}
function ResponsiveText_to_consumable_array(arr) {
    return ResponsiveText_array_without_holes(arr) || ResponsiveText_iterable_to_array(arr) || ResponsiveText_unsupported_iterable_to_array(arr) || ResponsiveText_non_iterable_spread();
}
function ResponsiveText_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ResponsiveText_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ResponsiveText_array_like_to_array(o, minLen);
}



/** The available variants of article.
 * Article has a different font family than heading and body.
 * article-3 should only be used for labels
 */ var ArticleTextVariants = [
    "article-1",
    "article-2",
    "article-3"
];
/** The available variants of body.
 * body-3 should only be used for labels
 */ var BodyTextVariants = [
    "body-1",
    "body-2",
    "body-3"
];
/** The available variants of heading.
 * Heading always has a bold font styles
 */ var HeadingTextVariants = [
    "heading-1",
    "heading-2",
    "heading-3",
    "heading-4",
    "heading-5"
];
var ResponsiveTextVariants = ResponsiveText_to_consumable_array(ArticleTextVariants).concat(ResponsiveText_to_consumable_array(BodyTextVariants), ResponsiveText_to_consumable_array(HeadingTextVariants));
/** @deprecated Use {@link https://corgi-x.tfd.engineering/components/text | Text} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ function ResponsiveText(_param) {
    var tmp = _param.as, TypographyHTMLElementTag = tmp === void 0 ? "span" : tmp, variant = _param.variant, _param_fontWeight = _param.fontWeight, fontWeight = _param_fontWeight === void 0 ? "roman" : _param_fontWeight, fontStyle = _param.fontStyle, color = _param.color, className = _param.className, props = ResponsiveText_object_without_properties(_param, [
        "as",
        "variant",
        "fontWeight",
        "fontStyle",
        "color",
        "className"
    ]);
    var _variant_split = ResponsiveText_sliced_to_array(variant.split("-"), 2), type = _variant_split[0], size = _variant_split[1];
    var weight = fontWeight;
    if ([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ].includes(TypographyHTMLElementTag)) {
        weight = "black";
    }
    // @ts-expect-error not sure why this works at runtime, but typescript isn't happy
    var typographyStyles = typography_namespaceObject[type].create({
        size: size,
        weight: weight,
        fontStyle: fontStyle,
        color: color
    });
    return /*#__PURE__*/ external_react_namespaceObject.createElement(TypographyHTMLElementTag, ResponsiveText_object_spread({
        className: external_classnames_default()(className, typographyStyles.className)
    }, props));
}

;// CONCATENATED MODULE: ./src/components/ResponsiveText/index.ts


;// CONCATENATED MODULE: ./src/components/RichSelector/RichSelector.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const RichSelector = ({"container":"h1bNcO","label":"hxOFKx","icon":"iY_6cN","input":"TZRotH","largeInput":"p9PyUM"});
;// CONCATENATED MODULE: ./src/components/RichSelector/RichSelector.tsx
function RichSelector_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RichSelector_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RichSelector_define_property(target, key, source[key]);
        });
    }
    return target;
}
function RichSelector_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = RichSelector_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RichSelector_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









/**
 * Selector component to display very detailed options.  Can display an image
 * and extended description.  Also set up to connect sibling options together
 * via the `lineThroughDesign`
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/richselector | RichSelector} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var RichSelector_RichSelector = function(_param) {
    var label = _param.label, isFirst = _param.isFirst, isLast = _param.isLast, icon = _param.icon, description = _param.description, type = _param.type, stateProp = _param.state, props = RichSelector_object_without_properties(_param, [
        "label",
        "isFirst",
        "isLast",
        "icon",
        "description",
        "type",
        "state"
    ]);
    var isCheckbox = type === "checkbox";
    var getInputDesign = isCheckbox ? getCheckboxDesign_getCheckboxDesign : getRadioDesign_getRadioDesign;
    return /*#__PURE__*/ external_react_namespaceObject.createElement(Selector_Selector, RichSelector_object_spread({
        type: type
    }, props), function(state) {
        var inputDesign = getInputDesign({
            state: stateProp !== null && stateProp !== void 0 ? stateProp : state,
            checked: props.checked
        });
        var lineThroughDesign = getLineThroughDesign_getLineThroughDesign({
            first: isFirst,
            last: isLast
        });
        return /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            className: external_classnames_default()(RichSelector.container, RichSelector[state])
        }, icon && /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
            className: RichSelector.icon
        }, icon), /*#__PURE__*/ external_react_namespaceObject.createElement("span", {
            className: lineThroughDesign
        }, /*#__PURE__*/ external_react_namespaceObject.createElement("span", {
            className: external_classnames_default()(inputDesign, RichSelector.input, RichSelector_define_property({}, RichSelector.largeInput, !icon))
        }, isCheckbox && /*#__PURE__*/ external_react_namespaceObject.createElement(Check, {
            fill: "white",
            size: 12
        }))), /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
            as: "span",
            variant: "heading-16",
            color: "kale-3",
            className: RichSelector.label
        }, label), description);
    });
};

;// CONCATENATED MODULE: ./src/components/RichSelector/index.ts


;// CONCATENATED MODULE: ./src/components/RichSelectorGroup/Description.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Description = ({"container":"hYaDQ1","position":"UXnXuR"});
;// CONCATENATED MODULE: ./src/components/RichSelectorGroup/Description.tsx
function Description_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Description_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Description_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Description_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Description_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Description_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Description_Description = function(_param) {
    var children = _param.children, className = _param.className, props = Description_object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(LiveMessage_LiveMessage, Description_object_spread({
        "aria-live": "polite",
        hidden: !props.in,
        className: Description.position
    }, props), /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
        as: "div",
        variant: "article-12",
        color: "carrot-2",
        fontStyle: "italic",
        className: external_classnames_default()(Description.container, className)
    }, children));
};

;// CONCATENATED MODULE: ./src/components/RichSelectorGroup/RichSelectorGroup.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const RichSelectorGroup = ({"container":"ayubQy","inputs":"krj8Uy","descriptionPadding":"dVCSVA"});
;// CONCATENATED MODULE: ./src/components/RichSelectorGroup/RichSelectorGroup.tsx
function RichSelectorGroup_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function RichSelectorGroup_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function RichSelectorGroup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RichSelectorGroup_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function RichSelectorGroup_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RichSelectorGroup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RichSelectorGroup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function RichSelectorGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RichSelectorGroup_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RichSelectorGroup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RichSelectorGroup_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = RichSelectorGroup_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RichSelectorGroup_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RichSelectorGroup_sliced_to_array(arr, i) {
    return RichSelectorGroup_array_with_holes(arr) || RichSelectorGroup_iterable_to_array_limit(arr, i) || RichSelectorGroup_unsupported_iterable_to_array(arr, i) || RichSelectorGroup_non_iterable_rest();
}
function RichSelectorGroup_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return RichSelectorGroup_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RichSelectorGroup_array_like_to_array(o, minLen);
}





/**
 * SelectorGroup component meant to be used with the RichSelector component.
 *
 * Will manage RichSelector `isFirst`, `isLast`, and `description` props.
 *
 * Handles showing the description given the fullWidthDescription and the hover
 * or checked state of the RichSelectors
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/richselector | RichSelector} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var RichSelectorGroup_RichSelectorGroup = function(_param) {
    var value = _param.value, fullWidthDescription = _param.fullWidthDescription, defaultFullWidthDescription = _param.defaultFullWidthDescription, children = _param.children, props = RichSelectorGroup_object_without_properties(_param, [
        "value",
        "fullWidthDescription",
        "defaultFullWidthDescription",
        "children"
    ]);
    var _activeOption, _activeOption1;
    var id = (0,external_react_namespaceObject.useId)();
    var options = external_react_default().Children.map(children, function(child) {
        return child;
    });
    var selectedOption = options.find(function(option) {
        return option.props.value === value;
    });
    var hasDescriptions = options.some(function(option) {
        return Boolean(option.props.description);
    });
    var _React_useState = RichSelectorGroup_sliced_to_array(external_react_default().useState(selectedOption), 2), activeOption = _React_useState[0], setActiveOption = _React_useState[1];
    var handleOptionEnter = function(value) {
        var hoveredOption = options.find(function(option) {
            return option.props.value === value;
        });
        setActiveOption(hoveredOption);
    };
    var handleOptionLeave = function() {
        setActiveOption(selectedOption);
    };
    var activeOptionId = id && activeOption ? "".concat(id, "-").concat(String(activeOption.props.value)) : undefined;
    var activeOptionHasDescription = Boolean((_activeOption = activeOption) === null || _activeOption === void 0 ? void 0 : _activeOption.props.description);
    var hasDefaultFullWithDescription = Boolean(defaultFullWidthDescription);
    var showFullWidthDescription = fullWidthDescription && (activeOptionHasDescription || hasDefaultFullWithDescription);
    var _activeOption_props_description;
    return /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(RichSelectorGroup.container, RichSelectorGroup_define_property({}, RichSelectorGroup.descriptionPadding, hasDescriptions && fullWidthDescription))
    }, /*#__PURE__*/ external_react_default().createElement(SelectorGroup_SelectorGroup, RichSelectorGroup_object_spread({
        inputsClassName: RichSelectorGroup.inputs,
        value: value
    }, props), options.map(function(option, index) {
        var _activeOption;
        var isActive = ((_activeOption = activeOption) === null || _activeOption === void 0 ? void 0 : _activeOption.props.value) === option.props.value;
        var hasDescription = Boolean(option.props.description);
        var descriptionId = id ? "".concat(id, "-").concat(String(option.props.value)) : undefined;
        return /*#__PURE__*/ external_react_default().cloneElement(option, {
            isFirst: index === 0,
            isLast: index === options.length - 1,
            labelProps: RichSelectorGroup_object_spread_props(RichSelectorGroup_object_spread({}, option.props.labelProps), {
                onMouseEnter: function() {
                    return handleOptionEnter(option.props.value);
                },
                onMouseLeave: handleOptionLeave,
                onFocus: function() {
                    return handleOptionEnter(option.props.value);
                },
                onBlur: handleOptionLeave
            }),
            className: external_classnames_default()(option.props.className, RichSelectorGroup_define_property({}, RichSelectorGroup.descriptionPadding, hasDescriptions && !fullWidthDescription)),
            "aria-describedby": descriptionId,
            description: fullWidthDescription ? undefined : /*#__PURE__*/ external_react_default().createElement(Description_Description, {
                id: descriptionId,
                in: isActive && hasDescription,
                className: RichSelectorGroup.description
            }, option.props.description)
        });
    })), showFullWidthDescription && /*#__PURE__*/ external_react_default().createElement(Description_Description, {
        id: activeOptionId,
        in: activeOptionHasDescription || hasDefaultFullWithDescription,
        className: RichSelectorGroup.description
    }, (_activeOption_props_description = (_activeOption1 = activeOption) === null || _activeOption1 === void 0 ? void 0 : _activeOption1.props.description) !== null && _activeOption_props_description !== void 0 ? _activeOption_props_description : defaultFullWidthDescription));
};

;// CONCATENATED MODULE: ./src/components/RichSelectorGroup/index.ts


;// CONCATENATED MODULE: ./src/components/Select/Arrow.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Select_Arrow = ({"container":"Lhs0CE","caret":"UyYQl2","left":"U6j1Bg","right":"DG6Dbv","chevron":"WAzhUJ"});
;// CONCATENATED MODULE: ./src/components/Select/hasValueSelected.ts


/**
 * Used to determine if an option is selected and it isn't an empty option
 */ var hasValueSelected = function(children) {
    if (!children) return false;
    var childArray = external_react_namespaceObject.Children.toArray(children);
    var firstChild = childArray[0];
    if (!(0,external_react_namespaceObject.isValidElement)(firstChild)) return false;
    var firstChildValue = firstChild.props.value;
    if (getHasValue(firstChildValue)) {
        return true;
    }
    return childArray.some(function(option) {
        if (!(0,external_react_namespaceObject.isValidElement)(option)) return false;
        var _option_props = option.props, selected = _option_props.selected, value = _option_props.value;
        return selected && getHasValue(value);
    });
};

;// CONCATENATED MODULE: ./src/components/Select/Select.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Select = ({"select":"bwIw36","regular":"Y8NqRF","bold":"sYP6Ks"});
;// CONCATENATED MODULE: ./src/components/Select/Select.tsx
function Select_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Select_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Select_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Select_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Select_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Select_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Select_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Select_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Select_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Select_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Select_sliced_to_array(arr, i) {
    return Select_array_with_holes(arr) || Select_iterable_to_array_limit(arr, i) || Select_unsupported_iterable_to_array(arr, i) || Select_non_iterable_rest();
}
function Select_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Select_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Select_array_like_to_array(o, minLen);
}









/** These are native props that we do not want to use and should protect ourselves */ var nativeOverrides = {
    autoFocus: false,
    multiple: false,
    defaultValue: undefined
};
var headingTypography = heading.create({
    size: 16
});
var bodyTypography = body.create({
    size: 16,
    weight: "bold"
});
/**
 * Custom select component using native select element.
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/select | Select} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var SelectComponent = function(_param) {
    var label = _param.label, children = _param.children, className = _param.className, onChange = _param.onChange, onFocus = _param.onFocus, onBlur = _param.onBlur, forwardedRef = _param.forwardedRef, invalid = _param.invalid, highlighted = _param.highlighted, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, _param_icon = _param.icon, icon = _param_icon === void 0 ? "caret" : _param_icon, _param_bold = _param.bold, bold = _param_bold === void 0 ? false : _param_bold, props = Select_object_without_properties(_param, [
        "label",
        "children",
        "className",
        "onChange",
        "onFocus",
        "onBlur",
        "forwardedRef",
        "invalid",
        "highlighted",
        "hideLabel",
        "icon",
        "bold"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = Select_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid,
        highlighted: highlighted
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _useState = Select_sliced_to_array((0,external_react_namespaceObject.useState)(getHasValue(props.value) || hasValueSelected(children)), 2), hasValue = _useState[0], setHasValue = _useState[1];
    (0,external_react_namespaceObject.useEffect)(function() {
        setHasValue(getHasValue(props.value) || hasValueSelected(children));
    }, [
        props.value,
        children
    ]);
    var handleChange = function(event) {
        var eventTarget = event.target;
        setHasValue(getHasValue(eventTarget.value));
    };
    return /*#__PURE__*/ external_react_default().createElement(BorderLabel_BorderLabel, {
        in: hasValue,
        state: state,
        text: label || props.name || "",
        className: className,
        hideLabel: hideLabel
    }, /*#__PURE__*/ external_react_default().createElement("select", Select_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()(Select.select, bold ? bodyTypography.className : headingTypography.className, bold ? Select.bold : Select.regular),
        onChange: interceptEvent(handleChange, onChange),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        "aria-invalid": invalid
    }, props, nativeOverrides), children), /*#__PURE__*/ external_react_default().createElement("span", {
        className: external_classnames_default()(Select_Arrow.container, Select_Arrow[icon], Select_Arrow[state])
    }, icon === "chevron" ? /*#__PURE__*/ external_react_default().createElement(Chevron, {
        fill: "kale-3",
        className: Select_Arrow.buttonIcon,
        size: 36
    }) : /*#__PURE__*/ external_react_default().createElement(Caret, {
        fill: "kale-3",
        className: Select_Arrow.buttonIcon,
        size: 36
    })));
};
var Select_Select = withRef(SelectComponent);

;// CONCATENATED MODULE: ./src/components/Select/index.ts


;// CONCATENATED MODULE: ./src/components/SlideShow/Slide.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SlideShow_Slide = ({"slide":"NEWjMd"});
;// CONCATENATED MODULE: ./src/components/SlideShow/Slide.tsx
function SlideShow_Slide_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SlideShow_Slide_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SlideShow_Slide_define_property(target, key, source[key]);
        });
    }
    return target;
}
function SlideShow_Slide_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = SlideShow_Slide_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SlideShow_Slide_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var SlideShow_Slide_Slide = function(_param) {
    var children = _param.children, className = _param.className, props = SlideShow_Slide_object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ external_react_default().createElement("li", SlideShow_Slide_object_spread({
        className: external_classnames_default()(SlideShow_Slide.slide, className)
    }, props), children);
};
/* harmony default export */ const components_SlideShow_Slide = (SlideShow_Slide_Slide);

;// CONCATENATED MODULE: ./src/components/SlideShow/isVisible.ts
/**
 * Return true if a child element is more than 50% in view relative to its
 * nearest scrollable parent.
 */ function isVisible(childRect, containerRect) {
    var childCenter = childRect.left + childRect.width / 2;
    return childCenter >= containerRect.left && childCenter <= containerRect.right;
}
/* harmony default export */ const SlideShow_isVisible = (isVisible);

;// CONCATENATED MODULE: ./src/components/SlideShow/SlideShow.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SlideShow = ({"container":"UI7TwX","horizontalSnap":"UWgRCi","dots":"b7sN3K","outside":"tHnvNE","inside":"_nkv6Z","previous":"HYbR2C","next":"sow3aJ"});
;// CONCATENATED MODULE: ./src/components/SlideShow/SlideShow.tsx
function SlideShow_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SlideShow_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function SlideShow_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SlideShow_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SlideShow_sliced_to_array(arr, i) {
    return SlideShow_array_with_holes(arr) || SlideShow_iterable_to_array_limit(arr, i) || SlideShow_unsupported_iterable_to_array(arr, i) || SlideShow_non_iterable_rest();
}
function SlideShow_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SlideShow_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SlideShow_array_like_to_array(o, minLen);
}









/**
 * Render a slide show component. This component accepts any number of children
 * that will each be rendered as a slide for the show.
 *
 * !Requires `polyfillSmoothScroll()` on the client for full browser support.
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/slideshow | SlideShow} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var SlideShow_SlideShow = function(param) {
    var children = param.children, label = param.label, _param_withDots = param.withDots, withDots = _param_withDots === void 0 ? false : _param_withDots, _param_withButtons = param.withButtons, withButtons = _param_withButtons === void 0 ? false : _param_withButtons, nextButtonClass = param.nextButtonClass, prevButtonClass = param.prevButtonClass, onCurrentSlide = param.onCurrentSlide, onSlideChange = param.onSlideChange, _param_scrollBehavior = param.scrollBehavior, scrollBehavior = _param_scrollBehavior === void 0 ? "auto" : _param_scrollBehavior, currentSlide = param.currentSlide, _param_controlsPosition = param.controlsPosition, controlsPosition = _param_controlsPosition === void 0 ? "outside" : _param_controlsPosition, activeIndexProp = param.activeIndex;
    var id = (0,external_react_namespaceObject.useId)();
    var numberOfSlides = external_react_default().Children.count(children);
    var _useHtmlElement = SlideShow_sliced_to_array(useHtmlElement(), 2), scrollableEl = _useHtmlElement[0], scrollableRef = _useHtmlElement[1];
    var _useSlideShow = useSlideShow({
        scrollableEl: scrollableEl,
        scrollBehavior: scrollBehavior,
        getIsActiveSlide: SlideShow_isVisible,
        onSlideChange: onSlideChange !== null && onSlideChange !== void 0 ? onSlideChange : onCurrentSlide,
        activeIndex: activeIndexProp !== null && activeIndexProp !== void 0 ? activeIndexProp : currentSlide
    }), activeIndex = _useSlideShow.activeIndex, goToSlide = _useSlideShow.goToSlide;
    var handlePreviousClick = function() {
        if (activeIndex === 0) {
            return;
        }
        goToSlide(activeIndex - 1);
    };
    var handleNextClick = function() {
        if (activeIndex === numberOfSlides - 1) {
            return;
        }
        goToSlide(activeIndex + 1);
    };
    return /*#__PURE__*/ external_react_default().createElement("section", {
        "aria-label": label,
        style: {
            position: controlsPosition === "inside" ? "relative" : "static"
        }
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        className: SlideShow.container
    }, /*#__PURE__*/ external_react_default().createElement(ScrollSnap_ScrollSnap, {
        as: "ul",
        id: id,
        ref: scrollableRef,
        className: SlideShow.horizontalSnap
    }, external_react_default().Children.map(children, function(child, index) {
        return /*#__PURE__*/ external_react_default().createElement(components_SlideShow_Slide, {
            "aria-label": "".concat(index + 1, " of ").concat(numberOfSlides)
        }, child);
    })), withButtons && /*#__PURE__*/ external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ external_react_default().createElement(ArrowButton_ArrowButton, {
        direction: "left",
        "aria-label": "previous",
        "aria-controls": id,
        className: external_classnames_default()(SlideShow.previous, prevButtonClass, SlideShow[controlsPosition]),
        size: controlsPosition === "inside" ? "lg" : "md",
        variant: controlsPosition === "inside" ? "white-bg" : "default",
        onClick: handlePreviousClick
    }), /*#__PURE__*/ external_react_default().createElement(ArrowButton_ArrowButton, {
        direction: "right",
        "aria-label": "next",
        "aria-controls": id,
        className: external_classnames_default()(SlideShow.next, nextButtonClass, SlideShow[controlsPosition]),
        size: controlsPosition === "inside" ? "lg" : "md",
        onClick: handleNextClick,
        variant: controlsPosition === "inside" ? "white-bg" : "default"
    }))), withDots && /*#__PURE__*/ external_react_default().createElement("div", {
        className: external_classnames_default()(SlideShow.dots, SlideShow[controlsPosition])
    }, external_react_default().Children.map(children, function(_, childIndex) {
        return /*#__PURE__*/ external_react_default().createElement(IndexButton_IndexButton, {
            "aria-controls": id,
            "aria-label": "Go to slide ".concat(childIndex + 1),
            active: childIndex === activeIndex,
            onClick: function() {
                return goToSlide(childIndex);
            },
            mode: controlsPosition === "inside" ? "green" : "dark",
            className: external_classnames_default()(childIndex === activeIndex ? SlideShow.active : null)
        });
    })));
};

;// CONCATENATED MODULE: ./src/components/SlideShow/index.ts


;// CONCATENATED MODULE: external "lodash/isError"
const isError_namespaceObject = require("lodash/isError");
var isError_default = /*#__PURE__*/__webpack_require__.n(isError_namespaceObject);
;// CONCATENATED MODULE: external "@stripe/stripe-js/pure"
const pure_namespaceObject = require("@stripe/stripe-js/pure");
;// CONCATENATED MODULE: ./src/components/Stripe/StripeContext.tsx

var StripeContext_INITIAL_VALUE = {};
var StripeContext = /*#__PURE__*/ external_react_namespaceObject.createContext(StripeContext_INITIAL_VALUE);

;// CONCATENATED MODULE: ./src/components/Stripe/StripeProvider.tsx
function StripeProvider_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function StripeProvider_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function StripeProvider_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function StripeProvider_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function StripeProvider_sliced_to_array(arr, i) {
    return StripeProvider_array_with_holes(arr) || StripeProvider_iterable_to_array_limit(arr, i) || StripeProvider_unsupported_iterable_to_array(arr, i) || StripeProvider_non_iterable_rest();
}
function StripeProvider_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return StripeProvider_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return StripeProvider_array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}




/**
 * Initializes Stripe API and create a context to access the global instance.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/StripeProvider | StripeProvider} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var StripeProvider = function(param) {
    var publishableKey = param.publishableKey, onLoadError = param.onLoadError, children = param.children;
    var _React_useState = StripeProvider_sliced_to_array(external_react_namespaceObject.useState(), 2), error = _React_useState[0], setError = _React_useState[1];
    var _React_useState1 = StripeProvider_sliced_to_array(external_react_namespaceObject.useState(), 2), instance = _React_useState1[0], setInstance = _React_useState1[1];
    /** Load stripe API */ external_react_namespaceObject.useEffect(function() {
        if (instance) {
            // Stripe is initialized nothing to do
            return;
        }
        if (error) {
            // Could not load stripe
            return;
        }
        var load = function() {
            var _ref = _async_to_generator(function() {
                var stripeInstance, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,pure_namespaceObject.loadStripe)(publishableKey)
                            ];
                        case 1:
                            stripeInstance = _state.sent();
                            setInstance(stripeInstance ? stripeInstance : undefined);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (!isError_default()(error)) return [
                                2
                            ];
                            setError(error);
                            if (onLoadError) {
                                onLoadError(error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function load() {
                return _ref.apply(this, arguments);
            };
        }();
        void load();
    }, [
        publishableKey,
        onLoadError,
        error,
        instance
    ]);
    var stripeContextValue = external_react_namespaceObject.useMemo(function() {
        return {
            stripe: instance,
            stripeLoadError: error
        };
    }, [
        instance,
        error
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(StripeContext.Provider, {
        value: stripeContextValue
    }, children);
};

;// CONCATENATED MODULE: ./src/components/Stripe/useStripe.ts


/**
 * Return the stripe context value
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useStripe | useStripe} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useStripe() {
    return external_react_namespaceObject.useContext(StripeContext);
}

;// CONCATENATED MODULE: ./src/components/Stripe/fonts.ts
var WOFF = "https://use.typekit.net/af/9395af/00000000000000003b9b2046/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3";
var FONTS = [
    {
        family: "neue-haas-grotesk-display",
        src: "url(".concat(WOFF, ")"),
        display: "auto",
        style: "normal",
        weight: "400"
    }
];

;// CONCATENATED MODULE: ./src/components/Stripe/ElementsProvider.tsx
function ElementsProvider_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ElementsProvider_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ElementsProvider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ElementsProvider_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ElementsProvider_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ElementsProvider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ElementsProvider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ElementsProvider_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ElementsProvider_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ElementsProvider_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ElementsProvider_sliced_to_array(arr, i) {
    return ElementsProvider_array_with_holes(arr) || ElementsProvider_iterable_to_array_limit(arr, i) || ElementsProvider_unsupported_iterable_to_array(arr, i) || ElementsProvider_non_iterable_rest();
}
function ElementsProvider_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ElementsProvider_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ElementsProvider_array_like_to_array(o, minLen);
}





/**
 * Create and provides a stripe elements object to subscribers.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/StripeElementProvider | StripeElementProvider} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ElementsProvider = function(_param) {
    var children = _param.children, _param_fonts = _param.fonts, fonts = _param_fonts === void 0 ? FONTS : _param_fonts, props = ElementsProvider_object_without_properties(_param, [
        "children",
        "fonts"
    ]);
    var _React_useState = ElementsProvider_sliced_to_array(external_react_namespaceObject.useState(), 2), elements = _React_useState[0], setElements = _React_useState[1];
    var safeOptions = useSafeOptions(ElementsProvider_object_spread({
        fonts: fonts
    }, props));
    var stripe = useStripe().stripe;
    external_react_namespaceObject.useEffect(function() {
        if (!stripe) {
            // Stripe is a required dependency for this component
            return;
        }
        if (elements) {
            return;
        }
        setElements(stripe.elements(safeOptions));
    }, [
        stripe,
        safeOptions,
        elements
    ]);
    var stripeElementsContextValue = external_react_namespaceObject.useMemo(function() {
        return {
            elements: elements
        };
    }, [
        elements
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(ElementsContext.Provider, {
        value: stripeElementsContextValue
    }, children);
};

;// CONCATENATED MODULE: ./src/components/Stripe/useCreateToken.ts



/**
 * Return a single function to create a stripe token. Automatically subscribes
 * to the current elements context and passes a valid element.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/api/functions/useStripeCreateToken | useStripeCreateToken} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ function useCreateToken() {
    var elements = useElements().elements;
    var stripe = useStripe().stripe;
    return function(data) {
        if (!stripe) {
            throw new Error("Stripe cannot be found");
        }
        if (!elements) {
            throw new Error("Stripe elements cannot be found");
        }
        var element = elements.getElement(elementTypes.cardNumber);
        if (!element) {
            throw new Error("Card element cannot found");
        }
        return stripe.createToken(element, data);
    };
}

;// CONCATENATED MODULE: ./src/components/Stripe/index.ts







;// CONCATENATED MODULE: ./src/components/TextArea/TextArea.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const TextArea = ({"textarea":"JNP_3_","label":"y6FJ6c"});
;// CONCATENATED MODULE: ./src/components/TextArea/TextArea.tsx
function TextArea_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TextArea_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function TextArea_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TextArea_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function TextArea_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TextArea_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TextArea_define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextArea_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function TextArea_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        TextArea_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function TextArea_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = TextArea_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function TextArea_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TextArea_sliced_to_array(arr, i) {
    return TextArea_array_with_holes(arr) || TextArea_iterable_to_array_limit(arr, i) || TextArea_unsupported_iterable_to_array(arr, i) || TextArea_non_iterable_rest();
}
function TextArea_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TextArea_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TextArea_array_like_to_array(o, minLen);
}






var TextArea_typography = heading.create({
    size: 16
});
var TextAreaComponent = function(_param) {
    var label = _param.label, className = _param.className, invalid = _param.invalid, onBlur = _param.onBlur, onChange = _param.onChange, onFocus = _param.onFocus, forwardedRef = _param.forwardedRef, _param_hideLabel = _param.hideLabel, hideLabel = _param_hideLabel === void 0 ? false : _param_hideLabel, props = TextArea_object_without_properties(_param, [
        "label",
        "className",
        "invalid",
        "onBlur",
        "onChange",
        "onFocus",
        "forwardedRef",
        "hideLabel"
    ]);
    // autoFocus and disabled should be passed on to native element.
    var _useElementState = TextArea_sliced_to_array(useElementState({
        autoFocus: props.autoFocus,
        disabled: props.disabled,
        invalid: invalid
    }), 2), state = _useElementState[0], handlers = _useElementState[1];
    var _React_useState = TextArea_sliced_to_array(external_react_namespaceObject.useState(typeof props.value !== "undefined" ? props.value : ""), 2), value = _React_useState[0], setValue = _React_useState[1];
    external_react_namespaceObject.useEffect(function() {
        if (typeof props.value !== "undefined") {
            setValue(props.value);
        }
    }, [
        props.value
    ]);
    var handleChange = function(event) {
        setValue(event.target.value);
    };
    return /*#__PURE__*/ external_react_namespaceObject.createElement(BorderLabel_BorderLabel, {
        className: external_classnames_default()(TextArea.label, className),
        in: state === "focus" || state === "invalid" || getHasValue(value),
        text: label || props.name || "",
        state: state,
        hideLabel: hideLabel
    }, /*#__PURE__*/ external_react_namespaceObject.createElement("textarea", TextArea_object_spread_props(TextArea_object_spread({
        ref: forwardedRef,
        className: external_classnames_default()(TextArea.textarea, TextArea_typography.className),
        onChange: interceptEvent(handleChange, onChange),
        onFocus: interceptEvent(handlers.onFocus, onFocus),
        onBlur: interceptEvent(handlers.onBlur, onBlur),
        "aria-invalid": invalid
    }, props), {
        value: value,
        placeholder: undefined
    })));
};
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/textarea | TextArea} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var TextArea_TextArea = withRef(TextAreaComponent);

;// CONCATENATED MODULE: ./src/components/TextArea/index.ts


;// CONCATENATED MODULE: ./src/components/Toast/constants.ts
var constants_ANIMATION_DURATION = 600;

;// CONCATENATED MODULE: ./src/components/Toast/Toast.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Toast = ({"toast":"uoJHJ4","neutral":"I_mRGr","negative":"tIXZ0J","positive":"hNPKvJ"});
;// CONCATENATED MODULE: ./src/components/Toast/Toast.transitions.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Toast_transitions = ({"appear":"BB6Inj","appearDone":"s9MChP","enter":"RiHmCW","enterDone":"qGWcPX","exit":"P3VF4u","exitDone":"e0DiqZ","appearActive":"B_7Ukf","spring-in":"Kqg2Pn","springIn":"Kqg2Pn","enterActive":"W1mX2G","exitActive":"vv7s6b","spring-out":"KRn7A9","springOut":"KRn7A9"});
;// CONCATENATED MODULE: ./src/components/Toast/Toast.tsx
function Toast_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Toast_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Toast_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Toast_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Toast_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Toast_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Toast_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Toast_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Toast_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var VARIANTS = (/* unused pure expression or super */ null && ([
    "negative",
    "neutral",
    "positive"
]));
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/toast | Toast} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Toast_Toast = function(_param) {
    var variant = _param.variant, children = _param.children, transitionProps = Toast_object_without_properties(_param, [
        "variant",
        "children"
    ]);
    return /*#__PURE__*/ external_react_namespaceObject.createElement(external_react_transition_group_namespaceObject.CSSTransition, Toast_object_spread_props(Toast_object_spread({}, transitionProps), {
        timeout: constants_ANIMATION_DURATION,
        classNames: Toast_transitions,
        unmountOnExit: true,
        appear: true
    }), /*#__PURE__*/ external_react_namespaceObject.createElement("div", {
        role: "alert",
        className: external_classnames_default()(Toast.toast, Toast[variant])
    }, /*#__PURE__*/ external_react_namespaceObject.createElement(Text_Text, {
        variant: "heading-16",
        color: "kale-3"
    }, children)));
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastContext.ts


var ToastContext = (0,external_react_namespaceObject.createContext)({
    dispatchToast: (noop_default()),
    dispatchToastDialog: (noop_default()),
    closeToastDialog: (noop_default())
});

;// CONCATENATED MODULE: ./src/components/Toast/ToastDialog.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ToastDialog = ({"document":"z6iqjW","message":"dZAqkd"});
;// CONCATENATED MODULE: ./src/components/Toast/ToastDialog.tsx
function ToastDialog_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastDialog_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastDialog_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToastDialog_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToastDialog_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToastDialog_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToastDialog_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ToastDialog_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ToastDialog_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ToastDialog_VARIANTS = (/* unused pure expression or super */ null && ([
    "negative",
    "neutral",
    "positive"
]));
/**
 * A toast that includes a single interaction.
 *
 * @deprecated Use {@link https://corgi-x.tfd.engineering/components/toast | Toast} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var ToastDialog_ToastDialog = function(_param) {
    var /** Style of the toast */ variant = _param.variant, /** Toast content */ message = _param.message, /** Text in the button */ buttonLabel = _param.buttonLabel, /** Button click handler */ onButtonClick = _param.onButtonClick, transitionProps = ToastDialog_object_without_properties(_param, [
        "variant",
        "message",
        "buttonLabel",
        "onButtonClick"
    ]);
    var closeToastDialog = external_react_default().useContext(ToastContext).closeToastDialog;
    var labelId = (0,external_react_namespaceObject.useId)();
    var handleClick = function(e) {
        var _closeToastDialog, _onButtonClick;
        (_closeToastDialog = closeToastDialog) === null || _closeToastDialog === void 0 ? void 0 : _closeToastDialog();
        (_onButtonClick = onButtonClick) === null || _onButtonClick === void 0 ? void 0 : _onButtonClick(e);
    };
    return /*#__PURE__*/ external_react_default().createElement(external_react_transition_group_namespaceObject.CSSTransition, ToastDialog_object_spread_props(ToastDialog_object_spread({}, transitionProps), {
        timeout: constants_ANIMATION_DURATION,
        classNames: Toast_transitions,
        unmountOnExit: true,
        appear: true
    }), /*#__PURE__*/ external_react_default().createElement("div", {
        role: "alertdialog",
        className: external_classnames_default()(Toast.toast, Toast[variant]),
        "aria-label": labelId
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        role: "document",
        className: ToastDialog.document
    }, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        color: "kale-3",
        id: labelId,
        className: ToastDialog.message
    }, message), /*#__PURE__*/ external_react_default().createElement(Button_Button, {
        asLink: true,
        variant: "primary",
        onClick: handleClick,
        className: ToastDialog.button
    }, /*#__PURE__*/ external_react_default().createElement(Text_Text, {
        variant: "heading-16",
        bold: true
    }, buttonLabel)))));
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastRenderer.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ToastRenderer = ({"tfd-toast":"kFGAW2","tfdToast":"kFGAW2","container":"je2jkL"});
;// CONCATENATED MODULE: ./src/components/Toast/ToastRenderer.tsx
function ToastRenderer_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastRenderer_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastRenderer_define_property(target, key, source[key]);
        });
    }
    return target;
}








var ToastRenderer_ToastRenderer = function() {
    var root = (0,external_react_namespaceObject.useRef)();
    var _useContext = (0,external_react_namespaceObject.useContext)(ToastContext), activeToasts = _useContext.activeToasts, activeToastDialogs = _useContext.activeToastDialogs;
    (0,external_react_namespaceObject.useEffect)(function() {
        root.current = addDOMElementById(ToastRenderer.tfdToast);
    }, []);
    if (!root.current || !activeToastDialogs || !activeToasts) {
        return null;
    }
    return /*#__PURE__*/ external_react_dom_default().createPortal(/*#__PURE__*/ external_react_default().createElement("div", {
        className: ToastRenderer.container
    }, /*#__PURE__*/ external_react_default().createElement(external_react_transition_group_namespaceObject.TransitionGroup, {
        component: null
    }, activeToastDialogs.map(function(toastDialogProps) {
        return /*#__PURE__*/ external_react_default().createElement(ToastDialog_ToastDialog, ToastRenderer_object_spread({
            key: toastDialogProps.id
        }, toastDialogProps));
    }), activeToasts.map(function(toastProps) {
        return /*#__PURE__*/ external_react_default().createElement(Toast_Toast, ToastRenderer_object_spread({
            key: toastProps.id
        }, toastProps));
    }))), root.current);
};

;// CONCATENATED MODULE: external "nanoid/non-secure"
const non_secure_namespaceObject = require("nanoid/non-secure");
;// CONCATENATED MODULE: ./src/components/Toast/ToastProvider.tsx
function ToastProvider_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ToastProvider_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function ToastProvider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToastProvider_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ToastProvider_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ToastProvider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToastProvider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToastProvider_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToastProvider_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToastProvider_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToastProvider_sliced_to_array(arr, i) {
    return ToastProvider_array_with_holes(arr) || ToastProvider_iterable_to_array_limit(arr, i) || ToastProvider_unsupported_iterable_to_array(arr, i) || ToastProvider_non_iterable_rest();
}
function ToastProvider_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ToastProvider_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ToastProvider_array_like_to_array(o, minLen);
}




var TOAST_DURATION = 1000 * 5;
var TIMEOUT = TOAST_DURATION + constants_ANIMATION_DURATION;
function useToastDispatch(toastTimeout) {
    var _useState = ToastProvider_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = ToastProvider_sliced_to_array((0,external_react_namespaceObject.useState)(), 2), queued = _useState1[0], setQueued = _useState1[1];
    var close = function() {
        return setActive(undefined);
    };
    var dispatchToast = (0,external_react_namespaceObject.useCallback)(function(toastProps) {
        var id = (0,non_secure_namespaceObject.nanoid)();
        var newToast = ToastProvider_object_spread_props(ToastProvider_object_spread({}, toastProps), {
            id: id
        });
        if (active || queued) {
            setQueued(newToast);
        } else {
            setActive(newToast);
        }
    }, [
        active,
        queued
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!active) return;
        var removeToast = function() {
            setActive(undefined);
        };
        var timeout = toastTimeout ? setTimeout(removeToast, toastTimeout) : undefined;
        return function() {
            if (timeout) {
                clearTimeout(timeout);
            }
            removeToast();
        };
    }, [
        active,
        toastTimeout
    ]);
    (0,external_react_namespaceObject.useEffect)(function() {
        if (!queued) return;
        setActive(undefined);
        var timeout = setTimeout(function() {
            setQueued(function(currentQueued) {
                setActive(currentQueued);
                return undefined;
            });
        }, constants_ANIMATION_DURATION);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        queued
    ]);
    return [
        dispatchToast,
        active ? [
            active
        ] : [],
        close
    ];
}
var ToastProvider = function(param) {
    var children = param.children;
    var _useToastDispatch = ToastProvider_sliced_to_array(useToastDispatch(TIMEOUT), 2), dispatchToast = _useToastDispatch[0], activeToasts = _useToastDispatch[1];
    var _useToastDispatch1 = ToastProvider_sliced_to_array(useToastDispatch(), 3), dispatchToastDialog = _useToastDispatch1[0], activeToastDialogs = _useToastDispatch1[1], closeToastDialog = _useToastDispatch1[2];
    var toastContextValue = (0,external_react_namespaceObject.useMemo)(function() {
        return {
            dispatchToast: dispatchToast,
            activeToasts: activeToasts,
            dispatchToastDialog: dispatchToastDialog,
            activeToastDialogs: activeToastDialogs,
            closeToastDialog: closeToastDialog
        };
    }, [
        dispatchToast,
        activeToasts,
        dispatchToastDialog,
        activeToastDialogs,
        closeToastDialog
    ]);
    return /*#__PURE__*/ external_react_default().createElement(ToastContext.Provider, {
        value: toastContextValue
    }, children);
};

;// CONCATENATED MODULE: ./src/components/Toast/useToast.ts


function useToast() {
    var dispatchToast = (0,external_react_namespaceObject.useContext)(ToastContext).dispatchToast;
    return dispatchToast;
}

;// CONCATENATED MODULE: ./src/components/Toast/useToastDialog.ts


function useToastDialog() {
    var dispatchToastDialog = (0,external_react_namespaceObject.useContext)(ToastContext).dispatchToastDialog;
    return dispatchToastDialog;
}

;// CONCATENATED MODULE: ./src/components/Toast/index.ts





;// CONCATENATED MODULE: ./src/components/withTFDProps/getDisplayName.ts
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

;// CONCATENATED MODULE: ./src/components/withTFDProps/withTFDProps.tsx
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ function withTFDProps_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withTFDProps_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withTFDProps_define_property(target, key, source[key]);
        });
    }
    return target;
}
function withTFDProps_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function withTFDProps_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        withTFDProps_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var withTFDProps = function(WrappedComponent) {
    return function(props) {
        var _props;
        var _props_dataname;
        var dataName = (_props_dataname = (_props = props) === null || _props === void 0 ? void 0 : _props["data-name"]) !== null && _props_dataname !== void 0 ? _props_dataname : getDisplayName(WrappedComponent);
        return /*#__PURE__*/ external_react_namespaceObject.createElement(WrappedComponent, withTFDProps_object_spread_props(withTFDProps_object_spread({}, props), {
            "data-name": dataName
        }));
    };
};

;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Tooltip = ({"overlay-wrapper":"EzFG5n","overlayWrapper":"EzFG5n","tooltip-wrapper":"IUpyoD","tooltipWrapper":"IUpyoD","tooltip":"ZOLQRn","light":"QBtlsG","dark":"QPqGtj","tooltip-top":"FTK0Zq","tooltipTop":"FTK0Zq","tooltip-top-left":"N5iEmD","tooltipTopLeft":"N5iEmD","tooltip-top-right":"tif_cs","tooltipTopRight":"tif_cs","tooltip-bottom":"PgfWlq","tooltipBottom":"PgfWlq","tooltip-bottom-left":"hU9Nmc","tooltipBottomLeft":"hU9Nmc","tooltip-bottom-right":"gg73G_","tooltipBottomRight":"gg73G_","tooltip-left":"TK1EaO","tooltipLeft":"TK1EaO","tooltip-left-top":"LQOkuB","tooltipLeftTop":"LQOkuB","tooltip-left-bottom":"FTAb_z","tooltipLeftBottom":"FTAb_z","tooltip-right":"FDGdsz","tooltipRight":"FDGdsz","tooltip-right-top":"obO_p2","tooltipRightTop":"obO_p2","tooltip-right-bottom":"Pg5ZTo","tooltipRightBottom":"Pg5ZTo"});
;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.tsx
function Tooltip_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Tooltip_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function Tooltip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tooltip_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Tooltip_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Tooltip_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tooltip_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Tooltip_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Tooltip_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Tooltip_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Tooltip_sliced_to_array(arr, i) {
    return Tooltip_array_with_holes(arr) || Tooltip_iterable_to_array_limit(arr, i) || Tooltip_unsupported_iterable_to_array(arr, i) || Tooltip_non_iterable_rest();
}
function Tooltip_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Tooltip_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tooltip_array_like_to_array(o, minLen);
}





var TooltipPositions = [
    "top",
    "top-left",
    "top-right",
    "right",
    "right-top",
    "right-bottom",
    "bottom",
    "bottom-left",
    "bottom-right",
    "left",
    "left-top",
    "left-bottom"
];
var TooltipModes = [
    "light",
    "dark"
];
function TooltipComponent(_param) {
    var children = _param.children, position = _param.position, content = _param.content, _param_mode = _param.mode, mode = _param_mode === void 0 ? "light" : _param_mode, className = _param.className, props = Tooltip_object_without_properties(_param, [
        "children",
        "position",
        "content",
        "mode",
        "className"
    ]);
    var el = external_react_default().useRef(null);
    var reactId = (0,external_react_namespaceObject.useId)();
    var id = props.id || reactId;
    var _React_useState = Tooltip_sliced_to_array(external_react_default().useState(true), 2), isHidden = _React_useState[0], setIsHidden = _React_useState[1];
    var hide = function() {
        setIsHidden(true);
    };
    var show = function() {
        setIsHidden(false);
    };
    // Special case - prevent mouseleave hiding tooltip if element in focus using
    // document.contains because child element could have multiple focusable
    // children
    var handleMouseLeave = function() {
        if (el.current && !el.current.contains(document.activeElement)) {
            setIsHidden(true);
        }
    };
    var handleBlur = function() {
        browserOnly(function(window) {
            /** This pushes the hide to the end of the event loop ensuring that on touch
       * devices they can interact with the tooltip content before it hides */ window.setTimeout(hide, 0);
        });
    };
    external_react_default().useEffect(function() {
        return browserOnly(function(_, document1) {
            var handleKeyDown = function(e) {
                if (e.key === "Escape") {
                    setIsHidden(true);
                }
            };
            document1.addEventListener("keydown", handleKeyDown);
            return function() {
                return document1.removeEventListener("keydown", handleKeyDown);
            };
        });
    }, []);
    if (!/*#__PURE__*/ external_react_default().isValidElement(children)) {
        throw new Error("Tooltip only accepts a single child as a valid trigger element");
    }
    var triggerElement = /*#__PURE__*/ external_react_default().cloneElement(children, {
        "aria-describedby": id,
        onMouseEnter: interceptEvent(children.props.onMouseEnter, show),
        onMouseLeave: interceptEvent(children.props.onMouseLeave, handleMouseLeave),
        onFocus: interceptEvent(children.props.onFocus, show),
        onBlur: interceptEvent(children.props.onBlur, handleBlur),
        // We need to attach onClick to support iOS Safari
        onClick: interceptEvent(children.props.onClick, show)
    });
    return /*#__PURE__*/ external_react_default().createElement("span", Tooltip_object_spread({
        className: external_classnames_default()(Tooltip.overlayWrapper, className),
        "aria-label": "Toggle tooltip",
        ref: el
    }, props), triggerElement, /*#__PURE__*/ external_react_default().createElement("span", {
        className: external_classnames_default()(Tooltip.tooltipWrapper, Tooltip["tooltip-".concat(position)]),
        onMouseEnter: show,
        onMouseLeave: hide,
        "aria-hidden": content ? isHidden : true
    }, /*#__PURE__*/ external_react_default().createElement("span", {
        className: external_classnames_default()(Tooltip.tooltip, Tooltip[mode]),
        role: "tooltip",
        id: id
    }, content)));
}
/** @deprecated Import {@link https://corgi-x.tfd.engineering/components/tooltip | Tooltip} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}. */ var Tooltip_Tooltip = withTFDProps(TooltipComponent);

;// CONCATENATED MODULE: ./src/components/Tooltip/index.ts


;// CONCATENATED MODULE: ./src/components/VerticalNavigation/VerticalNavigation.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const VerticalNavigation = ({"container":"ztq9Z1","items":"Bylntm","link":"gW6MfN","active":"b0wct3"});
;// CONCATENATED MODULE: ./src/components/VerticalNavigation/VerticalNavigation.tsx
function VerticalNavigation_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VerticalNavigation_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VerticalNavigation_define_property(target, key, source[key]);
        });
    }
    return target;
}
function VerticalNavigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function VerticalNavigation_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        VerticalNavigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/**
 *
 * The VerticalNavigation displays information and actions relating to the navigation in a vertical orientation.
 *
 * @deprecated Import {@link https://corgi-x.tfd.engineering/components/verticalnavigation | VerticalNavigation} from corgi-x. See the {@link https://corgi-x.tfd.engineering/components/legacy | Legacy components}.
 */ var VerticalNavigation_VerticalNavigation = function(props) {
    return /*#__PURE__*/ external_react_default().createElement("nav", {
        role: "navigation",
        className: VerticalNavigation.container
    }, /*#__PURE__*/ external_react_default().createElement("div", {
        className: VerticalNavigation.items
    }, props.items.map(function(item) {
        return /*#__PURE__*/ external_react_default().createElement(Link_Link, VerticalNavigation_object_spread_props(VerticalNavigation_object_spread({}, item), {
            key: item.title,
            className: VerticalNavigation.link,
            activeClassName: VerticalNavigation.active,
            variant: "secondary",
            mode: "dark"
        }), /*#__PURE__*/ external_react_default().createElement(Text_Text, {
            variant: "heading-16",
            bold: true
        }, item.title));
    })));
};

;// CONCATENATED MODULE: ./src/components/VerticalNavigation/index.ts


;// CONCATENATED MODULE: ./src/components/withTFDProps/index.ts


;// CONCATENATED MODULE: ./src/components/index.ts
// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity












































;// CONCATENATED MODULE: ./src/hooks/index.ts






;// CONCATENATED MODULE: external "smoothscroll-polyfill"
const external_smoothscroll_polyfill_namespaceObject = require("smoothscroll-polyfill");
var external_smoothscroll_polyfill_default = /*#__PURE__*/__webpack_require__.n(external_smoothscroll_polyfill_namespaceObject);
;// CONCATENATED MODULE: ./src/util/polyfills.ts

/**
 * Enable native smooth scrolling on browser not supporting it (e.g. IE, Safari)
 * with the [smoothscroll-polyfill](https://github.com/iamdustan/smoothscroll).
 *
 * Polyfills must be enabled on the browser, for example in the app client's
 * entry file or within an effect.
 */ function polyfillSmoothScroll() {
    external_smoothscroll_polyfill_default().polyfill();
}

;// CONCATENATED MODULE: ./src/util/accessibility/index.ts



;// CONCATENATED MODULE: ./src/index.ts

// these exports are listed in dependency order to ensure that the CSS bundle
// is created with styles and their overrides in the correct order for specificity










var __webpack_exports__ANIMATION_DURATION = __webpack_exports__.zn9;
var __webpack_exports__AppBar = __webpack_exports__.xG4;
var __webpack_exports__AriaLiveAttributes = __webpack_exports__.CVn;
var __webpack_exports__Arrow = __webpack_exports__.Ehc;
var __webpack_exports__ArticleColors = __webpack_exports__.MUU;
var __webpack_exports__ArticleFontWeights = __webpack_exports__.JFs;
var __webpack_exports__ArticleSizeVariants = __webpack_exports__.WnP;
var __webpack_exports__ArticleSizes = __webpack_exports__.LYm;
var __webpack_exports__ArticleStyles = __webpack_exports__.L6R;
var __webpack_exports__ArticleTextVariants = __webpack_exports__.aPt;
var __webpack_exports__ArticleWeights = __webpack_exports__.dnp;
var __webpack_exports__AsyncModal = __webpack_exports__.zRX;
var __webpack_exports__Back = __webpack_exports__.eJh;
var __webpack_exports__Behavior = __webpack_exports__.cgf;
var __webpack_exports__Blob = __webpack_exports__.t6b;
var __webpack_exports__BodyColors = __webpack_exports__.Bld;
var __webpack_exports__BodyFontWeights = __webpack_exports__.kc3;
var __webpack_exports__BodySizeVariants = __webpack_exports__.by9;
var __webpack_exports__BodySizes = __webpack_exports__.coK;
var __webpack_exports__BodyStyles = __webpack_exports__.ChY;
var __webpack_exports__BodyTextVariants = __webpack_exports__.wrz;
var __webpack_exports__BodyWeights = __webpack_exports__.w1F;
var __webpack_exports__Bolt = __webpack_exports__.rZ0;
var __webpack_exports__BorderLabel = __webpack_exports__.Rkq;
var __webpack_exports__BowlSteaming = __webpack_exports__.KN4;
var __webpack_exports__Breadcrumbs = __webpack_exports__.OoM;
var __webpack_exports__Button = __webpack_exports__.zxk;
var __webpack_exports__ButtonVariants = __webpack_exports__.cTN;
var __webpack_exports__Calendar = __webpack_exports__.faS;
var __webpack_exports__Card = __webpack_exports__.Zbd;
var __webpack_exports__CardCvc = __webpack_exports__.ATA;
var __webpack_exports__CardExpiration = __webpack_exports__.imh;
var __webpack_exports__CardHTMLElements = __webpack_exports__.izk;
var __webpack_exports__CardNumber = __webpack_exports__.ZQe;
var __webpack_exports__Caret = __webpack_exports__.Fjk;
var __webpack_exports__Carousel = __webpack_exports__.lr9;
var __webpack_exports__CarouselItem = __webpack_exports__.d$M;
var __webpack_exports__Carrot = __webpack_exports__.R0Z;
var __webpack_exports__Check = __webpack_exports__.JrY;
var __webpack_exports__CheckCircle = __webpack_exports__.fU8;
var __webpack_exports__Checkbox = __webpack_exports__.XZJ;
var __webpack_exports__CheckboxView = __webpack_exports__.Zn_;
var __webpack_exports__Chevron = __webpack_exports__.Tt3;
var __webpack_exports__Circle = __webpack_exports__.Cdc;
var __webpack_exports__CircleAlert = __webpack_exports__.Bjq;
var __webpack_exports__CircleCross = __webpack_exports__.liM;
var __webpack_exports__CircleFill = __webpack_exports__.LSb;
var __webpack_exports__CircleMinus = __webpack_exports__.XWL;
var __webpack_exports__CirclePlus = __webpack_exports__.Gq5;
var __webpack_exports__Clipboard = __webpack_exports__.TUt;
var __webpack_exports__Clock = __webpack_exports__.SUY;
var __webpack_exports__Close = __webpack_exports__.x8P;
var __webpack_exports__CloseButton = __webpack_exports__.PZ7;
var __webpack_exports__ContentReveal = __webpack_exports__.Zqw;
var __webpack_exports__ContentRevealAnimations = __webpack_exports__.OE3;
var __webpack_exports__ContentWidth = __webpack_exports__.ufE;
var __webpack_exports__ContentWidthAlignment = __webpack_exports__.HDb;
var __webpack_exports__ContentWidthStyles = __webpack_exports__.anL;
var __webpack_exports__Divider = __webpack_exports__.izJ;
var __webpack_exports__DividerColors = __webpack_exports__.B_z;
var __webpack_exports__DividerOrientations = __webpack_exports__.FCg;
var __webpack_exports__Doctor = __webpack_exports__.mF8;
var __webpack_exports__DogFood = __webpack_exports__.$6d;
var __webpack_exports__ESCAPE = __webpack_exports__.hYT;
var __webpack_exports__ElementStates = __webpack_exports__.Dkg;
var __webpack_exports__ElementsProvider = __webpack_exports__._5T;
var __webpack_exports__Facebook = __webpack_exports__.s1S;
var __webpack_exports__ForkSpoon = __webpack_exports__.NDf;
var __webpack_exports__FormControl = __webpack_exports__.NIc;
var __webpack_exports__Gallery = __webpack_exports__.riA;
var __webpack_exports__GalleryModes = __webpack_exports__.Wx4;
var __webpack_exports__GridContainer = __webpack_exports__.T5p;
var __webpack_exports__GridContainerBreakpoints = __webpack_exports__.aH1;
var __webpack_exports__GridContainerHTMLElements = __webpack_exports__.kqm;
var __webpack_exports__HeadingColors = __webpack_exports__.tYz;
var __webpack_exports__HeadingFontWeights = __webpack_exports__.o0;
var __webpack_exports__HeadingSizeVariants = __webpack_exports__.ton;
var __webpack_exports__HeadingSizes = __webpack_exports__.vwx;
var __webpack_exports__HeadingStyles = __webpack_exports__.Ewq;
var __webpack_exports__HeadingTextVariants = __webpack_exports__.MyD;
var __webpack_exports__HeadingWeights = __webpack_exports__.QDz;
var __webpack_exports__Heart = __webpack_exports__.Xdw;
var __webpack_exports__HeartOutline = __webpack_exports__.mqL;
var __webpack_exports__Hero = __webpack_exports__.VMD;
var __webpack_exports__HoImport = __webpack_exports__.hM8;
var __webpack_exports__HorizontalNavigation = __webpack_exports__.X9i;
var __webpack_exports__HorizontalNavigationItem = __webpack_exports__.EWW;
var __webpack_exports__IconPropTypes = __webpack_exports__.Nt3;
var __webpack_exports__IndexButton = __webpack_exports__.JFW;
var __webpack_exports__Information = __webpack_exports__.daM;
var __webpack_exports__Input = __webpack_exports__.IIB;
var __webpack_exports__InputComponent = __webpack_exports__.amK;
var __webpack_exports__LabeledSelector = __webpack_exports__.YlX;
var __webpack_exports__Leaf = __webpack_exports__.B3Q;
var __webpack_exports__Lightbox = __webpack_exports__.eyg;
var __webpack_exports__Link = __webpack_exports__.rUS;
var __webpack_exports__LinkModes = __webpack_exports__.z4R;
var __webpack_exports__LinkVariants = __webpack_exports__.CTN;
var __webpack_exports__ListSelect = __webpack_exports__.H27;
var __webpack_exports__ListSelectOption = __webpack_exports__.fmD;
var __webpack_exports__ListSelectOptionComponent = __webpack_exports__.IBy;
var __webpack_exports__LiveMessage = __webpack_exports__.xbP;
var __webpack_exports__Lock = __webpack_exports__.HEZ;
var __webpack_exports__Logo = __webpack_exports__.TRl;
var __webpack_exports__LogoModes = __webpack_exports__.MvK;
var __webpack_exports__Mail = __webpack_exports__.Mh9;
var __webpack_exports__Minus = __webpack_exports__.WF_;
var __webpack_exports__Modal = __webpack_exports__.u_l;
var __webpack_exports__Modes = __webpack_exports__.nlv;
var __webpack_exports__Navigation = __webpack_exports__.W_F;
var __webpack_exports__PREFERS_REDUCED_MOTION_QUERY = __webpack_exports__.Wti;
var __webpack_exports__Parcel = __webpack_exports__.SSe;
var __webpack_exports__Play = __webpack_exports__.shV;
var __webpack_exports__Plus = __webpack_exports__.v37;
var __webpack_exports__Radio = __webpack_exports__.Y8K;
var __webpack_exports__RadioView = __webpack_exports__.gFx;
var __webpack_exports__Refund = __webpack_exports__.NOA;
var __webpack_exports__ResponsiveText = __webpack_exports__.lzW;
var __webpack_exports__ResponsiveTextVariants = __webpack_exports__.MiT;
var __webpack_exports__RichSelector = __webpack_exports__.ahL;
var __webpack_exports__RichSelectorGroup = __webpack_exports__.aBh;
var __webpack_exports__Scale = __webpack_exports__.Ciz;
var __webpack_exports__ScrollSnap = __webpack_exports__.a_G;
var __webpack_exports__ScrollSnapComponent = __webpack_exports__.Xwg;
var __webpack_exports__Select = __webpack_exports__.PhF;
var __webpack_exports__Selector = __webpack_exports__.Qfc;
var __webpack_exports__SelectorGroup = __webpack_exports__.pdy;
var __webpack_exports__SlideShow = __webpack_exports__.n19;
var __webpack_exports__Square = __webpack_exports__.bK0;
var __webpack_exports__SquareFill = __webpack_exports__.uX1;
var __webpack_exports__StandOnScale = __webpack_exports__.Ex;
var __webpack_exports__Star = __webpack_exports__.Uxw;
var __webpack_exports__StripeElement = __webpack_exports__.GPN;
var __webpack_exports__StripeProvider = __webpack_exports__.vwl;
var __webpack_exports__Text = __webpack_exports__.xvT;
var __webpack_exports__TextArea = __webpack_exports__.Kx8;
var __webpack_exports__TextAreaComponent = __webpack_exports__.U5e;
var __webpack_exports__TextV2 = __webpack_exports__._T;
var __webpack_exports__TextV2Variants = __webpack_exports__.i$g;
var __webpack_exports__TextVariants = __webpack_exports__.qOL;
var __webpack_exports__ToastProvider = __webpack_exports__.VWW;
var __webpack_exports__ToastRenderer = __webpack_exports__.Tyr;
var __webpack_exports__Tooltip = __webpack_exports__.ua7;
var __webpack_exports__TooltipModes = __webpack_exports__.uvY;
var __webpack_exports__TooltipPositions = __webpack_exports__.asY;
var __webpack_exports__Truck = __webpack_exports__._DY;
var __webpack_exports__Twitter = __webpack_exports__.tLe;
var __webpack_exports__Types = __webpack_exports__.Yky;
var __webpack_exports__Vegetable = __webpack_exports__.orV;
var __webpack_exports__VerticalNavigation = __webpack_exports__.ORm;
var __webpack_exports__article = __webpack_exports__.Y24;
var __webpack_exports__articleStyles = __webpack_exports__.gKo;
var __webpack_exports__body = __webpack_exports__.d1Q;
var __webpack_exports__bodyStyles = __webpack_exports__.EtW;
var __webpack_exports__browserOnly = __webpack_exports__.KmX;
var __webpack_exports__getButtonDesign = __webpack_exports__.qJJ;
var __webpack_exports__getCheckboxDesign = __webpack_exports__.X2c;
var __webpack_exports__getLineThroughDesign = __webpack_exports__.ri4;
var __webpack_exports__getLinkDesign = __webpack_exports__.UEi;
var __webpack_exports__getModalDesign = __webpack_exports__.ilL;
var __webpack_exports__getNonWaveDesign = __webpack_exports__.tJS;
var __webpack_exports__getPreferredScrollBehavior = __webpack_exports__.QqB;
var __webpack_exports__getRadioDesign = __webpack_exports__.VUO;
var __webpack_exports__getWaveDesign = __webpack_exports__.GlN;
var __webpack_exports__heading = __webpack_exports__.nPj;
var __webpack_exports__headingStyles = __webpack_exports__.$BV;
var __webpack_exports__isAnchorLink = __webpack_exports__.E2g;
var __webpack_exports__polyfillSmoothScroll = __webpack_exports__.b_w;
var __webpack_exports__useCreateToken = __webpack_exports__.RS$;
var __webpack_exports__useElementState = __webpack_exports__.XDk;
var __webpack_exports__useElements = __webpack_exports__.lqB;
var __webpack_exports__useHtmlElement = __webpack_exports__.pJl;
var __webpack_exports__useIntersection = __webpack_exports__.sxs;
var __webpack_exports__useIsomorphicLayoutEffect = __webpack_exports__.LIc;
var __webpack_exports__useLightboxControl = __webpack_exports__.DlW;
var __webpack_exports__useSafeOptions = __webpack_exports__.OyM;
var __webpack_exports__useSlideShow = __webpack_exports__.LAe;
var __webpack_exports__useStripe = __webpack_exports__.MDn;
var __webpack_exports__useToast = __webpack_exports__.pmc;
var __webpack_exports__useToastDialog = __webpack_exports__.cJl;
var __webpack_exports__withRef = __webpack_exports__.Oer;
var __webpack_exports__withTFDProps = __webpack_exports__.pum;
export { __webpack_exports__ANIMATION_DURATION as ANIMATION_DURATION, __webpack_exports__AppBar as AppBar, __webpack_exports__AriaLiveAttributes as AriaLiveAttributes, __webpack_exports__Arrow as Arrow, __webpack_exports__ArticleColors as ArticleColors, __webpack_exports__ArticleFontWeights as ArticleFontWeights, __webpack_exports__ArticleSizeVariants as ArticleSizeVariants, __webpack_exports__ArticleSizes as ArticleSizes, __webpack_exports__ArticleStyles as ArticleStyles, __webpack_exports__ArticleTextVariants as ArticleTextVariants, __webpack_exports__ArticleWeights as ArticleWeights, __webpack_exports__AsyncModal as AsyncModal, __webpack_exports__Back as Back, __webpack_exports__Behavior as Behavior, __webpack_exports__Blob as Blob, __webpack_exports__BodyColors as BodyColors, __webpack_exports__BodyFontWeights as BodyFontWeights, __webpack_exports__BodySizeVariants as BodySizeVariants, __webpack_exports__BodySizes as BodySizes, __webpack_exports__BodyStyles as BodyStyles, __webpack_exports__BodyTextVariants as BodyTextVariants, __webpack_exports__BodyWeights as BodyWeights, __webpack_exports__Bolt as Bolt, __webpack_exports__BorderLabel as BorderLabel, __webpack_exports__BowlSteaming as BowlSteaming, __webpack_exports__Breadcrumbs as Breadcrumbs, __webpack_exports__Button as Button, __webpack_exports__ButtonVariants as ButtonVariants, __webpack_exports__Calendar as Calendar, __webpack_exports__Card as Card, __webpack_exports__CardCvc as CardCvc, __webpack_exports__CardExpiration as CardExpiration, __webpack_exports__CardHTMLElements as CardHTMLElements, __webpack_exports__CardNumber as CardNumber, __webpack_exports__Caret as Caret, __webpack_exports__Carousel as Carousel, __webpack_exports__CarouselItem as CarouselItem, __webpack_exports__Carrot as Carrot, __webpack_exports__Check as Check, __webpack_exports__CheckCircle as CheckCircle, __webpack_exports__Checkbox as Checkbox, __webpack_exports__CheckboxView as CheckboxView, __webpack_exports__Chevron as Chevron, __webpack_exports__Circle as Circle, __webpack_exports__CircleAlert as CircleAlert, __webpack_exports__CircleCross as CircleCross, __webpack_exports__CircleFill as CircleFill, __webpack_exports__CircleMinus as CircleMinus, __webpack_exports__CirclePlus as CirclePlus, __webpack_exports__Clipboard as Clipboard, __webpack_exports__Clock as Clock, __webpack_exports__Close as Close, __webpack_exports__CloseButton as CloseButton, __webpack_exports__ContentReveal as ContentReveal, __webpack_exports__ContentRevealAnimations as ContentRevealAnimations, __webpack_exports__ContentWidth as ContentWidth, __webpack_exports__ContentWidthAlignment as ContentWidthAlignment, __webpack_exports__ContentWidthStyles as ContentWidthStyles, __webpack_exports__Divider as Divider, __webpack_exports__DividerColors as DividerColors, __webpack_exports__DividerOrientations as DividerOrientations, __webpack_exports__Doctor as Doctor, __webpack_exports__DogFood as DogFood, __webpack_exports__ESCAPE as ESCAPE, __webpack_exports__ElementStates as ElementStates, __webpack_exports__ElementsProvider as ElementsProvider, __webpack_exports__Facebook as Facebook, __webpack_exports__ForkSpoon as ForkSpoon, __webpack_exports__FormControl as FormControl, __webpack_exports__Gallery as Gallery, __webpack_exports__GalleryModes as GalleryModes, __webpack_exports__GridContainer as GridContainer, __webpack_exports__GridContainerBreakpoints as GridContainerBreakpoints, __webpack_exports__GridContainerHTMLElements as GridContainerHTMLElements, __webpack_exports__HeadingColors as HeadingColors, __webpack_exports__HeadingFontWeights as HeadingFontWeights, __webpack_exports__HeadingSizeVariants as HeadingSizeVariants, __webpack_exports__HeadingSizes as HeadingSizes, __webpack_exports__HeadingStyles as HeadingStyles, __webpack_exports__HeadingTextVariants as HeadingTextVariants, __webpack_exports__HeadingWeights as HeadingWeights, __webpack_exports__Heart as Heart, __webpack_exports__HeartOutline as HeartOutline, __webpack_exports__Hero as Hero, __webpack_exports__HoImport as HoImport, __webpack_exports__HorizontalNavigation as HorizontalNavigation, __webpack_exports__HorizontalNavigationItem as HorizontalNavigationItem, __webpack_exports__IconPropTypes as IconPropTypes, __webpack_exports__IndexButton as IndexButton, __webpack_exports__Information as Information, __webpack_exports__Input as Input, __webpack_exports__InputComponent as InputComponent, __webpack_exports__LabeledSelector as LabeledSelector, __webpack_exports__Leaf as Leaf, __webpack_exports__Lightbox as Lightbox, __webpack_exports__Link as Link, __webpack_exports__LinkModes as LinkModes, __webpack_exports__LinkVariants as LinkVariants, __webpack_exports__ListSelect as ListSelect, __webpack_exports__ListSelectOption as ListSelectOption, __webpack_exports__ListSelectOptionComponent as ListSelectOptionComponent, __webpack_exports__LiveMessage as LiveMessage, __webpack_exports__Lock as Lock, __webpack_exports__Logo as Logo, __webpack_exports__LogoModes as LogoModes, __webpack_exports__Mail as Mail, __webpack_exports__Minus as Minus, __webpack_exports__Modal as Modal, __webpack_exports__Modes as Modes, __webpack_exports__Navigation as Navigation, __webpack_exports__PREFERS_REDUCED_MOTION_QUERY as PREFERS_REDUCED_MOTION_QUERY, __webpack_exports__Parcel as Parcel, __webpack_exports__Play as Play, __webpack_exports__Plus as Plus, __webpack_exports__Radio as Radio, __webpack_exports__RadioView as RadioView, __webpack_exports__Refund as Refund, __webpack_exports__ResponsiveText as ResponsiveText, __webpack_exports__ResponsiveTextVariants as ResponsiveTextVariants, __webpack_exports__RichSelector as RichSelector, __webpack_exports__RichSelectorGroup as RichSelectorGroup, __webpack_exports__Scale as Scale, __webpack_exports__ScrollSnap as ScrollSnap, __webpack_exports__ScrollSnapComponent as ScrollSnapComponent, __webpack_exports__Select as Select, __webpack_exports__Selector as Selector, __webpack_exports__SelectorGroup as SelectorGroup, __webpack_exports__SlideShow as SlideShow, __webpack_exports__Square as Square, __webpack_exports__SquareFill as SquareFill, __webpack_exports__StandOnScale as StandOnScale, __webpack_exports__Star as Star, __webpack_exports__StripeElement as StripeElement, __webpack_exports__StripeProvider as StripeProvider, __webpack_exports__Text as Text, __webpack_exports__TextArea as TextArea, __webpack_exports__TextAreaComponent as TextAreaComponent, __webpack_exports__TextV2 as TextV2, __webpack_exports__TextV2Variants as TextV2Variants, __webpack_exports__TextVariants as TextVariants, __webpack_exports__ToastProvider as ToastProvider, __webpack_exports__ToastRenderer as ToastRenderer, __webpack_exports__Tooltip as Tooltip, __webpack_exports__TooltipModes as TooltipModes, __webpack_exports__TooltipPositions as TooltipPositions, __webpack_exports__Truck as Truck, __webpack_exports__Twitter as Twitter, __webpack_exports__Types as Types, __webpack_exports__Vegetable as Vegetable, __webpack_exports__VerticalNavigation as VerticalNavigation, __webpack_exports__article as article, __webpack_exports__articleStyles as articleStyles, __webpack_exports__body as body, __webpack_exports__bodyStyles as bodyStyles, __webpack_exports__browserOnly as browserOnly, __webpack_exports__getButtonDesign as getButtonDesign, __webpack_exports__getCheckboxDesign as getCheckboxDesign, __webpack_exports__getLineThroughDesign as getLineThroughDesign, __webpack_exports__getLinkDesign as getLinkDesign, __webpack_exports__getModalDesign as getModalDesign, __webpack_exports__getNonWaveDesign as getNonWaveDesign, __webpack_exports__getPreferredScrollBehavior as getPreferredScrollBehavior, __webpack_exports__getRadioDesign as getRadioDesign, __webpack_exports__getWaveDesign as getWaveDesign, __webpack_exports__heading as heading, __webpack_exports__headingStyles as headingStyles, __webpack_exports__isAnchorLink as isAnchorLink, __webpack_exports__polyfillSmoothScroll as polyfillSmoothScroll, __webpack_exports__useCreateToken as useCreateToken, __webpack_exports__useElementState as useElementState, __webpack_exports__useElements as useElements, __webpack_exports__useHtmlElement as useHtmlElement, __webpack_exports__useIntersection as useIntersection, __webpack_exports__useIsomorphicLayoutEffect as useIsomorphicLayoutEffect, __webpack_exports__useLightboxControl as useLightboxControl, __webpack_exports__useSafeOptions as useSafeOptions, __webpack_exports__useSlideShow as useSlideShow, __webpack_exports__useStripe as useStripe, __webpack_exports__useToast as useToast, __webpack_exports__useToastDialog as useToastDialog, __webpack_exports__withRef as withRef, __webpack_exports__withTFDProps as withTFDProps };

//# sourceMappingURL=index.js.map